var li = Object.defineProperty;
var sa = (r) => {
  throw TypeError(r);
};
var ci = (r, i, e) => i in r ? li(r, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[i] = e;
var t = (r, i, e) => ci(r, typeof i != "symbol" ? i + "" : i, e), vt = (r, i, e) => i.has(r) || sa("Cannot " + e);
var o = (r, i, e) => (vt(r, i, "read from private field"), e ? e.call(r) : i.get(r)), T = (r, i, e) => i.has(r) ? sa("Cannot add the same private member more than once") : i instanceof WeakSet ? i.add(r) : i.set(r, e), E = (r, i, e, n) => (vt(r, i, "write to private field"), n ? n.call(r, e) : i.set(r, e), e), mt = (r, i, e) => (vt(r, i, "access private method"), e);
import { createDecoder as Hn, createEncoder as ui } from "@waku/message-encryption/symmetric";
import { Message as l, proto3 as a, protoInt64 as d } from "@bufbuild/protobuf";
import "./encode-url-data.js";
import { utf8ToBytes as Et, bytesToHex as Yn, toHex as Wa, hexToBytes as Pt, concatBytes as Wr } from "ethereum-cryptography/utils";
import { keccak256 as ut } from "ethereum-cryptography/keccak";
import { bootstrap as qa } from "@libp2p/bootstrap";
import { createLightNode as _a, waitForRemotePeer as Va } from "@waku/sdk";
import * as za from "ethereum-cryptography/secp256k1";
import { Point as Qa, recoverPublicKey as mi, sign as di, verify as hi, utils as Ei, getPublicKey as Ti } from "ethereum-cryptography/secp256k1";
import { createChannelURLWithChatKey as fi, createUserURLWithChatKey as ja, createCommunityURLWithChatKey as Si } from "./create-url.js";
import { base58btc as Xa } from "multiformats/bases/base58";
import { varint as yi } from "multiformats";
import { ethers as Kn } from "ethers";
var xn;
(function(r) {
  r.Relay = "relay", r.Store = "store", r.LightPush = "lightpush", r.Filter = "filter";
})(xn || (xn = {}));
var oa;
(function(r) {
  r.GENERIC_FAIL = "Generic error", r.ENCODE_FAILED = "Failed to encode", r.DECODE_FAILED = "Failed to decode", r.EMPTY_PAYLOAD = "Payload is empty", r.SIZE_TOO_BIG = "Size is too big", r.TOPIC_NOT_CONFIGURED = "Topic not configured", r.NO_PEER_AVAILABLE = "No peer available", r.REMOTE_PEER_FAULT = "Remote peer fault", r.REMOTE_PEER_REJECTED = "Remote peer rejected";
})(oa || (oa = {}));
var xt;
(function(r) {
  r.BACKWARD = "backward", r.FORWARD = "forward";
})(xt || (xt = {}));
var la;
(function(r) {
  r.BOOTSTRAP = "bootstrap", r.PEER_EXCHANGE = "peer-exchange";
})(la || (la = {}));
var ca;
(function(r) {
  r.PEER_DISCOVERY_BOOTSTRAP = "peer:discovery:bootstrap", r.PEER_DISCOVERY_PEER_EXCHANGE = "peer:discovery:peer-exchange", r.PEER_CONNECT_BOOTSTRAP = "peer:connected:bootstrap", r.PEER_CONNECT_PEER_EXCHANGE = "peer:connected:peer-exchange";
})(ca || (ca = {}));
var ua;
(function(r) {
  r.CONNECTION_STATUS = "waku:connection";
})(ua || (ua = {}));
function Ni(r) {
  return /^\p{Emoji_Presentation}+$/gu.test(r);
}
const b = class b extends l {
  constructor(e) {
    super();
    /**
     * Signature of the payload field
     *
     * @generated from field: bytes signature = 1;
     */
    t(this, "signature", new Uint8Array(0));
    /**
     * This is the encoded protobuf of the application level message, i.e ChatMessage
     *
     * @generated from field: bytes payload = 2;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * The type of protobuf message sent
     *
     * @generated from field: ApplicationMetadataMessage.Type type = 3;
     */
    t(this, "type", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new b().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new b().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new b().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(b, e, n);
  }
};
t(b, "runtime", a), t(b, "typeName", "ApplicationMetadataMessage"), t(b, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "signature",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "type",
    kind: "enum",
    T: a.getEnumType(I)
  }
]));
let et = b;
var I = /* @__PURE__ */ ((r) => (r[r.UNKNOWN = 0] = "UNKNOWN", r[r.CHAT_MESSAGE = 1] = "CHAT_MESSAGE", r[r.CONTACT_UPDATE = 2] = "CONTACT_UPDATE", r[r.MEMBERSHIP_UPDATE_MESSAGE = 3] = "MEMBERSHIP_UPDATE_MESSAGE", r[r.SYNC_PAIR_INSTALLATION = 4] = "SYNC_PAIR_INSTALLATION", r[r.DEPRECATED_SYNC_INSTALLATION = 5] = "DEPRECATED_SYNC_INSTALLATION", r[r.REQUEST_ADDRESS_FOR_TRANSACTION = 6] = "REQUEST_ADDRESS_FOR_TRANSACTION", r[r.ACCEPT_REQUEST_ADDRESS_FOR_TRANSACTION = 7] = "ACCEPT_REQUEST_ADDRESS_FOR_TRANSACTION", r[r.DECLINE_REQUEST_ADDRESS_FOR_TRANSACTION = 8] = "DECLINE_REQUEST_ADDRESS_FOR_TRANSACTION", r[r.REQUEST_TRANSACTION = 9] = "REQUEST_TRANSACTION", r[r.SEND_TRANSACTION = 10] = "SEND_TRANSACTION", r[r.DECLINE_REQUEST_TRANSACTION = 11] = "DECLINE_REQUEST_TRANSACTION", r[r.SYNC_INSTALLATION_CONTACT_V2 = 12] = "SYNC_INSTALLATION_CONTACT_V2", r[r.SYNC_INSTALLATION_ACCOUNT = 13] = "SYNC_INSTALLATION_ACCOUNT", r[r.CONTACT_CODE_ADVERTISEMENT = 15] = "CONTACT_CODE_ADVERTISEMENT", r[r.PUSH_NOTIFICATION_REGISTRATION = 16] = "PUSH_NOTIFICATION_REGISTRATION", r[r.PUSH_NOTIFICATION_REGISTRATION_RESPONSE = 17] = "PUSH_NOTIFICATION_REGISTRATION_RESPONSE", r[r.PUSH_NOTIFICATION_QUERY = 18] = "PUSH_NOTIFICATION_QUERY", r[r.PUSH_NOTIFICATION_QUERY_RESPONSE = 19] = "PUSH_NOTIFICATION_QUERY_RESPONSE", r[r.PUSH_NOTIFICATION_REQUEST = 20] = "PUSH_NOTIFICATION_REQUEST", r[r.PUSH_NOTIFICATION_RESPONSE = 21] = "PUSH_NOTIFICATION_RESPONSE", r[r.EMOJI_REACTION = 22] = "EMOJI_REACTION", r[r.GROUP_CHAT_INVITATION = 23] = "GROUP_CHAT_INVITATION", r[r.CHAT_IDENTITY = 24] = "CHAT_IDENTITY", r[r.COMMUNITY_DESCRIPTION = 25] = "COMMUNITY_DESCRIPTION", r[r.COMMUNITY_INVITATION = 26] = "COMMUNITY_INVITATION", r[r.COMMUNITY_REQUEST_TO_JOIN = 27] = "COMMUNITY_REQUEST_TO_JOIN", r[r.PIN_MESSAGE = 28] = "PIN_MESSAGE", r[r.EDIT_MESSAGE = 29] = "EDIT_MESSAGE", r[r.STATUS_UPDATE = 30] = "STATUS_UPDATE", r[r.DELETE_MESSAGE = 31] = "DELETE_MESSAGE", r[r.SYNC_INSTALLATION_COMMUNITY = 32] = "SYNC_INSTALLATION_COMMUNITY", r[r.ANONYMOUS_METRIC_BATCH = 33] = "ANONYMOUS_METRIC_BATCH", r[r.SYNC_CHAT_REMOVED = 34] = "SYNC_CHAT_REMOVED", r[r.SYNC_CHAT_MESSAGES_READ = 35] = "SYNC_CHAT_MESSAGES_READ", r[r.BACKUP = 36] = "BACKUP", r[r.SYNC_ACTIVITY_CENTER_READ = 37] = "SYNC_ACTIVITY_CENTER_READ", r[r.SYNC_ACTIVITY_CENTER_ACCEPTED = 38] = "SYNC_ACTIVITY_CENTER_ACCEPTED", r[r.SYNC_ACTIVITY_CENTER_DISMISSED = 39] = "SYNC_ACTIVITY_CENTER_DISMISSED", r[r.SYNC_BOOKMARK = 40] = "SYNC_BOOKMARK", r[r.SYNC_CLEAR_HISTORY = 41] = "SYNC_CLEAR_HISTORY", r[r.SYNC_SETTING = 42] = "SYNC_SETTING", r[r.COMMUNITY_MESSAGE_ARCHIVE_MAGNETLINK = 43] = "COMMUNITY_MESSAGE_ARCHIVE_MAGNETLINK", r[r.SYNC_PROFILE_PICTURES = 44] = "SYNC_PROFILE_PICTURES", r[r.SYNC_ACCOUNT = 45] = "SYNC_ACCOUNT", r[r.ACCEPT_CONTACT_REQUEST = 46] = "ACCEPT_CONTACT_REQUEST", r[r.RETRACT_CONTACT_REQUEST = 47] = "RETRACT_CONTACT_REQUEST", r[r.COMMUNITY_REQUEST_TO_JOIN_RESPONSE = 48] = "COMMUNITY_REQUEST_TO_JOIN_RESPONSE", r[r.SYNC_COMMUNITY_SETTINGS = 49] = "SYNC_COMMUNITY_SETTINGS", r[r.REQUEST_CONTACT_VERIFICATION = 50] = "REQUEST_CONTACT_VERIFICATION", r[r.ACCEPT_CONTACT_VERIFICATION = 51] = "ACCEPT_CONTACT_VERIFICATION", r[r.DECLINE_CONTACT_VERIFICATION = 52] = "DECLINE_CONTACT_VERIFICATION", r[r.SYNC_TRUSTED_USER = 53] = "SYNC_TRUSTED_USER", r[r.SYNC_VERIFICATION_REQUEST = 54] = "SYNC_VERIFICATION_REQUEST", r[r.SYNC_CONTACT_REQUEST_DECISION = 56] = "SYNC_CONTACT_REQUEST_DECISION", r[r.COMMUNITY_REQUEST_TO_LEAVE = 57] = "COMMUNITY_REQUEST_TO_LEAVE", r[r.SYNC_DELETE_FOR_ME_MESSAGE = 58] = "SYNC_DELETE_FOR_ME_MESSAGE", r[r.SYNC_SAVED_ADDRESS = 59] = "SYNC_SAVED_ADDRESS", r[r.COMMUNITY_CANCEL_REQUEST_TO_JOIN = 60] = "COMMUNITY_CANCEL_REQUEST_TO_JOIN", r[r.CANCEL_CONTACT_VERIFICATION = 61] = "CANCEL_CONTACT_VERIFICATION", r[r.SYNC_KEYPAIR = 62] = "SYNC_KEYPAIR", r[r.SYNC_SOCIAL_LINKS = 63] = "SYNC_SOCIAL_LINKS", r[r.SYNC_ENS_USERNAME_DETAIL = 64] = "SYNC_ENS_USERNAME_DETAIL", r[r.COMMUNITY_EVENTS_MESSAGE = 67] = "COMMUNITY_EVENTS_MESSAGE", r[r.COMMUNITY_EDIT_SHARED_ADDRESSES = 68] = "COMMUNITY_EDIT_SHARED_ADDRESSES", r[r.SYNC_ACCOUNT_CUSTOMIZATION_COLOR = 69] = "SYNC_ACCOUNT_CUSTOMIZATION_COLOR", r[r.SYNC_ACCOUNTS_POSITIONS = 70] = "SYNC_ACCOUNTS_POSITIONS", r[r.COMMUNITY_EVENTS_MESSAGE_REJECTED = 71] = "COMMUNITY_EVENTS_MESSAGE_REJECTED", r[r.COMMUNITY_PRIVILEGED_USER_SYNC_MESSAGE = 72] = "COMMUNITY_PRIVILEGED_USER_SYNC_MESSAGE", r[r.COMMUNITY_SHARD_KEY = 73] = "COMMUNITY_SHARD_KEY", r[r.SYNC_CHAT = 74] = "SYNC_CHAT", r[r.SYNC_ACTIVITY_CENTER_DELETED = 75] = "SYNC_ACTIVITY_CENTER_DELETED", r[r.SYNC_ACTIVITY_CENTER_UNREAD = 76] = "SYNC_ACTIVITY_CENTER_UNREAD", r[r.SYNC_ACTIVITY_CENTER_COMMUNITY_REQUEST_DECISION = 77] = "SYNC_ACTIVITY_CENTER_COMMUNITY_REQUEST_DECISION", r[r.SYNC_TOKEN_PREFERENCES = 78] = "SYNC_TOKEN_PREFERENCES", r[r.COMMUNITY_PUBLIC_SHARD_INFO = 79] = "COMMUNITY_PUBLIC_SHARD_INFO", r[r.SYNC_COLLECTIBLE_PREFERENCES = 80] = "SYNC_COLLECTIBLE_PREFERENCES", r[r.COMMUNITY_USER_KICKED = 81] = "COMMUNITY_USER_KICKED", r[r.SYNC_PROFILE_SHOWCASE_PREFERENCES = 82] = "SYNC_PROFILE_SHOWCASE_PREFERENCES", r[r.COMMUNITY_PUBLIC_STORENODES_INFO = 83] = "COMMUNITY_PUBLIC_STORENODES_INFO", r[r.COMMUNITY_REEVALUATE_PERMISSIONS_REQUEST = 84] = "COMMUNITY_REEVALUATE_PERMISSIONS_REQUEST", r))(I || {});
a.util.setEnumType(
  I,
  "ApplicationMetadataMessage.Type",
  [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CHAT_MESSAGE" },
    { no: 2, name: "CONTACT_UPDATE" },
    { no: 3, name: "MEMBERSHIP_UPDATE_MESSAGE" },
    { no: 4, name: "SYNC_PAIR_INSTALLATION" },
    { no: 5, name: "DEPRECATED_SYNC_INSTALLATION" },
    { no: 6, name: "REQUEST_ADDRESS_FOR_TRANSACTION" },
    { no: 7, name: "ACCEPT_REQUEST_ADDRESS_FOR_TRANSACTION" },
    { no: 8, name: "DECLINE_REQUEST_ADDRESS_FOR_TRANSACTION" },
    { no: 9, name: "REQUEST_TRANSACTION" },
    { no: 10, name: "SEND_TRANSACTION" },
    { no: 11, name: "DECLINE_REQUEST_TRANSACTION" },
    { no: 12, name: "SYNC_INSTALLATION_CONTACT_V2" },
    { no: 13, name: "SYNC_INSTALLATION_ACCOUNT" },
    { no: 15, name: "CONTACT_CODE_ADVERTISEMENT" },
    { no: 16, name: "PUSH_NOTIFICATION_REGISTRATION" },
    { no: 17, name: "PUSH_NOTIFICATION_REGISTRATION_RESPONSE" },
    { no: 18, name: "PUSH_NOTIFICATION_QUERY" },
    { no: 19, name: "PUSH_NOTIFICATION_QUERY_RESPONSE" },
    { no: 20, name: "PUSH_NOTIFICATION_REQUEST" },
    { no: 21, name: "PUSH_NOTIFICATION_RESPONSE" },
    { no: 22, name: "EMOJI_REACTION" },
    { no: 23, name: "GROUP_CHAT_INVITATION" },
    { no: 24, name: "CHAT_IDENTITY" },
    { no: 25, name: "COMMUNITY_DESCRIPTION" },
    { no: 26, name: "COMMUNITY_INVITATION" },
    { no: 27, name: "COMMUNITY_REQUEST_TO_JOIN" },
    { no: 28, name: "PIN_MESSAGE" },
    { no: 29, name: "EDIT_MESSAGE" },
    { no: 30, name: "STATUS_UPDATE" },
    { no: 31, name: "DELETE_MESSAGE" },
    { no: 32, name: "SYNC_INSTALLATION_COMMUNITY" },
    { no: 33, name: "ANONYMOUS_METRIC_BATCH" },
    { no: 34, name: "SYNC_CHAT_REMOVED" },
    { no: 35, name: "SYNC_CHAT_MESSAGES_READ" },
    { no: 36, name: "BACKUP" },
    { no: 37, name: "SYNC_ACTIVITY_CENTER_READ" },
    { no: 38, name: "SYNC_ACTIVITY_CENTER_ACCEPTED" },
    { no: 39, name: "SYNC_ACTIVITY_CENTER_DISMISSED" },
    { no: 40, name: "SYNC_BOOKMARK" },
    { no: 41, name: "SYNC_CLEAR_HISTORY" },
    { no: 42, name: "SYNC_SETTING" },
    { no: 43, name: "COMMUNITY_MESSAGE_ARCHIVE_MAGNETLINK" },
    { no: 44, name: "SYNC_PROFILE_PICTURES" },
    { no: 45, name: "SYNC_ACCOUNT" },
    { no: 46, name: "ACCEPT_CONTACT_REQUEST" },
    { no: 47, name: "RETRACT_CONTACT_REQUEST" },
    { no: 48, name: "COMMUNITY_REQUEST_TO_JOIN_RESPONSE" },
    { no: 49, name: "SYNC_COMMUNITY_SETTINGS" },
    { no: 50, name: "REQUEST_CONTACT_VERIFICATION" },
    { no: 51, name: "ACCEPT_CONTACT_VERIFICATION" },
    { no: 52, name: "DECLINE_CONTACT_VERIFICATION" },
    { no: 53, name: "SYNC_TRUSTED_USER" },
    { no: 54, name: "SYNC_VERIFICATION_REQUEST" },
    { no: 56, name: "SYNC_CONTACT_REQUEST_DECISION" },
    { no: 57, name: "COMMUNITY_REQUEST_TO_LEAVE" },
    { no: 58, name: "SYNC_DELETE_FOR_ME_MESSAGE" },
    { no: 59, name: "SYNC_SAVED_ADDRESS" },
    { no: 60, name: "COMMUNITY_CANCEL_REQUEST_TO_JOIN" },
    { no: 61, name: "CANCEL_CONTACT_VERIFICATION" },
    { no: 62, name: "SYNC_KEYPAIR" },
    { no: 63, name: "SYNC_SOCIAL_LINKS" },
    { no: 64, name: "SYNC_ENS_USERNAME_DETAIL" },
    { no: 67, name: "COMMUNITY_EVENTS_MESSAGE" },
    { no: 68, name: "COMMUNITY_EDIT_SHARED_ADDRESSES" },
    { no: 69, name: "SYNC_ACCOUNT_CUSTOMIZATION_COLOR" },
    { no: 70, name: "SYNC_ACCOUNTS_POSITIONS" },
    { no: 71, name: "COMMUNITY_EVENTS_MESSAGE_REJECTED" },
    { no: 72, name: "COMMUNITY_PRIVILEGED_USER_SYNC_MESSAGE" },
    { no: 73, name: "COMMUNITY_SHARD_KEY" },
    { no: 74, name: "SYNC_CHAT" },
    { no: 75, name: "SYNC_ACTIVITY_CENTER_DELETED" },
    { no: 76, name: "SYNC_ACTIVITY_CENTER_UNREAD" },
    { no: 77, name: "SYNC_ACTIVITY_CENTER_COMMUNITY_REQUEST_DECISION" },
    { no: 78, name: "SYNC_TOKEN_PREFERENCES" },
    { no: 79, name: "COMMUNITY_PUBLIC_SHARD_INFO" },
    { no: 80, name: "SYNC_COLLECTIBLE_PREFERENCES" },
    { no: 81, name: "COMMUNITY_USER_KICKED" },
    { no: 82, name: "SYNC_PROFILE_SHOWCASE_PREFERENCES" },
    { no: 83, name: "COMMUNITY_PUBLIC_STORENODES_INFO" },
    { no: 84, name: "COMMUNITY_REEVALUATE_PERMISSIONS_REQUEST" }
  ]
);
var S = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_MESSAGE_TYPE = 0] = "UNKNOWN_MESSAGE_TYPE", r[r.ONE_TO_ONE = 1] = "ONE_TO_ONE", r[r.PUBLIC_GROUP = 2] = "PUBLIC_GROUP", r[r.PRIVATE_GROUP = 3] = "PRIVATE_GROUP", r[r.SYSTEM_MESSAGE_PRIVATE_GROUP = 4] = "SYSTEM_MESSAGE_PRIVATE_GROUP", r[r.COMMUNITY_CHAT = 5] = "COMMUNITY_CHAT", r[r.SYSTEM_MESSAGE_GAP = 6] = "SYSTEM_MESSAGE_GAP", r))(S || {});
a.util.setEnumType(S, "MessageType", [
  { no: 0, name: "UNKNOWN_MESSAGE_TYPE" },
  { no: 1, name: "ONE_TO_ONE" },
  { no: 2, name: "PUBLIC_GROUP" },
  { no: 3, name: "PRIVATE_GROUP" },
  { no: 4, name: "SYSTEM_MESSAGE_PRIVATE_GROUP" },
  { no: 5, name: "COMMUNITY_CHAT" },
  { no: 6, name: "SYSTEM_MESSAGE_GAP" }
]);
var jn = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_IMAGE_FORMAT = 0] = "UNKNOWN_IMAGE_FORMAT", r[r.PNG = 1] = "PNG", r[r.JPEG = 2] = "JPEG", r[r.WEBP = 3] = "WEBP", r[r.GIF = 4] = "GIF", r))(jn || {});
a.util.setEnumType(jn, "ImageFormat", [
  { no: 0, name: "UNKNOWN_IMAGE_FORMAT" },
  { no: 1, name: "PNG" },
  { no: 2, name: "JPEG" },
  { no: 3, name: "WEBP" },
  { no: 4, name: "GIF" }
]);
var Xn = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_TOKEN_TYPE = 0] = "UNKNOWN_TOKEN_TYPE", r[r.ERC20 = 1] = "ERC20", r[r.ERC721 = 2] = "ERC721", r[r.ENS = 3] = "ENS", r))(Xn || {});
a.util.setEnumType(Xn, "CommunityTokenType", [
  { no: 0, name: "UNKNOWN_TOKEN_TYPE" },
  { no: 1, name: "ERC20" },
  { no: 2, name: "ERC721" },
  { no: 3, name: "ENS" }
]);
const B = class B extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 local_clock = 1;
     */
    t(this, "localClock", d.zero);
    /**
     * @generated from field: uint64 local_state = 2;
     */
    t(this, "localState", d.zero);
    /**
     * @generated from field: uint64 remote_clock = 3;
     */
    t(this, "remoteClock", d.zero);
    /**
     * @generated from field: uint64 remote_state = 4;
     */
    t(this, "remoteState", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new B().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new B().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new B().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(B, e, n);
  }
};
t(B, "runtime", a), t(B, "typeName", "ContactRequestPropagatedState"), t(B, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "local_clock",
    kind: "scalar",
    T: 4
  },
  {
    no: 2,
    name: "local_state",
    kind: "scalar",
    T: 4
  },
  {
    no: 3,
    name: "remote_clock",
    kind: "scalar",
    T: 4
  },
  {
    no: 4,
    name: "remote_state",
    kind: "scalar",
    T: 4
  }
]));
let Tt = B;
const U = class U extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string ens_name = 2;
     */
    t(this, "ensName", "");
    /**
     * @generated from field: string profile_image = 3;
     */
    t(this, "profileImage", "");
    /**
     * @generated from field: string display_name = 4;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: uint64 contact_request_clock = 5;
     */
    t(this, "contactRequestClock", d.zero);
    /**
     * @generated from field: ContactRequestPropagatedState contact_request_propagated_state = 6;
     */
    t(this, "contactRequestPropagatedState");
    /**
     * @generated from field: string public_key = 7;
     */
    t(this, "publicKey", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new U().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new U().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new U().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(U, e, n);
  }
};
t(U, "runtime", a), t(U, "typeName", "ContactUpdate"), t(U, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "ens_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "profile_image",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "contact_request_clock",
    kind: "scalar",
    T: 4
  },
  {
    no: 6,
    name: "contact_request_propagated_state",
    kind: "message",
    T: Tt
  },
  {
    no: 7,
    name: "public_key",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let ma = U;
const R = class R extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: uint64 clock = 2;
     */
    t(this, "clock", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new R().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new R().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new R().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(R, e, n);
  }
};
t(R, "runtime", a), t(R, "typeName", "AcceptContactRequest"), t(R, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let da = R;
const J = class J extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: uint64 clock = 2;
     */
    t(this, "clock", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new J().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new J().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new J().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(J, e, n);
  }
};
t(J, "runtime", a), t(J, "typeName", "RetractContactRequest"), t(J, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let ha = J;
const P = class P extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: int32 cluster = 1;
     */
    t(this, "cluster", 0);
    /**
     * @generated from field: int32 index = 2;
     */
    t(this, "index", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new P().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new P().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new P().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(P, e, n);
  }
};
t(P, "runtime", a), t(P, "typeName", "Shard"), t(P, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "cluster",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 2,
    name: "index",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]));
let nt = P;
const L = class L extends l {
  constructor(e) {
    super();
    /**
     * clock
     *
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * community ID
     *
     * @generated from field: bytes community_id = 2;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * shard information
     *
     * @generated from field: Shard shard = 3;
     */
    t(this, "shard");
    /**
     * if chainID > 0, the signer must be verified through the community contract
     *
     * @generated from field: uint64 chainId = 4;
     */
    t(this, "chainId", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new L().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new L().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new L().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(L, e, n);
  }
};
t(L, "runtime", a), t(L, "typeName", "PublicShardInfo"), t(L, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  { no: 3, name: "shard", kind: "message", T: nt },
  {
    no: 4,
    name: "chainId",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let Ea = L;
const D = class D extends l {
  constructor(e) {
    super();
    /**
     * Signature of the payload field
     *
     * @generated from field: bytes signature = 1;
     */
    t(this, "signature", new Uint8Array(0));
    /**
     * Marshaled PublicShardInfo
     *
     * @generated from field: bytes payload = 2;
     */
    t(this, "payload", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new D().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new D().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new D().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(D, e, n);
  }
};
t(D, "runtime", a), t(D, "typeName", "CommunityPublicShardInfo"), t(D, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "signature",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Ta = D;
const v = class v extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string hash = 1;
     */
    t(this, "hash", "");
    /**
     * @generated from field: int32 pack = 2;
     */
    t(this, "pack", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new v().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new v().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new v().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(v, e, n);
  }
};
t(v, "runtime", a), t(v, "typeName", "StickerMessage"), t(v, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "hash",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "pack",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]));
let Mt = v;
const F = class F extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes payload = 1;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * @generated from field: ImageFormat format = 2;
     */
    t(this, "format", jn.UNKNOWN_IMAGE_FORMAT);
    /**
     * @generated from field: string album_id = 3;
     */
    t(this, "albumId", "");
    /**
     * @generated from field: uint32 width = 4;
     */
    t(this, "width", 0);
    /**
     * @generated from field: uint32 height = 5;
     */
    t(this, "height", 0);
    /**
     * @generated from field: uint32 album_images_count = 6;
     */
    t(this, "albumImagesCount", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new F().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new F().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new F().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(F, e, n);
  }
};
t(F, "runtime", a), t(F, "typeName", "ImageMessage"), t(F, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  { no: 2, name: "format", kind: "enum", T: a.getEnumType(jn) },
  {
    no: 3,
    name: "album_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "width",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 5,
    name: "height",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 6,
    name: "album_images_count",
    kind: "scalar",
    T: 13
  }
]));
let Wt = F;
const G = class G extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes payload = 1;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * @generated from field: AudioMessage.AudioType type = 2;
     */
    t(this, "type", 0);
    /**
     * @generated from field: uint64 duration_ms = 3;
     */
    t(this, "durationMs", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new G().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new G().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new G().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(G, e, n);
  }
};
t(G, "runtime", a), t(G, "typeName", "AudioMessage"), t(G, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "type",
    kind: "enum",
    T: a.getEnumType(qr)
  },
  {
    no: 3,
    name: "duration_ms",
    kind: "scalar",
    T: 4
  }
]));
let qt = G;
var qr = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_AUDIO_TYPE = 0] = "UNKNOWN_AUDIO_TYPE", r[r.AAC = 1] = "AAC", r[r.AMR = 2] = "AMR", r))(qr || {});
a.util.setEnumType(qr, "AudioMessage.AudioType", [
  { no: 0, name: "UNKNOWN_AUDIO_TYPE" },
  { no: 1, name: "AAC" },
  { no: 2, name: "AMR" }
]);
const Y = class Y extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * Text of the message
     *
     * @generated from field: string text = 2;
     */
    t(this, "text", "");
    /**
     * @generated from field: string chat_id = 3;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: string message_id = 4;
     */
    t(this, "messageId", "");
    /**
     * Grant for community edit messages
     *
     * @generated from field: bytes grant = 5 [deprecated = true];
     * @deprecated
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * The type of message (public/one-to-one/private-group-chat)
     *
     * @generated from field: MessageType message_type = 6;
     */
    t(this, "messageType", S.UNKNOWN_MESSAGE_TYPE);
    /**
     * @generated from field: ChatMessage.ContentType content_type = 7;
     */
    t(this, "contentType", 0);
    /**
     * @generated from field: repeated UnfurledLink unfurled_links = 8;
     */
    t(this, "unfurledLinks", []);
    /**
     * @generated from field: UnfurledStatusLinks unfurled_status_links = 9;
     */
    t(this, "unfurledStatusLinks");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Y().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Y().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Y().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Y, e, n);
  }
};
t(Y, "runtime", a), t(Y, "typeName", "EditMessage"), t(Y, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "text",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "message_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 6,
    name: "message_type",
    kind: "enum",
    T: a.getEnumType(S)
  },
  {
    no: 7,
    name: "content_type",
    kind: "enum",
    T: a.getEnumType(Gn)
  },
  {
    no: 8,
    name: "unfurled_links",
    kind: "message",
    T: yt,
    repeated: !0
  },
  {
    no: 9,
    name: "unfurled_status_links",
    kind: "message",
    T: gt
  }
]));
let ft = Y;
const K = class K extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string chat_id = 2;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: string message_id = 3;
     */
    t(this, "messageId", "");
    /**
     * Grant for community delete messages
     *
     * @generated from field: bytes grant = 4 [deprecated = true];
     * @deprecated
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * The type of message (public/one-to-one/private-group-chat)
     *
     * @generated from field: MessageType message_type = 5;
     */
    t(this, "messageType", S.UNKNOWN_MESSAGE_TYPE);
    /**
     * @generated from field: string deleted_by = 6;
     */
    t(this, "deletedBy", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new K().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new K().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new K().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(K, e, n);
  }
};
t(K, "runtime", a), t(K, "typeName", "DeleteMessage"), t(K, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "message_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 5,
    name: "message_type",
    kind: "enum",
    T: a.getEnumType(S)
  },
  {
    no: 6,
    name: "deleted_by",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let St = K;
const H = class H extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string message_id = 2;
     */
    t(this, "messageId", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new H().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new H().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new H().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(H, e, n);
  }
};
t(H, "runtime", a), t(H, "typeName", "SyncDeleteForMeMessage"), t(H, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "message_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let fa = H;
const x = class x extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: string type = 2;
     */
    t(this, "type", "");
    /**
     * @generated from field: string timestamp = 3;
     */
    t(this, "timestamp", "");
    /**
     * @generated from field: string timestampEdited = 4;
     */
    t(this, "timestampEdited", "");
    /**
     * @generated from field: string content = 5;
     */
    t(this, "content", "");
    /**
     * @generated from field: DiscordMessageAuthor author = 6;
     */
    t(this, "author");
    /**
     * @generated from field: DiscordMessageReference reference = 7;
     */
    t(this, "reference");
    /**
     * @generated from field: repeated DiscordMessageAttachment attachments = 8;
     */
    t(this, "attachments", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new x().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new x().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new x().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(x, e, n);
  }
};
t(x, "runtime", a), t(x, "typeName", "DiscordMessage"), t(x, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "type",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "timestamp",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "timestampEdited",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "content",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 6, name: "author", kind: "message", T: Vt },
  { no: 7, name: "reference", kind: "message", T: zt },
  {
    no: 8,
    name: "attachments",
    kind: "message",
    T: Qt,
    repeated: !0
  }
]));
let _t = x;
const M = class M extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: string name = 2;
     */
    t(this, "name", "");
    /**
     * @generated from field: string discriminator = 3;
     */
    t(this, "discriminator", "");
    /**
     * @generated from field: string nickname = 4;
     */
    t(this, "nickname", "");
    /**
     * @generated from field: string avatarUrl = 5;
     */
    t(this, "avatarUrl", "");
    /**
     * @generated from field: bytes avatarImagePayload = 6;
     */
    t(this, "avatarImagePayload", new Uint8Array(0));
    /**
     * @generated from field: string localUrl = 7;
     */
    t(this, "localUrl", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new M().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new M().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new M().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(M, e, n);
  }
};
t(M, "runtime", a), t(M, "typeName", "DiscordMessageAuthor"), t(M, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "discriminator",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "nickname",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "avatarUrl",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "avatarImagePayload",
    kind: "scalar",
    T: 12
  },
  {
    no: 7,
    name: "localUrl",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let Vt = M;
const W = class W extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string messageId = 1;
     */
    t(this, "messageId", "");
    /**
     * @generated from field: string channelId = 2;
     */
    t(this, "channelId", "");
    /**
     * @generated from field: string guildId = 3;
     */
    t(this, "guildId", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new W().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new W().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new W().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(W, e, n);
  }
};
t(W, "runtime", a), t(W, "typeName", "DiscordMessageReference"), t(W, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "messageId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "channelId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "guildId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let zt = W;
const q = class q extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: string messageId = 2;
     */
    t(this, "messageId", "");
    /**
     * @generated from field: string url = 3;
     */
    t(this, "url", "");
    /**
     * @generated from field: string fileName = 4;
     */
    t(this, "fileName", "");
    /**
     * @generated from field: uint64 fileSizeBytes = 5;
     */
    t(this, "fileSizeBytes", d.zero);
    /**
     * @generated from field: string contentType = 6;
     */
    t(this, "contentType", "");
    /**
     * @generated from field: bytes payload = 7;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * @generated from field: string localUrl = 8;
     */
    t(this, "localUrl", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new q().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new q().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new q().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(q, e, n);
  }
};
t(q, "runtime", a), t(q, "typeName", "DiscordMessageAttachment"), t(q, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "messageId",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "fileName",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "fileSizeBytes",
    kind: "scalar",
    T: 4
  },
  {
    no: 6,
    name: "contentType",
    kind: "scalar",
    T: 9
  },
  {
    no: 7,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 8,
    name: "localUrl",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let Qt = q;
const _ = class _ extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string bridgeName = 1;
     */
    t(this, "bridgeName", "");
    /**
     * @generated from field: string userName = 2;
     */
    t(this, "userName", "");
    /**
     * @generated from field: string userAvatar = 3;
     */
    t(this, "userAvatar", "");
    /**
     * @generated from field: string userID = 4;
     */
    t(this, "userID", "");
    /**
     * @generated from field: string content = 5;
     */
    t(this, "content", "");
    /**
     * @generated from field: string messageID = 6;
     */
    t(this, "messageID", "");
    /**
     * @generated from field: string parentMessageID = 7;
     */
    t(this, "parentMessageID", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new _().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new _().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new _().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(_, e, n);
  }
};
t(_, "runtime", a), t(_, "typeName", "BridgeMessage"), t(_, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "bridgeName",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "userName",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "userAvatar",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "userID",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "content",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "messageID",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "parentMessageID",
    kind: "scalar",
    T: 9
  }
]));
let jt = _;
const V = class V extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes payload = 1;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * @generated from field: uint32 width = 2;
     */
    t(this, "width", 0);
    /**
     * @generated from field: uint32 height = 3;
     */
    t(this, "height", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new V().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new V().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new V().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(V, e, n);
  }
};
t(V, "runtime", a), t(V, "typeName", "UnfurledLinkThumbnail"), t(V, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "width",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "height",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let tt = V;
const z = class z extends l {
  constructor(e) {
    super();
    /**
     * A valid URL which uniquely identifies this link.
     *
     * @generated from field: string url = 1;
     */
    t(this, "url", "");
    /**
     * Website's title.
     *
     * @generated from field: string title = 2;
     */
    t(this, "title", "");
    /**
     * Description is sometimes available, but can be empty. Most mainstream
     * websites provide this information.
     *
     * @generated from field: string description = 3;
     */
    t(this, "description", "");
    /**
     * @generated from field: bytes thumbnail_payload = 4;
     */
    t(this, "thumbnailPayload", new Uint8Array(0));
    /**
     * @generated from field: uint32 thumbnail_width = 5;
     */
    t(this, "thumbnailWidth", 0);
    /**
     * @generated from field: uint32 thumbnail_height = 6;
     */
    t(this, "thumbnailHeight", 0);
    /**
     * @generated from field: UnfurledLink.LinkType type = 7;
     */
    t(this, "type", 0);
    /**
     * @generated from field: bytes favicon_payload = 8;
     */
    t(this, "faviconPayload", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new z().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new z().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new z().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(z, e, n);
  }
};
t(z, "runtime", a), t(z, "typeName", "UnfurledLink"), t(z, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "title",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "thumbnail_payload",
    kind: "scalar",
    T: 12
  },
  {
    no: 5,
    name: "thumbnail_width",
    kind: "scalar",
    T: 13
  },
  {
    no: 6,
    name: "thumbnail_height",
    kind: "scalar",
    T: 13
  },
  {
    no: 7,
    name: "type",
    kind: "enum",
    T: a.getEnumType(_r)
  },
  {
    no: 8,
    name: "favicon_payload",
    kind: "scalar",
    T: 12
  }
]));
let yt = z;
var _r = /* @__PURE__ */ ((r) => (r[r.LINK = 0] = "LINK", r[r.IMAGE = 1] = "IMAGE", r))(_r || {});
a.util.setEnumType(_r, "UnfurledLink.LinkType", [
  { no: 0, name: "LINK" },
  { no: 1, name: "IMAGE" }
]);
const Q = class Q extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes public_key = 1;
     */
    t(this, "publicKey", new Uint8Array(0));
    /**
     * @generated from field: string display_name = 2;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: string description = 3;
     */
    t(this, "description", "");
    /**
     * @generated from field: UnfurledLinkThumbnail icon = 4;
     */
    t(this, "icon");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Q().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Q().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Q().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Q, e, n);
  }
};
t(Q, "runtime", a), t(Q, "typeName", "UnfurledStatusContactLink"), t(Q, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "public_key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "description",
    kind: "scalar",
    T: 9
  },
  { no: 4, name: "icon", kind: "message", T: tt }
]));
let Xt = Q;
const j = class j extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes community_id = 1;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: string display_name = 2;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: string description = 3;
     */
    t(this, "description", "");
    /**
     * @generated from field: uint32 members_count = 4;
     */
    t(this, "membersCount", 0);
    /**
     * @generated from field: string color = 5;
     */
    t(this, "color", "");
    /**
     * @generated from field: UnfurledLinkThumbnail icon = 7;
     */
    t(this, "icon");
    /**
     * @generated from field: UnfurledLinkThumbnail banner = 8;
     */
    t(this, "banner");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new j().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new j().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new j().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(j, e, n);
  }
};
t(j, "runtime", a), t(j, "typeName", "UnfurledStatusCommunityLink"), t(j, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "members_count",
    kind: "scalar",
    T: 13
  },
  {
    no: 5,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "icon", kind: "message", T: tt },
  { no: 8, name: "banner", kind: "message", T: tt }
]));
let Nt = j;
const X = class X extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string channel_uuid = 1;
     */
    t(this, "channelUuid", "");
    /**
     * @generated from field: string emoji = 2;
     */
    t(this, "emoji", "");
    /**
     * @generated from field: string display_name = 3;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: string description = 4;
     */
    t(this, "description", "");
    /**
     * @generated from field: string color = 5;
     */
    t(this, "color", "");
    /**
     * @generated from field: UnfurledStatusCommunityLink community = 6;
     */
    t(this, "community");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new X().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new X().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new X().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(X, e, n);
  }
};
t(X, "runtime", a), t(X, "typeName", "UnfurledStatusChannelLink"), t(X, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "channel_uuid",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "emoji",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "community",
    kind: "message",
    T: Nt
  }
]));
let Zt = X;
const Z = class Z extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string url = 1;
     */
    t(this, "url", "");
    /**
     * @generated from oneof UnfurledStatusLink.payload
     */
    t(this, "payload", { case: void 0 });
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Z().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Z().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Z().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Z, e, n);
  }
};
t(Z, "runtime", a), t(Z, "typeName", "UnfurledStatusLink"), t(Z, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "contact",
    kind: "message",
    T: Xt,
    oneof: "payload"
  },
  {
    no: 3,
    name: "community",
    kind: "message",
    T: Nt,
    oneof: "payload"
  },
  {
    no: 4,
    name: "channel",
    kind: "message",
    T: Zt,
    oneof: "payload"
  }
]));
let $t = Z;
const $ = class $ extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated UnfurledStatusLink unfurled_status_links = 1;
     */
    t(this, "unfurledStatusLinks", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new $().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new $().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new $().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals($, e, n);
  }
};
t($, "runtime", a), t($, "typeName", "UnfurledStatusLinks"), t($, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "unfurled_status_links",
    kind: "message",
    T: $t,
    repeated: !0
  }
]));
let gt = $;
const ee = class ee extends l {
  constructor(e) {
    super();
    /**
     * Lamport timestamp of the chat message
     *
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * Unix timestamps in milliseconds, currently not used as we use whisper as
     * more reliable, but here so that we don't rely on it
     *
     * @generated from field: uint64 timestamp = 2;
     */
    t(this, "timestamp", d.zero);
    /**
     * Text of the message
     *
     * @generated from field: string text = 3;
     */
    t(this, "text", "");
    /**
     * Id of the message that we are replying to
     *
     * @generated from field: string response_to = 4;
     */
    t(this, "responseTo", "");
    /**
     * Ens name of the sender
     *
     * @generated from field: string ens_name = 5;
     */
    t(this, "ensName", "");
    /**
     * Chat id, this field is symmetric for public-chats and private group chats,
     * but asymmetric in case of one-to-ones, as the sender will use the chat-id
     * of the received, while the receiver will use the chat-id of the sender.
     * Probably should be the concatenation of sender-pk & receiver-pk in
     * alphabetical order
     *
     * @generated from field: string chat_id = 6;
     */
    t(this, "chatId", "");
    /**
     * The type of message (public/one-to-one/private-group-chat)
     *
     * @generated from field: MessageType message_type = 7;
     */
    t(this, "messageType", S.UNKNOWN_MESSAGE_TYPE);
    /**
     * The type of the content of the message
     *
     * @generated from field: ChatMessage.ContentType content_type = 8;
     */
    t(this, "contentType", 0);
    /**
     * @generated from oneof ChatMessage.payload
     */
    t(this, "payload", { case: void 0 });
    /**
     * Grant for community chat messages
     *
     * @generated from field: bytes grant = 13 [deprecated = true];
     * @deprecated
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * Message author's display name, introduced in version 1
     *
     * @generated from field: string display_name = 14;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: ContactRequestPropagatedState contact_request_propagated_state = 15;
     */
    t(this, "contactRequestPropagatedState");
    /**
     * @generated from field: repeated UnfurledLink unfurled_links = 16;
     */
    t(this, "unfurledLinks", []);
    /**
     * @generated from field: Shard shard = 17;
     */
    t(this, "shard");
    /**
     * @generated from field: UnfurledStatusLinks unfurled_status_links = 18;
     */
    t(this, "unfurledStatusLinks");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ee().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ee().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ee().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ee, e, n);
  }
};
t(ee, "runtime", a), t(ee, "typeName", "ChatMessage"), t(ee, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "timestamp",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 3,
    name: "text",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "response_to",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "ens_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "message_type",
    kind: "enum",
    T: a.getEnumType(S)
  },
  {
    no: 8,
    name: "content_type",
    kind: "enum",
    T: a.getEnumType(Gn)
  },
  {
    no: 9,
    name: "sticker",
    kind: "message",
    T: Mt,
    oneof: "payload"
  },
  {
    no: 10,
    name: "image",
    kind: "message",
    T: Wt,
    oneof: "payload"
  },
  {
    no: 11,
    name: "audio",
    kind: "message",
    T: qt,
    oneof: "payload"
  },
  {
    no: 12,
    name: "community",
    kind: "scalar",
    T: 12,
    oneof: "payload"
  },
  {
    no: 99,
    name: "discord_message",
    kind: "message",
    T: _t,
    oneof: "payload"
  },
  {
    no: 100,
    name: "bridge_message",
    kind: "message",
    T: jt,
    oneof: "payload"
  },
  {
    no: 13,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 14,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 15,
    name: "contact_request_propagated_state",
    kind: "message",
    T: Tt
  },
  {
    no: 16,
    name: "unfurled_links",
    kind: "message",
    T: yt,
    repeated: !0
  },
  { no: 17, name: "shard", kind: "message", T: nt },
  {
    no: 18,
    name: "unfurled_status_links",
    kind: "message",
    T: gt
  }
]));
let rt = ee;
var Gn = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_CONTENT_TYPE = 0] = "UNKNOWN_CONTENT_TYPE", r[r.TEXT_PLAIN = 1] = "TEXT_PLAIN", r[r.STICKER = 2] = "STICKER", r[r.STATUS = 3] = "STATUS", r[r.EMOJI = 4] = "EMOJI", r[r.TRANSACTION_COMMAND = 5] = "TRANSACTION_COMMAND", r[r.SYSTEM_MESSAGE_CONTENT_PRIVATE_GROUP = 6] = "SYSTEM_MESSAGE_CONTENT_PRIVATE_GROUP", r[r.IMAGE = 7] = "IMAGE", r[r.AUDIO = 8] = "AUDIO", r[r.COMMUNITY = 9] = "COMMUNITY", r[r.SYSTEM_MESSAGE_GAP = 10] = "SYSTEM_MESSAGE_GAP", r[r.CONTACT_REQUEST = 11] = "CONTACT_REQUEST", r[r.DISCORD_MESSAGE = 12] = "DISCORD_MESSAGE", r[r.IDENTITY_VERIFICATION = 13] = "IDENTITY_VERIFICATION", r[r.SYSTEM_MESSAGE_PINNED_MESSAGE = 14] = "SYSTEM_MESSAGE_PINNED_MESSAGE", r[r.SYSTEM_MESSAGE_MUTUAL_EVENT_SENT = 15] = "SYSTEM_MESSAGE_MUTUAL_EVENT_SENT", r[r.SYSTEM_MESSAGE_MUTUAL_EVENT_ACCEPTED = 16] = "SYSTEM_MESSAGE_MUTUAL_EVENT_ACCEPTED", r[r.SYSTEM_MESSAGE_MUTUAL_EVENT_REMOVED = 17] = "SYSTEM_MESSAGE_MUTUAL_EVENT_REMOVED", r[r.BRIDGE_MESSAGE = 18] = "BRIDGE_MESSAGE", r))(Gn || {});
a.util.setEnumType(Gn, "ChatMessage.ContentType", [
  { no: 0, name: "UNKNOWN_CONTENT_TYPE" },
  { no: 1, name: "TEXT_PLAIN" },
  { no: 2, name: "STICKER" },
  { no: 3, name: "STATUS" },
  { no: 4, name: "EMOJI" },
  { no: 5, name: "TRANSACTION_COMMAND" },
  { no: 6, name: "SYSTEM_MESSAGE_CONTENT_PRIVATE_GROUP" },
  { no: 7, name: "IMAGE" },
  { no: 8, name: "AUDIO" },
  { no: 9, name: "COMMUNITY" },
  { no: 10, name: "SYSTEM_MESSAGE_GAP" },
  { no: 11, name: "CONTACT_REQUEST" },
  { no: 12, name: "DISCORD_MESSAGE" },
  { no: 13, name: "IDENTITY_VERIFICATION" },
  { no: 14, name: "SYSTEM_MESSAGE_PINNED_MESSAGE" },
  { no: 15, name: "SYSTEM_MESSAGE_MUTUAL_EVENT_SENT" },
  { no: 16, name: "SYSTEM_MESSAGE_MUTUAL_EVENT_ACCEPTED" },
  { no: 17, name: "SYSTEM_MESSAGE_MUTUAL_EVENT_REMOVED" },
  { no: 18, name: "BRIDGE_MESSAGE" }
]);
const ne = class ne extends l {
  constructor(e) {
    super();
    /**
     * clock Lamport timestamp of the chat message
     *
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * chat_id the ID of the chat the message belongs to, for query efficiency the chat_id is stored in the db even though the
     * target message also stores the chat_id
     *
     * @generated from field: string chat_id = 2;
     */
    t(this, "chatId", "");
    /**
     * message_id the ID of the target message that the user wishes to react to
     *
     * @generated from field: string message_id = 3;
     */
    t(this, "messageId", "");
    /**
     * message_type is (somewhat confusingly) the ID of the type of chat the message belongs to
     *
     * @generated from field: MessageType message_type = 4;
     */
    t(this, "messageType", S.UNKNOWN_MESSAGE_TYPE);
    /**
     * type the ID of the emoji the user wishes to react with
     *
     * @generated from field: EmojiReaction.Type type = 5;
     */
    t(this, "type", 0);
    /**
     * whether this is a rectraction of a previously sent emoji
     *
     * @generated from field: bool retracted = 6;
     */
    t(this, "retracted", !1);
    /**
     * Grant for organisation chat messages
     *
     * @generated from field: bytes grant = 7 [deprecated = true];
     * @deprecated
     */
    t(this, "grant", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ne().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ne().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ne().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ne, e, n);
  }
};
t(ne, "runtime", a), t(ne, "typeName", "EmojiReaction"), t(ne, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "message_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "message_type",
    kind: "enum",
    T: a.getEnumType(S)
  },
  {
    no: 5,
    name: "type",
    kind: "enum",
    T: a.getEnumType(Zn)
  },
  {
    no: 6,
    name: "retracted",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 7,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let kt = ne;
var Zn = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_EMOJI_REACTION_TYPE = 0] = "UNKNOWN_EMOJI_REACTION_TYPE", r[r.LOVE = 1] = "LOVE", r[r.THUMBS_UP = 2] = "THUMBS_UP", r[r.THUMBS_DOWN = 3] = "THUMBS_DOWN", r[r.LAUGH = 4] = "LAUGH", r[r.SAD = 5] = "SAD", r[r.ANGRY = 6] = "ANGRY", r))(Zn || {});
a.util.setEnumType(Zn, "EmojiReaction.Type", [
  { no: 0, name: "UNKNOWN_EMOJI_REACTION_TYPE" },
  { no: 1, name: "LOVE" },
  { no: 2, name: "THUMBS_UP" },
  { no: 3, name: "THUMBS_DOWN" },
  { no: 4, name: "LAUGH" },
  { no: 5, name: "SAD" },
  { no: 6, name: "ANGRY" }
]);
const gi = async (r, i, e, n) => {
  const s = await window.crypto.subtle.importKey(
    "raw",
    r,
    { name: "PBKDF2" },
    !1,
    ["deriveBits"]
  ), c = await window.crypto.subtle.deriveBits(
    {
      name: "PBKDF2",
      salt: i,
      iterations: e,
      hash: {
        name: "SHA-256"
      }
    },
    s,
    n << 3
  );
  return new Uint8Array(c);
}, ki = 32;
async function wt(r) {
  return await gi(
    Et(r),
    Et(""),
    65356,
    ki
  );
}
const Za = (r = 0n) => {
  const i = BigInt(Date.now());
  return r < i ? i : r + 1n;
}, wi = 4;
function It(r) {
  const e = ut(Et(r)).slice(0, wi);
  return `/waku/1/0x${Yn(e)}/rfc26`;
}
function Ft(r, i, e) {
  const { type: n, retracted: s } = r;
  if (n === Zn.UNKNOWN_EMOJI_REACTION_TYPE)
    return i;
  const c = Zn[n];
  return s ? i[c].delete(e) : i[c].add(e), i;
}
var p, w, An, Cn, gn, kn, Bn, Un, Mn, On;
const Rt = class Rt {
  constructor(i) {
    t(this, "client");
    T(this, p);
    t(this, "uuid");
    t(this, "id");
    t(this, "contentTopic");
    t(this, "type");
    t(this, "symmetricKey");
    t(this, "description");
    t(this, "chatCallbacks");
    T(this, w);
    T(this, An);
    T(this, Cn);
    T(this, gn);
    T(this, kn);
    T(this, Bn);
    T(this, Un);
    T(this, Mn);
    T(this, On);
    t(this, "messageCallbacks");
    /**
     * Returns chat messages soreted in ascending order and reply references resolved.
     */
    t(this, "getMessages", () => {
      const i = [];
      for (const e of o(this, w).values()) {
        const n = o(this, w).get(e.responseTo);
        n && (e.responseToMessage = n), i.push(e);
      }
      return i.sort((e, n) => e.clock < n.clock ? -1 : e.clock > n.clock ? 1 : 0), i;
    });
    t(this, "getMessage", (i) => o(this, w).get(i));
    t(this, "onChange", (i) => (this.chatCallbacks.add(i), () => {
      this.chatCallbacks.delete(i);
    }));
    t(this, "emitChange", (i) => {
      this.chatCallbacks.forEach((e) => e(i));
    });
    t(this, "onMessage", (i) => (this.messageCallbacks.add(i), E(this, Bn, !0), this.client.activityCenter.removeChatNotifications(this.uuid), () => {
      this.messageCallbacks.delete(i), E(this, Bn, !1);
    }));
    t(this, "fetchMessages", async (i) => {
      const e = o(this, On), n = i.start;
      if (e && e.timestamp && e.timestamp < i.start)
        return;
      let s;
      return o(this, Mn) ? s = o(this, Mn) : s = /* @__PURE__ */ new Date(), await this.client.waku.store.queryWithOrderedCallback(
        [
          Hn(this.contentTopic, this.symmetricKey, {
            clusterId: 16,
            shard: 32
          })
        ],
        (u) => {
          E(this, Un, !0), this.client.handleWakuMessage(u), E(this, Un, !1);
        },
        {
          timeFilter: {
            startTime: n,
            endTime: s
          },
          pageSize: 50,
          // most recent page first
          pageDirection: xt.BACKWARD
        }
      ), E(this, Mn, n), e && o(this, On) && // same message
      e.messageId === o(this, On).messageId ? void 0 : this.emitMessages();
    });
    t(this, "emitMessages", () => {
      if (o(this, Un))
        return;
      const i = this.getMessages();
      return this.messageCallbacks.forEach((e) => e(i)), i;
    });
    t(this, "handleChange", (i) => {
      this.description = i, this.emitChange(i);
    });
    t(this, "handleNewMessage", (i, e) => {
      o(this, Un) && E(this, On, this.getOldestFetchedMessage(
        o(this, On),
        i.messageId,
        e
      ));
      const n = o(this, kn).get(i.messageId);
      if (n) {
        if (this.isAuthor(i, n.signer))
          return;
        o(this, kn).delete(i.messageId);
      }
      if (o(this, w).get(i.messageId))
        return;
      const c = o(this, An).get(i.messageId);
      c && (this.isAuthor(i, c.signer) && (i.text = c.text, i.edittedClock = c.clock), o(this, An).delete(i.messageId));
      const u = o(this, Cn).get(i.messageId);
      u && (i.pinned = u.pinned, i.pinnedClock = u.clock, o(this, Cn).delete(i.messageId));
      const m = o(this, gn).get(i.messageId);
      m && (i.reactions = m.reactions, o(this, gn).delete(i.messageId)), o(this, w).set(i.messageId, i), this.emitMessages();
      const f = this.client.account !== void 0 && this.isAuthor(i, `0x${this.client.account.publicKey}`);
      !o(this, Bn) && !f && this.client.activityCenter.addMessageNotification(
        i,
        o(this, w).get(i.responseTo)
      );
    });
    t(this, "handleEditedMessage", (i, e, n, s) => {
      const c = o(this, w).get(i);
      if (c && this.isAuthor(c, s)) {
        c.text = e, this.emitMessages();
        return;
      }
      const u = o(this, An).get(i);
      (!u || u.clock < n) && o(this, An).set(i, {
        clock: n,
        signer: s,
        text: e
      });
    });
    t(this, "handleDeletedMessage", (i, e, n) => {
      const s = o(this, w).get(i);
      if (s && this.isAuthor(s, n)) {
        o(this, w).delete(i), o(this, kn).set(i, { clock: e, signer: n }), this.emitMessages();
        return;
      }
      const c = o(this, kn).get(i);
      (!c || c.clock > e) && o(this, kn).set(i, { clock: e, signer: n });
    });
    t(this, "handlePinnedMessage", (i, e, n) => {
      const s = o(this, w).get(i);
      if (s) {
        s.pinned = !!n, s.pinnedClock = e, this.emitMessages();
        return;
      }
      const c = o(this, Cn).get(i);
      (!c || c.clock < e) && o(this, Cn).set(i, {
        clock: e,
        pinned: !!n
      });
    });
    t(this, "handleEmojiReaction", (i, e, n, s) => {
      const c = o(this, w).get(i);
      if (c) {
        const m = Ft(
          e,
          c.reactions,
          s
        );
        c.reactions = m, this.emitMessages();
        return;
      }
      const u = o(this, gn).get(i);
      if (u) {
        const m = Ft(
          e,
          u.reactions,
          s
        );
        o(this, gn).set(i, { clock: n, reactions: m });
      } else {
        const m = Ft(
          e,
          {
            THUMBS_UP: /* @__PURE__ */ new Set(),
            THUMBS_DOWN: /* @__PURE__ */ new Set(),
            LOVE: /* @__PURE__ */ new Set(),
            LAUGH: /* @__PURE__ */ new Set(),
            SAD: /* @__PURE__ */ new Set(),
            ANGRY: /* @__PURE__ */ new Set()
          },
          s
        );
        o(this, gn).set(i, { clock: n, reactions: m });
      }
    });
    t(this, "sendTextMessage", async (i, e) => {
      if (i === "")
        throw new Error("Text message cannot be empty");
      const n = Ni(i) ? Gn.EMOJI : Gn.TEXT_PLAIN, s = new rt({
        clock: this.setClock(o(this, p)),
        timestamp: BigInt(Date.now()),
        text: i,
        responseTo: e ?? "",
        ensName: "",
        chatId: this.id,
        contentType: n,
        messageType: S.COMMUNITY_CHAT,
        grant: new Uint8Array([]),
        displayName: ""
      }).toBinary();
      await this.client.sendWakuMessage(
        I.CHAT_MESSAGE,
        s,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "sendImageMessage", async (i) => {
      const e = new rt({
        clock: this.setClock(o(this, p)),
        timestamp: BigInt(Date.now()),
        text: "",
        responseTo: "",
        ensName: "",
        chatId: this.id,
        messageType: S.COMMUNITY_CHAT,
        contentType: Gn.IMAGE,
        payload: {
          case: "image",
          value: {
            format: i.format,
            payload: i.payload
          }
        },
        grant: new Uint8Array([]),
        displayName: ""
      }).toBinary();
      await this.client.sendWakuMessage(
        I.CHAT_MESSAGE,
        e,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "editMessage", async (i, e) => {
      if (!this.client.account)
        throw new Error("Text message cannot be edited without a created account");
      const n = o(this, w).get(i);
      if (!n)
        throw new Error("Message not found");
      if (!this.isAuthor(n, `0x${this.client.account.publicKey}`))
        throw new Error("Text message can only be edited by its author");
      if (e === "")
        throw new Error("Text message cannot be empty");
      const s = new ft({
        clock: this.setClock(o(this, p)),
        text: e,
        messageId: i,
        chatId: this.id,
        grant: new Uint8Array([]),
        messageType: S.COMMUNITY_CHAT
      }).toBinary();
      await this.client.sendWakuMessage(
        I.EDIT_MESSAGE,
        s,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "deleteMessage", async (i) => {
      if (!this.client.account)
        throw new Error(
          "Text message cannot be deleted without a created account"
        );
      const e = o(this, w).get(i);
      if (!e)
        throw new Error("Message not found");
      if (!this.isAuthor(e, `0x${this.client.account.publicKey}`))
        throw new Error("Text message can only be deleted by its author");
      const n = new St({
        clock: this.setClock(o(this, p)),
        messageId: i,
        chatId: this.id,
        grant: new Uint8Array([]),
        messageType: S.COMMUNITY_CHAT
      }).toBinary();
      await this.client.sendWakuMessage(
        I.DELETE_MESSAGE,
        n,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "sendReaction", async (i, e) => {
      if (!this.client.account)
        throw new Error("Account not initialized");
      const n = o(this, w).get(i);
      if (!n)
        throw new Error("Message not found");
      const s = n.reactions[e].has(
        `0x${this.client.account.publicKey}`
      ), c = new kt({
        clock: this.setClock(o(this, p)),
        chatId: this.id,
        messageType: S.COMMUNITY_CHAT,
        messageId: i,
        type: Zn[e],
        retracted: s,
        grant: new Uint8Array([])
      }).toBinary();
      await this.client.sendWakuMessage(
        I.EMOJI_REACTION,
        c,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "isAuthor", (i, e) => i.signer === e);
    t(this, "setClock", (i) => (E(this, p, Za(i)), o(this, p)));
    this.client = i.client, this.uuid = i.uuid, this.id = i.id, this.contentTopic = i.contentTopic, this.type = i.type, this.symmetricKey = i.symmetricKey, this.description = i.description, E(this, p, BigInt(Date.now())), this.chatCallbacks = /* @__PURE__ */ new Set(), E(this, w, /* @__PURE__ */ new Map()), E(this, An, /* @__PURE__ */ new Map()), E(this, Cn, /* @__PURE__ */ new Map()), E(this, gn, /* @__PURE__ */ new Map()), E(this, kn, /* @__PURE__ */ new Map()), E(this, Bn, !1), this.messageCallbacks = /* @__PURE__ */ new Set();
  }
  get link() {
    return fi(this.uuid, this.client.community.chatKey);
  }
  getOldestFetchedMessage(i, e, n) {
    let s;
    return i ? n && i.timestamp && // is older
    n < i.timestamp ? s = {
      messageId: e,
      timestamp: n
    } : s = i : s = {
      messageId: e,
      timestamp: n
    }, s;
  }
};
p = new WeakMap(), w = new WeakMap(), An = new WeakMap(), Cn = new WeakMap(), gn = new WeakMap(), kn = new WeakMap(), Bn = new WeakMap(), Un = new WeakMap(), Mn = new WeakMap(), On = new WeakMap(), t(Rt, "create", async (i, e, n, s, c) => {
  const u = `${i.publicKey}${n}`, m = It(u), f = await wt(u);
  return new Rt({
    client: e,
    uuid: n,
    id: u,
    contentTopic: m,
    type: s,
    symmetricKey: f,
    description: c
  });
});
let er = Rt;
const Gt = [
  "/dns4/boot-01.do-ams3.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAmAR24Mbb6VuzoyUiGx42UenDkshENVDj4qnmmbabLvo31",
  "/dns4/boot-01.gc-us-central1-a.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAm8mUZ18tBWPXDQsaF7PbCKYA35z7WB2xNZH2EVq1qS8LJ",
  "/dns4/boot-01.ac-cn-hongkong-c.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAmGwcE8v7gmJNEWFtZtojYpPMTHy2jBLL6xRk33qgDxFWX",
  "/dns4/store-01.do-ams3.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAmAUdrQ3uwzuE4Gy4D56hX6uLKEeerJAnhKEHZ3DxF1EfT",
  "/dns4/store-02.do-ams3.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAm9aDJPkhGxc2SFcEACTFdZ91Q5TJjp76qZEhq9iF59x7R",
  "/dns4/store-01.gc-us-central1-a.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAmMELCo218hncCtTvC2Dwbej3rbyHQcR8erXNnKGei7WPZ",
  "/dns4/store-02.gc-us-central1-a.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAmJnVR7ZzFaYvciPVafUXuYGLHPzSUigqAmeNw9nJUVGeM",
  "/dns4/store-01.ac-cn-hongkong-c.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAm2M7xs7cLPc3jamawkEqbr7cUJX11uvY7LxQ6WFUdUKUT",
  "/dns4/store-02.ac-cn-hongkong-c.status.prod.status.im/tcp/443/wss/p2p/16Uiu2HAm9CQhsuwPR54q27kNj9iaQVfyRzTGKrhFmr94oD8ujU6P"
], $a = {
  development: Gt,
  preview: Gt,
  production: Gt
}, Ii = BigInt(184);
function Yt(r) {
  let i = 0n;
  for (let e = 0; e < 64; e++)
    (Ii & 1n << BigInt(e)) !== 0n && (i ^= r >> BigInt(e));
  return i &= 1n, BigInt.asUintN(64, r << 1n) | i;
}
function ei(r) {
  const i = BigInt(`0x${r.slice(52, 68)}`), e = Yt(i), n = Yt(e), s = Yt(n), c = dt[Number(e % BigInt(dt.length))], u = dt[Number(n % BigInt(dt.length))], m = Sa[Number(s % BigInt(Sa.length))];
  return `${c} ${u} ${m}`;
}
const Sa = [
  "Aardvark",
  "Aardwolf",
  "Abalone",
  "Abyssiniancat",
  "Abyssiniangroundhornbill",
  "Acaciarat",
  "Achillestang",
  "Acornbarnacle",
  "Acornweevil",
  "Acornwoodpecker",
  "Acouchi",
  "Adamsstaghornedbeetle",
  "Addax",
  "Adder",
  "Adeliepenguin",
  "Admiralbutterfly",
  "Adouri",
  "Aegeancat",
  "Affenpinscher",
  "Hound",
  "Augurbuzzard",
  "Bushviper",
  "Civet",
  "Clawedfrog",
  "Elephant",
  "Fisheagle",
  "Goldencat",
  "Groundhornbill",
  "Harrierhawk",
  "Hornbill",
  "Jacana",
  "Molesnake",
  "Paradiseflycatcher",
  "Piedkingfisher",
  "Porcupine",
  "Rockpython",
  "Wildcat",
  "Wilddog",
  "Agama",
  "Agouti",
  "Aidi",
  "Airedale",
  "Airedaleterrier",
  "Akitainu",
  "Mapturtle",
  "Jingle",
  "Husky",
  "Kleekai",
  "Malamute",
  "Albacoretuna",
  "Albatross",
  "Albertosaurus",
  "Albino",
  "Aldabratortoise",
  "Allensbigearedbat",
  "Alleycat",
  "Alligator",
  "Alligatorgar",
  "Alligatorsnappingturtle",
  "Allosaurus",
  "Alpaca",
  "Alpinegoat",
  "Alpineroadguidetigerbeetle",
  "Altiplanochinchillamouse",
  "Amazondolphin",
  "Amazonparrot",
  "Amazontreeboa",
  "Amberpenshell",
  "Ambushbug",
  "Alligator",
  "Avocet",
  "Badger",
  "Bittern",
  "Vulture",
  "Bobtail",
  "Bulldog",
  "Cicada",
  "Crayfish",
  "Creamdraft",
  "Crocodile",
  "Crow",
  "Curl",
  "Goldfinch",
  "Indianhorse",
  "Kestrel",
  "Lobster",
  "Marten",
  "Painthorse",
  "Quarterhorse",
  "Ratsnake",
  "Redsquirrel",
  "Riverotter",
  "Robin",
  "Saddlebred",
  "Shorthair",
  "Toad",
  "Warmblood",
  "Wigeon",
  "Wirehair",
  "Amethystgemclam",
  "Amethystinepython",
  "Amethystsunbird",
  "Ammonite",
  "Amoeba",
  "Amphibian",
  "Amphiuma",
  "Amurminnow",
  "Amurratsnake",
  "Amurstarfish",
  "Anaconda",
  "Anchovy",
  "Andalusianhorse",
  "Andeancat",
  "Andeancondor",
  "Anemone",
  "Anemonecrab",
  "Anemoneshrimp",
  "Angelfish",
  "Angelwingmussel",
  "Anglerfish",
  "Angora",
  "Angwantibo",
  "Anhinga",
  "Ankole",
  "Ankolewatusi",
  "Annashummingbird",
  "Annelid",
  "Annelida",
  "Anole",
  "Anophelesmosquito",
  "Ant",
  "Antarcticfurseal",
  "Antarcticgiantpetrel",
  "Antbear",
  "Anteater",
  "Antelope",
  "Antelopegroundsquirrel",
  "Antipodesgreenparakeet",
  "Antlion",
  "Anura",
  "Aoudad",
  "Apatosaur",
  "Ape",
  "Aphid",
  "Apisdorsatalaboriosa",
  "Aplomadofalcon",
  "Appaloosa",
  "Aquaticleech",
  "Arabianhorse",
  "Arabianoryx",
  "Arabianwildcat",
  "Aracari",
  "Arachnid",
  "Arawana",
  "Archaeocete",
  "Archaeopteryx",
  "Archerfish",
  "Arcticduck",
  "Arcticfox",
  "Arctichare",
  "Arcticseal",
  "Arcticwolf",
  "Argali",
  "Argentinehornedfrog",
  "Argentineruddyduck",
  "Argusfish",
  "Arieltoucan",
  "Arizonaalligatorlizard",
  "Arkshell",
  "Armadillo",
  "Armedcrab",
  "Armednylonshrimp",
  "Armyant",
  "Armyworm",
  "Arrowana",
  "Arrowcrab",
  "Arrowworm",
  "Arthropods",
  "Aruanas",
  "Constablebutterfly",
  "Damselfly",
  "Elephant",
  "Lion",
  "Piedstarling",
  "Porcupine",
  "Smallclawedotter",
  "Trumpetfish",
  "Waterbuffalo",
  "Greaterfreshwaterclam",
  "Lesserfreshwaterclam",
  "Mouflon",
  "Asp",
  "Assassinbug",
  "Astarte",
  "Astrangiacoral",
  "Atlanticblackgoby",
  "Atlanticbluetang",
  "Atlanticridleyturtle",
  "Atlanticsharpnosepuffer",
  "Atlanticspadefish",
  "Atlasmoth",
  "Attwatersprairiechicken",
  "Auk",
  "Auklet",
  "Aurochs",
  "Australiancattledog",
  "Australiancurlew",
  "Australianfreshwatercrocodile",
  "Australianfurseal",
  "Australiankelpie",
  "Australiankestrel",
  "Australianshelduck",
  "Australiansilkyterrier",
  "Austrianpinscher",
  "Avians",
  "Avocet",
  "Axisdeer",
  "Axolotl",
  "Ayeaye",
  "Aztecant",
  "Azurevase",
  "Azurevasesponge",
  "Azurewingedmagpie",
  "Babirusa",
  "Baboon",
  "Backswimmer",
  "Bactrian",
  "Badger",
  "Bagworm",
  "Baiji",
  "Baldeagle",
  "Baleenwhale",
  "Balloonfish",
  "Ballpython",
  "Bandicoot",
  "Bangeltiger",
  "Bantamrooster",
  "Banteng",
  "Barasinga",
  "Barasingha",
  "Barb",
  "Barbet",
  "Barebirdbat",
  "Barnacle",
  "Barnowl",
  "Barnswallow",
  "Barracuda",
  "Basenji",
  "Basil",
  "Basilisk",
  "Bass",
  "Bassethound",
  "Bat",
  "Bats",
  "Beagle",
  "Bear",
  "Beardedcollie",
  "Beardeddragon",
  "Beauceron",
  "Beaver",
  "Bedbug",
  "Bedlingtonterrier",
  "Bee",
  "Beetle",
  "Bellfrog",
  "Bellsnake",
  "Belugawhale",
  "Bengaltiger",
  "Bergerpicard",
  "Bernesemountaindog",
  "Betafish",
  "Bettong",
  "Bichonfrise",
  "Bighorn",
  "Bighornedsheep",
  "Bighornsheep",
  "Bigmouthbass",
  "Bilby",
  "Binturong",
  "Bird",
  "Birdofparadise",
  "Bison",
  "Bittern",
  "Blackbear",
  "Blackbird",
  "Blackbuck",
  "Blackfish",
  "Blackfly",
  "Blackfootedferret",
  "Blacklab",
  "Blacklemur",
  "Blackmamba",
  "Blacknorwegianelkhound",
  "Blackpanther",
  "Blackrhino",
  "Blackrussianterrier",
  "Blackwidowspider",
  "Blesbok",
  "Blobfish",
  "Blowfish",
  "Blueandgoldmackaw",
  "Bluebird",
  "Bluebottle",
  "Bluebottlejellyfish",
  "Bluefintuna",
  "Bluefish",
  "Bluegill",
  "Bluejay",
  "Blueshark",
  "Bluet",
  "Bluetickcoonhound",
  "Bluetonguelizard",
  "Bluewhale",
  "Boa",
  "Boaconstrictor",
  "Boar",
  "Bobcat",
  "Bobolink",
  "Bobwhite",
  "Boilweevil",
  "Bongo",
  "Bonobo",
  "Booby",
  "Bordercollie",
  "Borderterrier",
  "Borer",
  "Borzoi",
  "Boto",
  "Boubou",
  "Boutu",
  "Bovine",
  "Brahmanbull",
  "Brahmancow",
  "Brant",
  "Bream",
  "Brocketdeer",
  "Bronco",
  "Brontosaurus",
  "Brownbear",
  "Brownbutterfly",
  "Bubblefish",
  "Buck",
  "Buckeyebutterfly",
  "Budgie",
  "Bufeo",
  "Buffalo",
  "Bufflehead",
  "Bug",
  "Bull",
  "Bullfrog",
  "Bullmastiff",
  "Bumblebee",
  "Bunny",
  "Bunting",
  "Burro",
  "Bushbaby",
  "Bushsqueaker",
  "Bustard",
  "Butterfly",
  "Buzzard",
  "Caecilian",
  "Caiman",
  "Caimanlizard",
  "Calf",
  "Camel",
  "Canadagoose",
  "Canary",
  "Canine",
  "Canvasback",
  "Capeghostfrog",
  "Capybara",
  "Caracal",
  "Cardinal",
  "Caribou",
  "Carp",
  "Carpenterant",
  "Cassowary",
  "Cat",
  "Catbird",
  "Caterpillar",
  "Catfish",
  "Cats",
  "Cattle",
  "Caudata",
  "Cavy",
  "Centipede",
  "Cero",
  "Chafer",
  "Chameleon",
  "Chamois",
  "Chanticleer",
  "Cheetah",
  "Chevrotain",
  "Chick",
  "Chickadee",
  "Chicken",
  "Chihuahua",
  "Chimneyswift",
  "Chimpanzee",
  "Chinchilla",
  "Chinesecrocodilelizard",
  "Chipmunk",
  "Chital",
  "Chrysalis",
  "Chrysomelid",
  "Chuckwalla",
  "Chupacabra",
  "Cicada",
  "Cirriped",
  "Civet",
  "Clam",
  "Cleanerwrasse",
  "Clingfish",
  "Clownanemonefish",
  "Clumber",
  "Coati",
  "Cob",
  "Cobra",
  "Cockerspaniel",
  "Cod",
  "Coelacanth",
  "Collardlizard",
  "Collie",
  "Colt",
  "Comet",
  "Commabutterfly",
  "Commongonolek",
  "Conch",
  "Condor",
  "Coney",
  "Conure",
  "Cony",
  "Coot",
  "Cooter",
  "Copepod",
  "Copperbutterfly",
  "Copperhead",
  "Coqui",
  "Coral",
  "Cormorant",
  "Cornsnake",
  "Corydorascatfish",
  "Cottonmouth",
  "Cottontail",
  "Cow",
  "Cowbird",
  "Cowrie",
  "Coyote",
  "Coypu",
  "Crab",
  "Crane",
  "Cranefly",
  "Crayfish",
  "Creature",
  "Cricket",
  "Crocodile",
  "Crocodileskink",
  "Crossbill",
  "Crow",
  "Crownofthornsstarfish",
  "Crustacean",
  "Cub",
  "Cuckoo",
  "Cur",
  "Curassow",
  "Curlew",
  "Cuscus",
  "Cusimanse",
  "Cuttlefish",
  "Cutworm",
  "Cygnet",
  "Dachshund",
  "Dalmatian",
  "Damselfly",
  "Danishswedishfarmdog",
  "Darklingbeetle",
  "Dartfrog",
  "Darwinsfox",
  "Dassie",
  "Dassierat",
  "Davidstiger",
  "Deer",
  "Deermouse",
  "Degu",
  "Degus",
  "Deinonychus",
  "Desertpupfish",
  "Devilfish",
  "Deviltasmanian",
  "Diamondbackrattlesnake",
  "Dikdik",
  "Dikkops",
  "Dingo",
  "Dinosaur",
  "Diplodocus",
  "Dipper",
  "Discus",
  "Dobermanpinscher",
  "Doctorfish",
  "Dodo",
  "Dodobird",
  "Doe",
  "Dog",
  "Dogfish",
  "Dolphin",
  "Donkey",
  "Dorado",
  "Dore",
  "Dorking",
  "Dormouse",
  "Dotterel",
  "Dove",
  "Dowitcher",
  "Drafthorse",
  "Dragon",
  "Dragonfly",
  "Drake",
  "Drever",
  "Dromaeosaur",
  "Dromedary",
  "Drongo",
  "Duck",
  "Duckbillcat",
  "Duckbillplatypus",
  "Duckling",
  "Dugong",
  "Duiker",
  "Dunlin",
  "Dunnart",
  "Dutchshepherddog",
  "Dutchsmoushond",
  "Eagle",
  "Earthworm",
  "Earwig",
  "Easternglasslizard",
  "Easternnewt",
  "Echidna",
  "Eel",
  "Eelelephant",
  "Eeve",
  "Eft",
  "Egg",
  "Egret",
  "Eider",
  "Eidolonhelvum",
  "Ekaltadeta",
  "Eland",
  "Electriceel",
  "Elephant",
  "Elephantbeetle",
  "Elephantseal",
  "Elk",
  "Elkhound",
  "Elver",
  "Emeraldtreeskink",
  "Emperorpenguin",
  "Emperorshrimp",
  "Emu",
  "Englishpointer",
  "Englishsetter",
  "Equestrian",
  "Equine",
  "Erin",
  "Ermine",
  "Erne",
  "Eskimodog",
  "Esok",
  "Estuarinecrocodile",
  "Ethiopianwolf",
  "Europeanfiresalamander",
  "Europeanpolecat",
  "Ewe",
  "Eyas",
  "Eyelashpitviper",
  "Eyra",
  "Fairybluebird",
  "Fairyfly",
  "Falcon",
  "Fallowdeer",
  "Fantail",
  "Fanworms",
  "Fattaileddunnart",
  "Fawn",
  "Feline",
  "Fennecfox",
  "Ferret",
  "Fiddlercrab",
  "Fieldmouse",
  "Fieldspaniel",
  "Finch",
  "Finnishspitz",
  "Finwhale",
  "Fireant",
  "Firebelliedtoad",
  "Firecrest",
  "Firefly",
  "Fish",
  "Fishingcat",
  "Flamingo",
  "Flatcoatretriever",
  "Flatfish",
  "Flea",
  "Flee",
  "Flicker",
  "Flickertailsquirrel",
  "Flies",
  "Flounder",
  "Fluke",
  "Fly",
  "Flycatcher",
  "Flyingfish",
  "Flyingfox",
  "Flyinglemur",
  "Flyingsquirrel",
  "Foal",
  "Fossa",
  "Fowl",
  "Fox",
  "Foxhound",
  "Foxterrier",
  "Frenchbulldog",
  "Freshwatereel",
  "Frigatebird",
  "Frilledlizard",
  "Frillneckedlizard",
  "Fritillarybutterfly",
  "Frog",
  "Frogmouth",
  "Fruitbat",
  "Fruitfly",
  "Fugu",
  "Fulmar",
  "Funnelweaverspider",
  "Furseal",
  "Gadwall",
  "Galago",
  "Galah",
  "Galapagosalbatross",
  "Galapagosdove",
  "Galapagoshawk",
  "Galapagosmockingbird",
  "Galapagospenguin",
  "Galapagossealion",
  "Galapagostortoise",
  "Gallinule",
  "Gallowaycow",
  "Gander",
  "Gangesdolphin",
  "Gannet",
  "Gar",
  "Gardensnake",
  "Garpike",
  "Gartersnake",
  "Gaur",
  "Gavial",
  "Gazelle",
  "Gecko",
  "Geese",
  "Gelada",
  "Gelding",
  "Gemsbok",
  "Gemsbuck",
  "Genet",
  "Gentoopenguin",
  "Gerbil",
  "Gerenuk",
  "Germanpinscher",
  "Germanshepherd",
  "Germanshorthairedpointer",
  "Germanspaniel",
  "Germanspitz",
  "Germanwirehairedpointer",
  "Gharial",
  "Ghostshrimp",
  "Giantschnauzer",
  "Gibbon",
  "Gilamonster",
  "Giraffe",
  "Glassfrog",
  "Globefish",
  "Glowworm",
  "Gnat",
  "Gnatcatcher",
  "Gnu",
  "Goa",
  "Goat",
  "Godwit",
  "Goitered",
  "Goldeneye",
  "Goldenmantledgroundsquirrel",
  "Goldenretriever",
  "Goldfinch",
  "Goldfish",
  "Gonolek",
  "Goose",
  "Goosefish",
  "Gopher",
  "Goral",
  "Gordonsetter",
  "Gorilla",
  "Goshawk",
  "Gosling",
  "Gossamerwingedbutterfly",
  "Gourami",
  "Grackle",
  "Grasshopper",
  "Grassspider",
  "Grayfox",
  "Grayling",
  "Grayreefshark",
  "Graysquirrel",
  "Graywolf",
  "Greatargus",
  "Greatdane",
  "Greathornedowl",
  "Greatwhiteshark",
  "Grebe",
  "Greendarnerdragonfly",
  "Greyhounddog",
  "Grison",
  "Grizzlybear",
  "Grosbeak",
  "Groundbeetle",
  "Groundhog",
  "Grouper",
  "Grouse",
  "Grub",
  "Grunion",
  "Guanaco",
  "Guernseycow",
  "Guillemot",
  "Guineafowl",
  "Guineapig",
  "Gull",
  "Guppy",
  "Gyrfalcon",
  "Hackee",
  "Haddock",
  "Hadrosaurus",
  "Hagfish",
  "Hairstreak",
  "Hairstreakbutterfly",
  "Hake",
  "Halcyon",
  "Halibut",
  "Halicore",
  "Hamadryad",
  "Hamadryas",
  "Hammerheadbird",
  "Hammerheadshark",
  "Hammerkop",
  "Hamster",
  "Hanumanmonkey",
  "Hapuka",
  "Hapuku",
  "Harborporpoise",
  "Harborseal",
  "Hare",
  "Harlequinbug",
  "Harpseal",
  "Harpyeagle",
  "Harrier",
  "Harrierhawk",
  "Hart",
  "Hartebeest",
  "Harvestmen",
  "Harvestmouse",
  "Hatchetfish",
  "Hawaiianmonkseal",
  "Hawk",
  "Hectorsdolphin",
  "Hedgehog",
  "Heifer",
  "Hellbender",
  "Hen",
  "Herald",
  "Herculesbeetle",
  "Hermitcrab",
  "Heron",
  "Herring",
  "Hind",
  "Hippopotamus",
  "Hoatzin",
  "Hochstettersfrog",
  "Hog",
  "Hogget",
  "Hoiho",
  "Hoki",
  "Homalocephale",
  "Honeybadger",
  "Honeybee",
  "Honeycreeper",
  "Honeyeater",
  "Hookersealion",
  "Hoopoe",
  "Hornbill",
  "Hornedtoad",
  "Hornedviper",
  "Hornet",
  "Hornshark",
  "Horse",
  "Horsechestnutleafminer",
  "Horsefly",
  "Horsemouse",
  "Horseshoebat",
  "Horseshoecrab",
  "Hound",
  "Housefly",
  "Hoverfly",
  "Howlermonkey",
  "Huemul",
  "Huia",
  "Human",
  "Hummingbird",
  "Humpbackwhale",
  "Husky",
  "Hydatidtapeworm",
  "Hydra",
  "Hyena",
  "Hylaeosaurus",
  "Hypacrosaurus",
  "Hypsilophodon",
  "Hyracotherium",
  "Hyrax",
  "Iaerismetalmark",
  "Ibadanmalimbe",
  "Iberianbarbel",
  "Iberianchiffchaff",
  "Iberianemeraldlizard",
  "Iberianlynx",
  "Iberianmidwifetoad",
  "Iberianmole",
  "Iberiannase",
  "Ibex",
  "Ibis",
  "Ibisbill",
  "Ibizanhound",
  "Iceblueredtopzebra",
  "Icefish",
  "Icelandgull",
  "Icelandichorse",
  "Icelandicsheepdog",
  "Ichidna",
  "Ichneumonfly",
  "Ichthyosaurs",
  "Ichthyostega",
  "Icterinewarbler",
  "Iggypops",
  "Iguana",
  "Iguanodon",
  "Illadopsis",
  "Ilsamochadegu",
  "Imago",
  "Impala",
  "Imperatorangel",
  "Imperialeagle",
  "Incatern",
  "Inchworm",
  "Indianabat",
  "Indiancow",
  "Indianelephant",
  "Indianglassfish",
  "Indianhare",
  "Indianjackal",
  "Indianpalmsquirrel",
  "Indianpangolin",
  "Indianrhinoceros",
  "Indianringneckparakeet",
  "Indianrockpython",
  "Indianskimmer",
  "Indianspinyloach",
  "Indigobunting",
  "Indigowingedparrot",
  "Indochinahogdeer",
  "Indochinesetiger",
  "Indri",
  "Indusriverdolphin",
  "Inexpectatumpleco",
  "Inganue",
  "Insect",
  "Intermediateegret",
  "Invisiblerail",
  "Iraniangroundjay",
  "Iridescentshark",
  "Iriomotecat",
  "Irishdraughthorse",
  "Irishredandwhitesetter",
  "Irishsetter",
  "Irishterrier",
  "Irishwaterspaniel",
  "Irishwolfhound",
  "Irrawaddydolphin",
  "Irukandjijellyfish",
  "Isabellineshrike",
  "Isabellinewheatear",
  "Islandcanary",
  "Islandwhistler",
  "Isopod",
  "Italianbrownbear",
  "Italiangreyhound",
  "Ivorybackedwoodswallow",
  "Ivorybilledwoodpecker",
  "Ivorygull",
  "Izuthrush",
  "Jabiru",
  "Jackal",
  "Jackrabbit",
  "Jaeger",
  "Jaguar",
  "Jaguarundi",
  "Janenschia",
  "Japanesebeetle",
  "Javalina",
  "Jay",
  "Jellyfish",
  "Jenny",
  "Jerboa",
  "Joey",
  "Johndory",
  "Juliabutterfly",
  "Jumpingbean",
  "Junco",
  "Junebug",
  "Kagu",
  "Kakapo",
  "Kakarikis",
  "Kangaroo",
  "Karakul",
  "Katydid",
  "Kawala",
  "Kentrosaurus",
  "Kestrel",
  "Kid",
  "Killdeer",
  "Killerwhale",
  "Killifish",
  "Kingbird",
  "Kingfisher",
  "Kinglet",
  "Kingsnake",
  "Kinkajou",
  "Kiskadee",
  "Kissingbug",
  "Kite",
  "Kitfox",
  "Kitten",
  "Kittiwake",
  "Kitty",
  "Kiwi",
  "Koala",
  "Koalabear",
  "Kob",
  "Kodiakbear",
  "Koi",
  "Komododragon",
  "Koodoo",
  "Kookaburra",
  "Kouprey",
  "Krill",
  "Kronosaurus",
  "Kudu",
  "Kusimanse",
  "Labradorretriever",
  "Lacewing",
  "Ladybird",
  "Ladybug",
  "Lamb",
  "Lamprey",
  "Langur",
  "Lark",
  "Larva",
  "Laughingthrush",
  "Lcont",
  "Leafbird",
  "Leafcutterant",
  "Leafhopper",
  "Leafwing",
  "Leech",
  "Lemming",
  "Lemur",
  "Leonberger",
  "Leopard",
  "Leopardseal",
  "Leveret",
  "Lhasaapso",
  "Liger",
  "Lightningbug",
  "Limpet",
  "Limpkin",
  "Ling",
  "Lion",
  "Lionfish",
  "Littlenightmonkeys",
  "Lizard",
  "Llama",
  "Lobo",
  "Lobster",
  "Locust",
  "Loggerheadturtle",
  "Longhorn",
  "Longhornbeetle",
  "Longspur",
  "Loon",
  "Lorikeet",
  "Loris",
  "Louse",
  "Lovebird",
  "Lowchen",
  "Lunamoth",
  "Lungfish",
  "Lynx",
  "Macaque",
  "Macaw",
  "Macropod",
  "Magpie",
  "Maiasaura",
  "Majungatholus",
  "Malamute",
  "Mallard",
  "Maltesedog",
  "Mamba",
  "Mamenchisaurus",
  "Mammal",
  "Mammoth",
  "Manatee",
  "Mandrill",
  "Mangabey",
  "Manta",
  "Mantaray",
  "Mantid",
  "Mantis",
  "Mantisray",
  "Manxcat",
  "Mara",
  "Marabou",
  "Marbledmurrelet",
  "Mare",
  "Marlin",
  "Marmoset",
  "Marmot",
  "Marten",
  "Martin",
  "Massasauga",
  "Massospondylus",
  "Mastiff",
  "Mastodon",
  "Mayfly",
  "Meadowhawk",
  "Meadowlark",
  "Mealworm",
  "Meerkat",
  "Megalosaurus",
  "Megaraptor",
  "Merganser",
  "Merlin",
  "Metalmarkbutterfly",
  "Metamorphosis",
  "Microvenator",
  "Midge",
  "Milksnake",
  "Milkweedbug",
  "Millipede",
  "Minibeast",
  "Mink",
  "Minnow",
  "Mite",
  "Moa",
  "Mockingbird",
  "Mole",
  "Mollies",
  "Mollusk",
  "Molly",
  "Monarch",
  "Mongoose",
  "Monkey",
  "Monkfish",
  "Monoclonius",
  "Montanoceratops",
  "Moorhen",
  "Moose",
  "Moray",
  "Morayeel",
  "Morpho",
  "Mosasaur",
  "Mosquito",
  "Moth",
  "Motmot",
  "Mouflon",
  "Mountaincat",
  "Mountainlion",
  "Mouse",
  "Mousebird",
  "Mudpuppy",
  "Mule",
  "Mullet",
  "Muntjac",
  "Murrelet",
  "Muskox",
  "Muskrat",
  "Mussaurus",
  "Mussel",
  "Mustang",
  "Mutt",
  "Myna",
  "Mynah",
  "Myotis",
  "Nabarlek",
  "Nag",
  "Naga",
  "Nagapies",
  "Nandine",
  "Nandoo",
  "Nandu",
  "Narwhal",
  "Narwhale",
  "Natterjacktoad",
  "Nauplius",
  "Nautilus",
  "Needlefish",
  "Needletail",
  "Nematode",
  "Nene",
  "Neonblueguppy",
  "Neonbluehermitcrab",
  "Neondwarfgourami",
  "Neonrainbowfish",
  "Neonredguppy",
  "Neontetra",
  "Nerka",
  "Nettlefish",
  "Newfoundlanddog",
  "Newt",
  "Newtnutria",
  "Nightcrawler",
  "Nighthawk",
  "Nightheron",
  "Nightingale",
  "Nightjar",
  "Nilgai",
  "Armadillo",
  "Noctilio",
  "Noctule",
  "Noddy",
  "Noolbenger",
  "Northerncardinals",
  "Northernelephantseal",
  "Northernflyingsquirrel",
  "Northernfurseal",
  "Northernpike",
  "Northernseahorse",
  "Northernspottedowl",
  "Norwaylobster",
  "Norwayrat",
  "Nubiangoat",
  "Nudibranch",
  "Numbat",
  "Nurseshark",
  "Nutcracker",
  "Nuthatch",
  "Nutria",
  "Nyala",
  "Ocelot",
  "Octopus",
  "Okapi",
  "Olingo",
  "Olm",
  "Opossum",
  "Orangutan",
  "Orca",
  "Oregonsilverspotbutterfly",
  "Oriole",
  "Oropendola",
  "Oropendula",
  "Oryx",
  "Osprey",
  "Ostracod",
  "Ostrich",
  "Otter",
  "Ovenbird",
  "Owl",
  "Owlbutterfly",
  "Ox",
  "Oxen",
  "Oxpecker",
  "Oyster",
  "Ozarkbigearedbat",
  "Paca",
  "Pachyderm",
  "Pacificparrotlet",
  "Paddlefish",
  "Paintedladybutterfly",
  "Panda",
  "Pangolin",
  "Panther",
  "Paperwasp",
  "Papillon",
  "Parakeet",
  "Parrot",
  "Partridge",
  "Peacock",
  "Peafowl",
  "Peccary",
  "Pekingese",
  "Pelican",
  "Pelicinuspetrel",
  "Penguin",
  "Perch",
  "Peregrinefalcon",
  "Pewee",
  "Phalarope",
  "Pharaohhound",
  "Pheasant",
  "Phoebe",
  "Phoenix",
  "Pigeon",
  "Piglet",
  "Pika",
  "Pike",
  "Pikeperch",
  "Pilchard",
  "Pinemarten",
  "Pinkriverdolphin",
  "Pinniped",
  "Pintail",
  "Pipistrelle",
  "Pipit",
  "Piranha",
  "Pitbull",
  "Pittabird",
  "Plainsqueaker",
  "Plankton",
  "Planthopper",
  "Platypus",
  "Plover",
  "Polarbear",
  "Polecat",
  "Polyp",
  "Polyturator",
  "Pomeranian",
  "Pondskater",
  "Pony",
  "Pooch",
  "Poodle",
  "Porcupine",
  "Porpoise",
  "Portuguesemanofwar",
  "Possum",
  "Prairiedog",
  "Prawn",
  "Prayingmantid",
  "Prayingmantis",
  "Primate",
  "Pronghorn",
  "Pseudodynerusquadrisectus",
  "Ptarmigan",
  "Pterodactyls",
  "Pterosaurs",
  "Puffer",
  "Pufferfish",
  "Puffin",
  "Pug",
  "Pullet",
  "Puma",
  "Pupa",
  "Pupfish",
  "Puppy",
  "Purplemarten",
  "Pygmy",
  "Python",
  "Quadrisectus",
  "Quagga",
  "Quahog",
  "Quail",
  "Queenalexandrasbirdwing",
  "Queenalexandrasbirdwingbutterfly",
  "Queenant",
  "Queenbee",
  "Queenconch",
  "Queenslandgrouper",
  "Queenslandheeler",
  "Queensnake",
  "Quelea",
  "Quetzal",
  "Quetzalcoatlus",
  "Quillback",
  "Quinquespinosus",
  "Quokka",
  "Quoll",
  "Rabbit",
  "Rabidsquirrel",
  "Raccoon",
  "Racer",
  "Racerunner",
  "Ragfish",
  "Rail",
  "Rainbowfish",
  "Rainbowlorikeet",
  "Rainbowtrout",
  "Ram",
  "Raptors",
  "Rasbora",
  "Rat",
  "Ratfish",
  "Rattail",
  "Rattlesnake",
  "Raven",
  "Ray",
  "Redhead",
  "Redheadedwoodpecker",
  "Redpoll",
  "Redstart",
  "Redtailedhawk",
  "Reindeer",
  "Reptile",
  "Reynard",
  "Rhea",
  "Rhesusmonkey",
  "Rhino",
  "Rhinoceros",
  "Rhinocerosbeetle",
  "Rhodesianridgeback",
  "Ringtailedlemur",
  "Ringworm",
  "Riograndeescuerzo",
  "Roach",
  "Roadrunner",
  "Roan",
  "Robberfly",
  "Robin",
  "Rockrat",
  "Rodent",
  "Roebuck",
  "Roller",
  "Rook",
  "Rooster",
  "Rottweiler",
  "Sable",
  "Sableantelope",
  "Sablefish",
  "Saiga",
  "Sakimonkey",
  "Salamander",
  "Salmon",
  "Saltwatercrocodile",
  "Sambar",
  "Samoyeddog",
  "Sandbarshark",
  "Sanddollar",
  "Sanderling",
  "Sandpiper",
  "Sapsucker",
  "Sardine",
  "Sawfish",
  "Scallop",
  "Scarab",
  "Scarletibis",
  "Scaup",
  "Schapendoes",
  "Schipperke",
  "Schnauzer",
  "Scorpion",
  "Scoter",
  "Screamer",
  "Seabird",
  "Seagull",
  "Seahog",
  "Seahorse",
  "Seal",
  "Sealion",
  "Seamonkey",
  "Seaslug",
  "Seaurchin",
  "Senegalpython",
  "Seriema",
  "Serpent",
  "Serval",
  "Shark",
  "Shearwater",
  "Sheep",
  "Sheldrake",
  "Shelduck",
  "Shibainu",
  "Shihtzu",
  "Shorebird",
  "Shoveler",
  "Shrew",
  "Shrike",
  "Shrimp",
  "Siamang",
  "Siamesecat",
  "Siberiantiger",
  "Sidewinder",
  "Sifaka",
  "Silkworm",
  "Silverfish",
  "Silverfox",
  "Silversidefish",
  "Siskin",
  "Skimmer",
  "Skipper",
  "Skua",
  "Skylark",
  "Sloth",
  "Slothbear",
  "Slug",
  "Smelts",
  "Smew",
  "Snail",
  "Snake",
  "Snipe",
  "Snoutbutterfly",
  "Snowdog",
  "Snowgeese",
  "Snowleopard",
  "Snowmonkey",
  "Snowyowl",
  "Sockeyesalmon",
  "Solenodon",
  "Solitaire",
  "Songbird",
  "Sora",
  "Southernhairnosedwombat",
  "Sow",
  "Spadefoot",
  "Sparrow",
  "Sphinx",
  "Spider",
  "Spidermonkey",
  "Spiketail",
  "Spittlebug",
  "Sponge",
  "Spoonbill",
  "Spotteddolphin",
  "Spreadwing",
  "Springbok",
  "Springpeeper",
  "Springtail",
  "Squab",
  "Squamata",
  "Squeaker",
  "Squid",
  "Squirrel",
  "Stag",
  "Stagbeetle",
  "Stallion",
  "Starfish",
  "Starling",
  "Steed",
  "Steer",
  "Stegosaurus",
  "Stickinsect",
  "Stickleback",
  "Stilt",
  "Stingray",
  "Stinkbug",
  "Stinkpot",
  "Stoat",
  "Stonefly",
  "Stork",
  "Stud",
  "Sturgeon",
  "Sugarglider",
  "Sulphurbutterfly",
  "Sunbear",
  "Sunbittern",
  "Sunfish",
  "Swallow",
  "Swallowtail",
  "Swallowtailbutterfly",
  "Swan",
  "Swellfish",
  "Swift",
  "Swordfish",
  "Tadpole",
  "Tahr",
  "Takin",
  "Tamarin",
  "Tanager",
  "Tapaculo",
  "Tapeworm",
  "Tapir",
  "Tarantula",
  "Tarpan",
  "Tarsier",
  "Taruca",
  "Tasmaniandevil",
  "Tasmaniantiger",
  "Tattler",
  "Tayra",
  "Teal",
  "Tegus",
  "Teledu",
  "Tench",
  "Tenrec",
  "Termite",
  "Tern",
  "Terrapin",
  "Terrier",
  "Thoroughbred",
  "Thrasher",
  "Thrip",
  "Thrush",
  "Thunderbird",
  "Thylacine",
  "Tick",
  "Tiger",
  "Tigerbeetle",
  "Tigermoth",
  "Tigershark",
  "Tilefish",
  "Tinamou",
  "Titi",
  "Titmouse",
  "Toad",
  "Toadfish",
  "Tomtit",
  "Topi",
  "Tortoise",
  "Toucan",
  "Towhee",
  "Tragopan",
  "Treecreeper",
  "Trex",
  "Triceratops",
  "Trogon",
  "Trout",
  "Trumpeterbird",
  "Trumpeterswan",
  "Tsetsefly",
  "Tuatara",
  "Tuna",
  "Turaco",
  "Turkey",
  "Turnstone",
  "Turtle",
  "Turtledove",
  "Uakari",
  "Ugandakob",
  "Uintagroundsquirrel",
  "Ulyssesbutterfly",
  "Umbrellabird",
  "Umbrette",
  "Unau",
  "Ungulate",
  "Unicorn",
  "Upupa",
  "Urchin",
  "Urial",
  "Uromastyxmaliensis",
  "Uromastyxspinipes",
  "Urson",
  "Urubu",
  "Urus",
  "Urutu",
  "Urva",
  "Utahprairiedog",
  "Vampirebat",
  "Vaquita",
  "Veery",
  "Velociraptor",
  "Velvetcrab",
  "Velvetworm",
  "Venomoussnake",
  "Verdin",
  "Vervet",
  "Viceroybutterfly",
  "Vicuna",
  "Viper",
  "Viperfish",
  "Vipersquid",
  "Vireo",
  "Virginiaopossum",
  "Vixen",
  "Vole",
  "Volvox",
  "Vulpesvelox",
  "Vulpesvulpes",
  "Vulture",
  "Walkingstick",
  "Wallaby",
  "Wallaroo",
  "Walleye",
  "Walrus",
  "Warbler",
  "Warthog",
  "Wasp",
  "Waterboatman",
  "Waterbuck",
  "Waterbuffalo",
  "Waterbug",
  "Waterdogs",
  "Waterdragons",
  "Watermoccasin",
  "Waterstrider",
  "Waterthrush",
  "Wattlebird",
  "Watussi",
  "Waxwing",
  "Weasel",
  "Weaverbird",
  "Weevil",
  "Westafricanantelope",
  "Whale",
  "Whapuku",
  "Whelp",
  "Whimbrel",
  "Whippet",
  "Whippoorwill",
  "Whitebeakeddolphin",
  "Whiteeye",
  "Whitepelican",
  "Whiterhino",
  "Whitetaileddeer",
  "Whitetippedreefshark",
  "Whooper",
  "Whoopingcrane",
  "Widgeon",
  "Widowspider",
  "Wildcat",
  "Wildebeast",
  "Wildebeest",
  "Willet",
  "Wireworm",
  "Wisent",
  "Wobbegongshark",
  "Wolf",
  "Wolfspider",
  "Wolverine",
  "Wombat",
  "Woodborer",
  "Woodchuck",
  "Woodnymphbutterfly",
  "Woodpecker",
  "Woodstorks",
  "Woollybearcaterpillar",
  "Worm",
  "Wrasse",
  "Wreckfish",
  "Wren",
  "Wrenchbird",
  "Wryneck",
  "Wuerhosaurus",
  "Wyvern",
  "Xanclomys",
  "Xanthareel",
  "Xantus",
  "Xantusmurrelet",
  "Xeme",
  "Xenarthra",
  "Xenoposeidon",
  "Xenops",
  "Xenopterygii",
  "Xenopus",
  "Xenotarsosaurus",
  "Xenurusunicinctus",
  "Xerus",
  "Xiaosaurus",
  "Xinjiangovenator",
  "Xiphias",
  "Xiphiasgladius",
  "Xiphosuran",
  "Xoloitzcuintli",
  "Xoni",
  "Xrayfish",
  "Xraytetra",
  "Xuanhanosaurus",
  "Xuanhuaceratops",
  "Xuanhuasaurus",
  "Yaffle",
  "Yak",
  "Yapok",
  "Yardant",
  "Yearling",
  "Yellowbelliedmarmot",
  "Yellowbellylizard",
  "Yellowhammer",
  "Yellowjacket",
  "Yellowlegs",
  "Yellowthroat",
  "Yellowwhitebutterfly",
  "Yeti",
  "Ynambu",
  "Yorkshireterrier",
  "Yosemitetoad",
  "Yucker",
  "Zander",
  "Zanzibardaygecko",
  "Zebra",
  "Zebradove",
  "Zebrafinch",
  "Zebrafish",
  "Zebralongwingbutterfly",
  "Zebraswallowtailbutterfly",
  "Zebratailedlizard",
  "Zebu",
  "Zenaida",
  "Zeren",
  "Zethusspinipes",
  "Zethuswasp",
  "Zigzagsalamander",
  "Zonetailedpigeon",
  "Zooplankton",
  "Zopilote",
  "Zorilla"
], dt = [
  "Able",
  "Absolute",
  "Academic",
  "Acceptable",
  "Acclaimed",
  "Accomplished",
  "Accurate",
  "Aching",
  "Acidic",
  "Acrobatic",
  "Adorable",
  "Adventurous",
  "Babyish",
  "Back",
  "Baggy",
  "Bare",
  "Basic",
  "Beautiful",
  "Belated",
  "Beloved",
  "Bitter",
  "Calculating",
  "Calm",
  "Candid",
  "Canine",
  "Capital",
  "Carefree",
  "Careful",
  "Careless",
  "Caring",
  "Cautious",
  "Cavernous",
  "Celebrated",
  "Charming",
  "Damp",
  "Dangerous",
  "Dapper",
  "Daring",
  "Dark",
  "Darling",
  "Dazzling",
  "Deadly",
  "Deafening",
  "Dear",
  "Dearest",
  "Each",
  "Eager",
  "Early",
  "Earnest",
  "Easy",
  "Easygoing",
  "Ecstatic",
  "Edible",
  "Educated",
  "Elderly",
  "Fabulous",
  "Failing",
  "Faint",
  "Fair",
  "Faithful",
  "Familiar",
  "Famous",
  "Fancy",
  "Fantastic",
  "Far",
  "Faraway",
  "Farflung",
  "Faroff",
  "Gargantuan",
  "Gaseous",
  "General",
  "Generous",
  "Gentle",
  "Genuine",
  "Giant",
  "Giddy",
  "Gigantic",
  "Hairy",
  "Half",
  "Handmade",
  "Handsome",
  "Handy",
  "Happy",
  "Happygolucky",
  "Hard",
  "Icky",
  "Icy",
  "Ideal",
  "Idealistic",
  "Identical",
  "Idle",
  "Idolized",
  "Ill",
  "Jaded",
  "Jagged",
  "Jampacked",
  "Kaleidoscopic",
  "Keen",
  "Lanky",
  "Large",
  "Last",
  "Lasting",
  "Lavish",
  "Lawful",
  "Madeup",
  "Magnificent",
  "Majestic",
  "Major",
  "Mammoth",
  "Marvelous",
  "Married",
  "Naive",
  "Narrow",
  "Nasty",
  "Natural",
  "Oblong",
  "Obvious",
  "Occasional",
  "Oily",
  "Palatable",
  "Pale",
  "Paltry",
  "Parallel",
  "Parched",
  "Partial",
  "Passionate",
  "Past",
  "Pastel",
  "Peaceful",
  "Peppery",
  "Perfect",
  "Perfumed",
  "Quaint",
  "Qualified",
  "Radiant",
  "Ragged",
  "Rapid",
  "Rare",
  "Rash",
  "Raw",
  "Recent",
  "Reckless",
  "Rectangular",
  "Safe",
  "Salty",
  "Same",
  "Sandy",
  "Sane",
  "Sarcastic",
  "Sardonic",
  "Satisfied",
  "Scaly",
  "Scarce",
  "Scary",
  "Scented",
  "Scholarly",
  "Scientific",
  "Scornful",
  "Scratchy",
  "Scrawny",
  "Second",
  "Secondary",
  "Secret",
  "Selfassured",
  "Selfreliant",
  "Sentimental",
  "Single",
  "Talkative",
  "Tall",
  "Tame",
  "Tan",
  "Tangible",
  "Tart",
  "Tasty",
  "Tattered",
  "Taut",
  "Tedious",
  "Teeming",
  "Ultimate",
  "Unaware",
  "Uncommon",
  "Unconscious",
  "Understated",
  "Unequaled",
  "Vacant",
  "Vague",
  "Vain",
  "Valid",
  "Wan",
  "Warlike",
  "Warm",
  "Warmhearted",
  "Warped",
  "Wary",
  "Wasteful",
  "Watchful",
  "Waterlogged",
  "Watery",
  "Wavy",
  "Weak",
  "Weird",
  "Yawning",
  "Yearly",
  "Zany",
  "Active",
  "Actual",
  "Adept",
  "Admirable",
  "Admired",
  "Adolescent",
  "Adorable",
  "Adored",
  "Advanced",
  "Affectionate",
  "Afraid",
  "Aged",
  "Aggravating",
  "Beneficial",
  "Best",
  "Better",
  "Bewitched",
  "Big",
  "Bighearted",
  "Biodegradable",
  "Bitesized",
  "Cheerful",
  "Cheery",
  "Chief",
  "Chilly",
  "Chubby",
  "Circular",
  "Classic",
  "Clean",
  "Clear",
  "Clearcut",
  "Clever",
  "Close",
  "Closed",
  "Decent",
  "Decimal",
  "Decisive",
  "Deep",
  "Defenseless",
  "Defensive",
  "Defiant",
  "Deficient",
  "Definite",
  "Definitive",
  "Delayed",
  "Delectable",
  "Delicious",
  "Elaborate",
  "Elastic",
  "Elated",
  "Electric",
  "Elegant",
  "Elementary",
  "Elliptical",
  "Fast",
  "Fatal",
  "Favorable",
  "Favorite",
  "Fearless",
  "Feisty",
  "Feline",
  "Few",
  "Fickle",
  "Gifted",
  "Giving",
  "Glamorous",
  "Glaring",
  "Glass",
  "Gleaming",
  "Gleeful",
  "Glistening",
  "Glittering",
  "Gross",
  "Hardtofind",
  "Harmful",
  "Harmless",
  "Harmonious",
  "Harsh",
  "Hasty",
  "Haunting",
  "Illustrious",
  "Imaginary",
  "Imaginative",
  "Immaculate",
  "Immaterial",
  "Immediate",
  "Immense",
  "Impassioned",
  "Jaunty",
  "Jealous",
  "Jittery",
  "Key",
  "Kind",
  "Leading",
  "Leafy",
  "Lean",
  "Left",
  "Legal",
  "Legitimate",
  "Light",
  "Massive",
  "Mature",
  "Meager",
  "Mealy",
  "Mean",
  "Measly",
  "Meaty",
  "Medical",
  "Mediocre",
  "Nautical",
  "Near",
  "Neat",
  "Necessary",
  "Needy",
  "Odd",
  "Oddball",
  "Offbeat",
  "Official",
  "Old",
  "Periodic",
  "Perky",
  "Personal",
  "Pertinent",
  "Pesky",
  "Pessimistic",
  "Petty",
  "Physical",
  "Piercing",
  "Pink",
  "Pitiful",
  "Plain",
  "Quarrelsome",
  "Quarterly",
  "Ready",
  "Real",
  "Realistic",
  "Reasonable",
  "Red",
  "Reflecting",
  "Regal",
  "Regular",
  "Separate",
  "Serene",
  "Serious",
  "Serpentine",
  "Several",
  "Severe",
  "Shabby",
  "Shadowy",
  "Shady",
  "Shallow",
  "Sharp",
  "Shimmering",
  "Shiny",
  "Shocked",
  "Shocking",
  "Shoddy",
  "Short",
  "Shortterm",
  "Showy",
  "Shrill",
  "Shy",
  "Silent",
  "Silky",
  "Tempting",
  "Tender",
  "Tense",
  "Tepid",
  "Terrific",
  "Testy",
  "Thankful",
  "That",
  "These",
  "Tremendous",
  "Uneven",
  "Unfinished",
  "Unfolded",
  "Uniform",
  "Unique",
  "Valuable",
  "Vapid",
  "Variable",
  "Vast",
  "Velvety",
  "Wealthy",
  "Weary",
  "Webbed",
  "Wee",
  "Weekly",
  "Weepy",
  "Weighty",
  "Welcome",
  "Welldocumented",
  "Yellow",
  "Zealous",
  "Aggressive",
  "Agile",
  "Agitated",
  "Agonizing",
  "Agreeable",
  "Ajar",
  "Alarmed",
  "Alarming",
  "Alert",
  "Alienated",
  "Alive",
  "All",
  "Altruistic",
  "Bland",
  "Blank",
  "Blaring",
  "Bleak",
  "Blind",
  "Blissful",
  "Blond",
  "Blue",
  "Blushing",
  "Cloudy",
  "Clueless",
  "Clumsy",
  "Cluttered",
  "Coarse",
  "Cold",
  "Colorful",
  "Colorless",
  "Colossal",
  "Comfortable",
  "Common",
  "Compassionate",
  "Competent",
  "Complete",
  "Delightful",
  "Demanding",
  "Dense",
  "Dental",
  "Dependable",
  "Dependent",
  "Descriptive",
  "Deserted",
  "Detailed",
  "Determined",
  "Devoted",
  "Different",
  "Embellished",
  "Eminent",
  "Emotional",
  "Empty",
  "Enchanted",
  "Enchanting",
  "Energetic",
  "Enlightened",
  "Enormous",
  "Fine",
  "Finished",
  "Firm",
  "First",
  "Firsthand",
  "Fitting",
  "Fixed",
  "Flaky",
  "Flamboyant",
  "Flashy",
  "Flat",
  "Flawless",
  "Flickering",
  "Gloomy",
  "Glorious",
  "Glossy",
  "Glum",
  "Golden",
  "Good",
  "Goodnatured",
  "Gorgeous",
  "Graceful",
  "Healthy",
  "Heartfelt",
  "Hearty",
  "Heavenly",
  "Heavy",
  "Hefty",
  "Helpful",
  "Humongous",
  "Impartial",
  "Impeccable",
  "Imperfect",
  "Imperturbable",
  "Important",
  "Impossible",
  "Impractical",
  "Impressionable",
  "Impressive",
  "Improbable",
  "Joint",
  "Jolly",
  "Jovial",
  "Juvenile",
  "Kindhearted",
  "Kindly",
  "Lighthearted",
  "Likable",
  "Likely",
  "Limited",
  "Limp",
  "Limping",
  "Linear",
  "Lined",
  "Liquid",
  "Medium",
  "Meek",
  "Mellow",
  "Melodic",
  "Memorable",
  "Menacing",
  "Merry",
  "Messy",
  "Metallic",
  "Mild",
  "Negative",
  "Neglected",
  "Negligible",
  "Neighboring",
  "Nervous",
  "New",
  "Oldfashioned",
  "Only",
  "Open",
  "Optimal",
  "Optimistic",
  "Opulent",
  "Plaintive",
  "Plastic",
  "Playful",
  "Pleasant",
  "Pleased",
  "Pleasing",
  "Plump",
  "Plush",
  "Pointed",
  "Pointless",
  "Poised",
  "Polished",
  "Polite",
  "Political",
  "Pungent",
  "Queasy",
  "Querulous",
  "Reliable",
  "Relieved",
  "Remarkable",
  "Remorseful",
  "Remote",
  "Repentant",
  "Required",
  "Respectful",
  "Responsible",
  "Silly",
  "Silver",
  "Similar",
  "Simple",
  "Simplistic",
  "Sizzling",
  "Skeletal",
  "Skinny",
  "Sleepy",
  "Slight",
  "Slim",
  "Slimy",
  "Slippery",
  "Slow",
  "Slushy",
  "Small",
  "Smart",
  "Smoggy",
  "Smooth",
  "Smug",
  "Snappy",
  "Snarling",
  "Sneaky",
  "Sniveling",
  "Snoopy",
  "Thick",
  "Thin",
  "Third",
  "Thirsty",
  "This",
  "Thorny",
  "Thorough",
  "Those",
  "Thoughtful",
  "Threadbare",
  "United",
  "Unkempt",
  "Unknown",
  "Unlined",
  "Unnatural",
  "Unrealistic",
  "Venerated",
  "Vengeful",
  "Verifiable",
  "Vibrant",
  "Vicious",
  "Wellgroomed",
  "Wellinformed",
  "Welllit",
  "Wellmade",
  "Welloff",
  "Welltodo",
  "Wellworn",
  "Wet",
  "Which",
  "Whimsical",
  "Whirlwind",
  "Whispered",
  "Worse",
  "Writhing",
  "Yellowish",
  "Zesty",
  "Amazing",
  "Ambitious",
  "Ample",
  "Amused",
  "Amusing",
  "Anchored",
  "Ancient",
  "Angelic",
  "Angry",
  "Anguished",
  "Animated",
  "Annual",
  "Another",
  "Antique",
  "Bogus",
  "Boiling",
  "Bold",
  "Bony",
  "Boring",
  "Bossy",
  "Both",
  "Bouncy",
  "Bountiful",
  "Bowed",
  "Complex",
  "Complicated",
  "Composed",
  "Concerned",
  "Concrete",
  "Confused",
  "Conscious",
  "Considerate",
  "Constant",
  "Content",
  "Conventional",
  "Cooked",
  "Cool",
  "Cooperative",
  "Difficult",
  "Digital",
  "Diligent",
  "Dim",
  "Dimpled",
  "Dimwitted",
  "Direct",
  "Discrete",
  "Entire",
  "Envious",
  "Equal",
  "Equatorial",
  "Essential",
  "Esteemed",
  "Ethical",
  "Euphoric",
  "Flimsy",
  "Flippant",
  "Flowery",
  "Fluffy",
  "Fluid",
  "Flustered",
  "Focused",
  "Fond",
  "Foolhardy",
  "Foolish",
  "Forceful",
  "Forked",
  "Formal",
  "Forsaken",
  "Gracious",
  "Grand",
  "Grandiose",
  "Granular",
  "Grateful",
  "Grave",
  "Gray",
  "Great",
  "Greedy",
  "Green",
  "Hidden",
  "High",
  "Highlevel",
  "Hilarious",
  "Hoarse",
  "Hollow",
  "Homely",
  "Inborn",
  "Incomparable",
  "Incompatible",
  "Incomplete",
  "Inconsequential",
  "Incredible",
  "Indelible",
  "Indolent",
  "Inexperienced",
  "Infamous",
  "Infantile",
  "Joyful",
  "Joyous",
  "Jubilant",
  "Klutzy",
  "Knobby",
  "Little",
  "Live",
  "Lively",
  "Livid",
  "Lone",
  "Long",
  "Milky",
  "Mindless",
  "Miniature",
  "Minor",
  "Minty",
  "Misguided",
  "Misty",
  "Mixed",
  "Next",
  "Nice",
  "Nifty",
  "Nimble",
  "Nippy",
  "Orange",
  "Orderly",
  "Ordinary",
  "Organic",
  "Ornate",
  "Ornery",
  "Poor",
  "Popular",
  "Portly",
  "Posh",
  "Positive",
  "Possible",
  "Potable",
  "Powerful",
  "Powerless",
  "Practical",
  "Precious",
  "Present",
  "Prestigious",
  "Questionable",
  "Quick",
  "Revolving",
  "Rewarding",
  "Rich",
  "Right",
  "Rigid",
  "Ringed",
  "Ripe",
  "Sociable",
  "Soft",
  "Soggy",
  "Solid",
  "Somber",
  "Some",
  "Sophisticated",
  "Sore",
  "Sorrowful",
  "Soulful",
  "Soupy",
  "Sour",
  "Spanish",
  "Sparkling",
  "Sparse",
  "Specific",
  "Spectacular",
  "Speedy",
  "Spherical",
  "Spicy",
  "Spiffy",
  "Spirited",
  "Spiteful",
  "Splendid",
  "Spotless",
  "Spotted",
  "Spry",
  "Thrifty",
  "Thunderous",
  "Tidy",
  "Tight",
  "Timely",
  "Tinted",
  "Tiny",
  "Tired",
  "Torn",
  "Total",
  "Unripe",
  "Unruly",
  "Unselfish",
  "Unsightly",
  "Unsteady",
  "Unsung",
  "Untidy",
  "Untimely",
  "Untried",
  "Victorious",
  "Vigilant",
  "Vigorous",
  "Villainous",
  "Violet",
  "Whole",
  "Whopping",
  "Wicked",
  "Wide",
  "Wideeyed",
  "Wiggly",
  "Wild",
  "Willing",
  "Wilted",
  "Winding",
  "Windy",
  "Young",
  "Zigzag",
  "Anxious",
  "Any",
  "Apprehensive",
  "Appropriate",
  "Apt",
  "Arctic",
  "Arid",
  "Aromatic",
  "Artistic",
  "Assured",
  "Astonishing",
  "Athletic",
  "Brave",
  "Breakable",
  "Brief",
  "Bright",
  "Brilliant",
  "Brisk",
  "Broken",
  "Bronze",
  "Brown",
  "Bruised",
  "Coordinated",
  "Corny",
  "Corrupt",
  "Costly",
  "Courageous",
  "Courteous",
  "Crafty",
  "Crazy",
  "Creamy",
  "Creative",
  "Creepy",
  "Crisp",
  "Dirty",
  "Disguised",
  "Distant",
  "Distant",
  "Distinct",
  "Distorted",
  "Dizzy",
  "Dopey",
  "Downright",
  "Dreary",
  "Even",
  "Evergreen",
  "Everlasting",
  "Every",
  "Evil",
  "Exalted",
  "Excellent",
  "Excitable",
  "Exemplary",
  "Exhausted",
  "Forthright",
  "Fortunate",
  "Fragrant",
  "Frail",
  "Frank",
  "Frayed",
  "Free",
  "French",
  "Frequent",
  "Fresh",
  "Friendly",
  "Frightened",
  "Frightening",
  "Gregarious",
  "Grim",
  "Grimy",
  "Gripping",
  "Grizzled",
  "Grouchy",
  "Grounded",
  "Honest",
  "Honorable",
  "Honored",
  "Hopeful",
  "Hospitable",
  "Hot",
  "Huge",
  "Infatuated",
  "Inferior",
  "Infinite",
  "Informal",
  "Innocent",
  "Insecure",
  "Insignificant",
  "Insistent",
  "Instructive",
  "Insubstantial",
  "Judicious",
  "Juicy",
  "Jumbo",
  "Knotty",
  "Knowing",
  "Knowledgeable",
  "Longterm",
  "Loose",
  "Lopsided",
  "Lost",
  "Loud",
  "Lovable",
  "Lovely",
  "Loving",
  "Modern",
  "Modest",
  "Moist",
  "Monthly",
  "Monumental",
  "Moral",
  "Mortified",
  "Motionless",
  "Nocturnal",
  "Noisy",
  "Nonstop",
  "Normal",
  "Notable",
  "Noted",
  "Original",
  "Other",
  "Our",
  "Outgoing",
  "Outlandish",
  "Outlying",
  "Precious",
  "Pretty",
  "Previous",
  "Pricey",
  "Prickly",
  "Primary",
  "Prime",
  "Pristine",
  "Private",
  "Prize",
  "Probable",
  "Productive",
  "Profitable",
  "Quickwitted",
  "Quiet",
  "Quintessential",
  "Roasted",
  "Robust",
  "Rosy",
  "Rotating",
  "Rotten",
  "Rough",
  "Round",
  "Rowdy",
  "Square",
  "Squeaky",
  "Squiggly",
  "Stable",
  "Staid",
  "Stained",
  "Stale",
  "Standard",
  "Starchy",
  "Stark",
  "Starry",
  "Steel",
  "Steep",
  "Sticky",
  "Stiff",
  "Stimulating",
  "Stingy",
  "Stormy",
  "Strange",
  "Strict",
  "Strident",
  "Striking",
  "Striped",
  "Strong",
  "Studious",
  "Stunning",
  "Tough",
  "Tragic",
  "Trained",
  "Treasured",
  "Tremendous",
  "Triangular",
  "Tricky",
  "Trifling",
  "Trim",
  "Untrue",
  "Unused",
  "Unusual",
  "Unwelcome",
  "Unwieldy",
  "Unwilling",
  "Unwitting",
  "Unwritten",
  "Upbeat",
  "Virtual",
  "Virtuous",
  "Visible",
  "Winged",
  "Wiry",
  "Wise",
  "Witty",
  "Wobbly",
  "Woeful",
  "Wonderful",
  "Wooden",
  "Woozy",
  "Wordy",
  "Worldly",
  "Worn",
  "Youthful",
  "Attached",
  "Attentive",
  "Attractive",
  "Austere",
  "Authentic",
  "Authorized",
  "Automatic",
  "Avaricious",
  "Average",
  "Aware",
  "Awesome",
  "Awful",
  "Awkward",
  "Bubbly",
  "Bulky",
  "Bumpy",
  "Buoyant",
  "Burdensome",
  "Burly",
  "Bustling",
  "Busy",
  "Buttery",
  "Buzzing",
  "Critical",
  "Crooked",
  "Crowded",
  "Crushing",
  "Cuddly",
  "Cultivated",
  "Cultured",
  "Cumbersome",
  "Curly",
  "Curvy",
  "Cute",
  "Cylindrical",
  "Doting",
  "Double",
  "Downright",
  "Drab",
  "Drafty",
  "Dramatic",
  "Dry",
  "Dual",
  "Dutiful",
  "Excited",
  "Exciting",
  "Exotic",
  "Expensive",
  "Experienced",
  "Expert",
  "Extralarge",
  "Extraneous",
  "Extrasmall",
  "Extroverted",
  "Frilly",
  "Frivolous",
  "Frizzy",
  "Front",
  "Frosty",
  "Frozen",
  "Frugal",
  "Fruitful",
  "Full",
  "Fumbling",
  "Functional",
  "Funny",
  "Fussy",
  "Fuzzy",
  "Growing",
  "Growling",
  "Grown",
  "Grubby",
  "Grumpy",
  "Guilty",
  "Gullible",
  "Gummy",
  "Humble",
  "Humming",
  "Hungry",
  "Husky",
  "Intelligent",
  "Intent",
  "Intentional",
  "Interesting",
  "Internal",
  "International",
  "Intrepid",
  "Ironclad",
  "Irresponsible",
  "Itchy",
  "Jumpy",
  "Junior",
  "Known",
  "Kooky",
  "Low",
  "Loyal",
  "Lucky",
  "Lumbering",
  "Luminous",
  "Lumpy",
  "Lustrous",
  "Luxurious",
  "Mountainous",
  "Muddy",
  "Muffled",
  "Mundane",
  "Murky",
  "Mushy",
  "Musty",
  "Mysterious",
  "Noteworthy",
  "Novel",
  "Noxious",
  "Numb",
  "Nutritious",
  "Nutty",
  "Outrageous",
  "Outstanding",
  "Oval",
  "Overcooked",
  "Overdue",
  "Overjoyed",
  "Profuse",
  "Proper",
  "Proud",
  "Prudent",
  "Punctual",
  "Puny",
  "Pure",
  "Purple",
  "Pushy",
  "Puzzled",
  "Puzzling",
  "Quirky",
  "Quixotic",
  "Quizzical",
  "Royal",
  "Rubbery",
  "Ruddy",
  "Rundown",
  "Runny",
  "Rural",
  "Rusty",
  "Stupendous",
  "Sturdy",
  "Stylish",
  "Subdued",
  "Substantial",
  "Subtle",
  "Suburban",
  "Sudden",
  "Sugary",
  "Sunny",
  "Super",
  "Superb",
  "Superficial",
  "Superior",
  "Supportive",
  "Surefooted",
  "Surprised",
  "Suspicious",
  "Svelte",
  "Sweaty",
  "Sweet",
  "Sweltering",
  "Swift",
  "Sympathetic",
  "Trivial",
  "Troubled",
  "Trusting",
  "Trustworthy",
  "Trusty",
  "Truthful",
  "Tubby",
  "Turbulent",
  "Twin",
  "Upright",
  "Upset",
  "Urban",
  "Usable",
  "Used",
  "Useful",
  "Useless",
  "Utilized",
  "Utter",
  "Vital",
  "Vivacious",
  "Vivid",
  "Voluminous",
  "Worst",
  "Worthwhile",
  "Worthy",
  "Wrathful",
  "Wry",
  "Yummy",
  "True",
  "Aliceblue",
  "Aqua",
  "Aquamarine",
  "Azure",
  "Beige",
  "Bisque",
  "Blanchedalmond",
  "Blue",
  "Blueviolet",
  "Brown",
  "Burlywood",
  "Cadetblue",
  "Chartreuse",
  "Chocolate",
  "Coral",
  "Cornflowerblue",
  "Cornsilk",
  "Crimson",
  "Cyan",
  "Darkblue",
  "Darkcyan",
  "Darkgoldenrod",
  "Darkgray",
  "Darkgreen",
  "Darkgrey",
  "Darkkhaki",
  "Darkmagenta",
  "Darkolivegreen",
  "Darkorange",
  "Darkorchid",
  "Darkred",
  "Darksalmon",
  "Darkseagreen",
  "Darkslateblue",
  "Darkslategray",
  "Darkslategrey",
  "Darkturquoise",
  "Darkviolet",
  "Deeppink",
  "Deepskyblue",
  "Dimgray",
  "Dimgrey",
  "Dodgerblue",
  "Firebrick",
  "Floralwhite",
  "Forestgreen",
  "Fractal",
  "Fuchsia",
  "Gainsboro",
  "Ghostwhite",
  "Gold",
  "Goldenrod",
  "Gray",
  "Green",
  "Greenyellow",
  "Honeydew",
  "Hotpink",
  "Indianred",
  "Indigo",
  "Ivory",
  "Khaki",
  "Lavender",
  "Lavenderblush",
  "Lawngreen",
  "Lemonchiffon",
  "Lightblue",
  "Lightcoral",
  "Lightcyan",
  "Lightgoldenrod",
  "Lightgoldenrodyellow",
  "Lightgray",
  "Lightgreen",
  "Lightgrey",
  "Lightpink",
  "Lightsalmon",
  "Lightseagreen",
  "Lightskyblue",
  "Lightslateblue",
  "Lightslategray",
  "Lightsteelblue",
  "Lightyellow",
  "Lime",
  "Limegreen",
  "Linen",
  "Magenta",
  "Maroon",
  "Mediumaquamarine",
  "Mediumblue",
  "Mediumforestgreen",
  "Mediumgoldenrod",
  "Mediumorchid",
  "Mediumpurple",
  "Mediumseagreen",
  "Mediumslateblue",
  "Mediumspringgreen",
  "Mediumturquoise",
  "Mediumvioletred",
  "Midnightblue",
  "Mintcream",
  "Mistyrose",
  "Moccasin",
  "Navajowhite",
  "Navy",
  "Navyblue",
  "Oldlace",
  "Olive",
  "Olivedrab",
  "Opaque",
  "Orange",
  "Orangered",
  "Orchid",
  "Palegoldenrod",
  "Palegreen",
  "Paleturquoise",
  "Palevioletred",
  "Papayawhip",
  "Peachpuff",
  "Peru",
  "Pink",
  "Plum",
  "Powderblue",
  "Purple",
  "Red",
  "Rosybrown",
  "Royalblue",
  "Saddlebrown",
  "Salmon",
  "Sandybrown",
  "Seagreen",
  "Seashell",
  "Sienna",
  "Silver",
  "Skyblue",
  "Slateblue",
  "Slategray",
  "Slategrey",
  "Snow",
  "Springgreen",
  "Steelblue",
  "Tan",
  "Teal",
  "Thistle",
  "Tomato",
  "Transparent",
  "Turquoise",
  "Violet",
  "Violetred",
  "Wheat",
  "Whitesmoke",
  "Yellow",
  "Yellowgreen"
], Ai = [
  "f",
  // hexadecimal
  "z"
  // base58btc
], Ci = [
  231
  // secp256k1-pub (compressed) (0xe7)
];
function ni(r, i = { compress: !0 }) {
  const e = r.replace(/^0[xX]/, "f"), n = e[0];
  if (!Ai.includes(n))
    throw new Error("Invalid public key multibase code");
  let s;
  switch (n) {
    case "z": {
      const c = Xa.decode(e), u = yi.decode(c), m = u[0], f = u[1];
      if (!Ci.includes(m))
        throw new Error("Invalid public key multicodec code");
      s = Wa(
        c.slice(f)
      );
      break;
    }
    case "f": {
      s = e.slice(1);
      break;
    }
    default:
      throw new Error("Unsupported public key multicodec code");
  }
  return `0x${Qa.fromHex(s).toHex(i.compress)}`;
}
function Vr(r) {
  const i = Pt(
    ni(r).replace(/^0[xX]/, "")
  );
  return Xa.encode(new Uint8Array([231, 1, ...i]));
}
function zr(r, i) {
  if (r.length !== 65)
    throw new Error("Signature must be 65 bytes long");
  if (r[64] >= 4)
    throw new Error("Recovery id must be less than 4");
  const e = r.slice(0, 64), n = r.slice(-1);
  return mi(ut(i), e, Number(n));
}
async function Oi(r, i) {
  const e = ti(r), n = ut(e), [s, c] = await di(n, i, {
    recovered: !0,
    der: !1
  });
  return Wr(s, new Uint8Array([c]));
}
function pi(r, i, e) {
  const n = ti(i), s = ut(n);
  let c;
  if (e)
    c = e.replace(/^0[xX]/, "");
  else {
    const u = zr(r, n);
    c = Wa(u);
  }
  return hi(r.slice(0, -1), s, c);
}
function ti(r) {
  return r instanceof Uint8Array ? r : Et(r);
}
var Rn;
class ya {
  constructor(i, e) {
    T(this, Rn);
    t(this, "privateKey");
    t(this, "publicKey");
    t(this, "chatKey");
    t(this, "username");
    t(this, "ensName");
    t(this, "membership");
    t(this, "description");
    E(this, Rn, i);
    const n = e ? Pt(e.privateKey) : Ei.randomPrivateKey(), s = Ti(n);
    this.privateKey = Yn(n), this.publicKey = Yn(s), this.chatKey = Vr("0x" + this.publicKey), this.username = ei("0x" + this.publicKey), this.membership = e ? e.membership : "none";
  }
  get link() {
    return ja(this.chatKey);
  }
  async sign(i) {
    return await Oi(i, this.privateKey);
  }
  verify(i, e) {
    return pi(i, e, this.publicKey);
  }
  updateMembership(i) {
    const e = i.isMember("0x" + this.publicKey);
    switch (this.membership) {
      case "none": {
        i.requestToJoin(), this.membership = "requested", o(this, Rn).account = this;
        return;
      }
      case "approved": {
        e === !1 && (this.membership = "kicked", o(this, Rn).account = this);
        return;
      }
      case "requested": {
        e && (this.membership = "approved", o(this, Rn).account = this);
        return;
      }
    }
  }
}
Rn = new WeakMap();
var Wn, C, Jn;
class bi {
  constructor(i) {
    T(this, Wn);
    T(this, C);
    T(this, Jn);
    t(this, "getLatest", () => {
      const i = [], e = /* @__PURE__ */ new Map();
      let n = 0;
      for (const s of o(this, C).values()) {
        if (s.type === "message") {
          const c = s.value.chatUuid, u = e.get(c);
          let m = u?.count ?? 0;
          const f = s.isMention || s.isReply;
          if (f && (m++, n++), u ? u.count = m : e.set(c, { count: m }), !f)
            continue;
        }
        i.push(s);
      }
      return i.sort((s, c) => s.value.clock > c.value.clock ? -1 : s.value.clock < c.value.clock ? 1 : 0), {
        // todo?: group notifications (all, mentions, replies)
        notifications: i,
        unreadChats: e,
        totalCount: n
      };
    });
    t(this, "addMessageNotification", (i, e) => {
      let n, s;
      if (o(this, Wn).account) {
        const c = `0x${o(this, Wn).account.publicKey}`;
        n = i.text.includes(c), s = e?.signer === c;
      }
      o(this, C).add({
        type: "message",
        value: i,
        isMention: n,
        isReply: s
      }), this.emitLatest();
    });
    // todo?: also calls `clearChatNotifications` (on non-action items/notifications)?
    // markAllAsRead = () => {}
    // todo?: for example from chat with red bar in UI indicating start
    // markChatNotificationsAsUnreadSince = (category, id) => {}
    // todo?: rename to `clearChatNotifications`; separate (button) from `markAllAsRead`?
    // todo?: merge with `removeChatNotifications`; together with `notification.type` condition
    /**
     * Removes all notifications.
     */
    t(this, "removeNotifications", (i) => {
      if (i === "all")
        for (const e of o(this, C)) {
          const { isMention: n, isReply: s } = e;
          (n || s) && o(this, C).delete(e);
        }
      else i === "mentions" ? o(this, C).forEach((e) => {
        e.isMention && o(this, C).delete(e);
      }) : i === "replies" && o(this, C).forEach((e) => {
        e.isReply && o(this, C).delete(e);
      });
      this.emitLatest();
    });
    // todo?: call from UI on ESC
    // todo?: call from UI if scrolled all the way to the end
    /**
     * Removes chat message notifications from the Activity Center. For example,
     * on only opening or after scrolling to the end.
     */
    t(this, "removeChatNotifications", (i) => {
      for (const e of o(this, C))
        e.type === "message" && e.value.chatUuid === i && o(this, C).delete(e);
      this.emitLatest();
    });
    t(this, "emitLatest", () => {
      const i = this.getLatest();
      o(this, Jn).forEach((e) => e(i));
    });
    t(this, "onChange", (i) => (o(this, Jn).add(i), () => {
      o(this, Jn).delete(i);
    }));
    E(this, Wn, i), E(this, C, /* @__PURE__ */ new Set()), E(this, Jn, /* @__PURE__ */ new Set());
  }
}
Wn = new WeakMap(), C = new WeakMap(), Jn = new WeakMap();
function Na(r, i) {
  const e = {};
  return Object.entries(r).reduce((s, [c, u]) => (i[c] || (s[c] = u), s), e);
}
function Bi(r, i) {
  const e = {}, n = [];
  for (const s of Object.keys(r))
    i[s] || n.push(s);
  for (const s of Object.keys(i))
    r[s] || (e[s] = i[s]);
  return { added: e, removed: n };
}
var bn = /* @__PURE__ */ ((r) => (r[r.NO_ONE = 0] = "NO_ONE", r[r.IDVERIFIED_CONTACTS = 1] = "IDVERIFIED_CONTACTS", r[r.CONTACTS = 2] = "CONTACTS", r[r.EVERYONE = 3] = "EVERYONE", r))(bn || {});
a.util.setEnumType(
  bn,
  "ProfileShowcaseVisibility",
  [
    { no: 0, name: "PROFILE_SHOWCASE_VISIBILITY_NO_ONE" },
    { no: 1, name: "PROFILE_SHOWCASE_VISIBILITY_IDVERIFIED_CONTACTS" },
    { no: 2, name: "PROFILE_SHOWCASE_VISIBILITY_CONTACTS" },
    { no: 3, name: "PROFILE_SHOWCASE_VISIBILITY_EVERYONE" }
  ]
);
const te = class te extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string community_id = 1;
     */
    t(this, "communityId", "");
    /**
     * @generated from field: uint32 order = 2;
     */
    t(this, "order", 0);
    /**
     * @generated from field: bytes grant = 3;
     */
    t(this, "grant", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new te().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new te().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new te().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(te, e, n);
  }
};
t(te, "runtime", a), t(te, "typeName", "ProfileShowcaseCommunity"), t(te, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let nr = te;
const re = class re extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string address = 1;
     */
    t(this, "address", "");
    /**
     * @generated from field: string name = 2;
     */
    t(this, "name", "");
    /**
     * @generated from field: string color_id = 3;
     */
    t(this, "colorId", "");
    /**
     * @generated from field: string emoji = 4;
     */
    t(this, "emoji", "");
    /**
     * @generated from field: uint32 order = 5;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new re().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new re().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new re().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(re, e, n);
  }
};
t(re, "runtime", a), t(re, "typeName", "ProfileShowcaseAccount"), t(re, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "address",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "color_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "emoji",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let tr = re;
const ae = class ae extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string uid = 1 [deprecated = true];
     * @deprecated
     */
    t(this, "uid", "");
    /**
     * @generated from field: uint32 order = 2;
     */
    t(this, "order", 0);
    /**
     * @generated from field: string contract_address = 3;
     */
    t(this, "contractAddress", "");
    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    t(this, "communityId", "");
    /**
     * @generated from field: uint64 chain_id = 5;
     */
    t(this, "chainId", d.zero);
    /**
     * @generated from field: string token_id = 6;
     */
    t(this, "tokenId", "");
    /**
     * @generated from field: string account_address = 7 [deprecated = true];
     * @deprecated
     */
    t(this, "accountAddress", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ae().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ae().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ae().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ae, e, n);
  }
};
t(ae, "runtime", a), t(ae, "typeName", "ProfileShowcaseCollectible"), t(ae, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "uid",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "contract_address",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "community_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "chain_id",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 6,
    name: "token_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "account_address",
    kind: "scalar",
    T: 9
  }
]));
let rr = ae;
const ie = class ie extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string symbol = 1;
     */
    t(this, "symbol", "");
    /**
     * @generated from field: uint32 order = 2;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ie().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ie().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ie().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(ie, e, n);
  }
};
t(ie, "runtime", a), t(ie, "typeName", "ProfileShowcaseVerifiedToken"), t(ie, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "symbol",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let ar = ie;
const se = class se extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string contract_address = 1;
     */
    t(this, "contractAddress", "");
    /**
     * @generated from field: uint32 order = 2;
     */
    t(this, "order", 0);
    /**
     * @generated from field: uint64 chain_id = 3;
     */
    t(this, "chainId", d.zero);
    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    t(this, "communityId", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new se().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new se().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new se().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(se, e, n);
  }
};
t(se, "runtime", a), t(se, "typeName", "ProfileShowcaseUnverifiedToken"), t(se, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "contract_address",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "chain_id",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 4,
    name: "community_id",
    kind: "scalar",
    T: 9
  }
]));
let ir = se;
const oe = class oe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string url = 1;
     */
    t(this, "url", "");
    /**
     * @generated from field: uint32 order = 2;
     */
    t(this, "order", 0);
    /**
     * @generated from field: string text = 3;
     */
    t(this, "text", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new oe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new oe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new oe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(oe, e, n);
  }
};
t(oe, "runtime", a), t(oe, "typeName", "ProfileShowcaseSocialLink"), t(oe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "text",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let sr = oe;
const le = class le extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated ProfileShowcaseCommunity communities = 1;
     */
    t(this, "communities", []);
    /**
     * @generated from field: repeated ProfileShowcaseAccount accounts = 2;
     */
    t(this, "accounts", []);
    /**
     * @generated from field: repeated ProfileShowcaseCollectible collectibles = 3;
     */
    t(this, "collectibles", []);
    /**
     * @generated from field: repeated ProfileShowcaseVerifiedToken verified_tokens = 4;
     */
    t(this, "verifiedTokens", []);
    /**
     * @generated from field: repeated ProfileShowcaseUnverifiedToken unverified_tokens = 5;
     */
    t(this, "unverifiedTokens", []);
    /**
     * @generated from field: repeated ProfileShowcaseSocialLink social_links = 6;
     */
    t(this, "socialLinks", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new le().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new le().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new le().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(le, e, n);
  }
};
t(le, "runtime", a), t(le, "typeName", "ProfileShowcaseEntries"), t(le, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "communities",
    kind: "message",
    T: nr,
    repeated: !0
  },
  {
    no: 2,
    name: "accounts",
    kind: "message",
    T: tr,
    repeated: !0
  },
  {
    no: 3,
    name: "collectibles",
    kind: "message",
    T: rr,
    repeated: !0
  },
  {
    no: 4,
    name: "verified_tokens",
    kind: "message",
    T: ar,
    repeated: !0
  },
  {
    no: 5,
    name: "unverified_tokens",
    kind: "message",
    T: ir,
    repeated: !0
  },
  {
    no: 6,
    name: "social_links",
    kind: "message",
    T: sr,
    repeated: !0
  }
]));
let or = le;
const ce = class ce extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes encrypted_entries = 1;
     */
    t(this, "encryptedEntries", new Uint8Array(0));
    /**
     * @generated from field: repeated bytes encryption_keys = 2;
     */
    t(this, "encryptionKeys", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ce().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ce().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ce().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(ce, e, n);
  }
};
t(ce, "runtime", a), t(ce, "typeName", "ProfileShowcaseEntriesEncrypted"), t(ce, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "encrypted_entries",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "encryption_keys",
    kind: "scalar",
    T: 12,
    repeated: !0
  }
]));
let At = ce;
const ue = class ue extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: ProfileShowcaseEntries for_everyone = 1;
     */
    t(this, "forEveryone");
    /**
     * @generated from field: ProfileShowcaseEntriesEncrypted for_contacts = 2;
     */
    t(this, "forContacts");
    /**
     * @generated from field: ProfileShowcaseEntriesEncrypted for_id_verified_contacts = 3;
     */
    t(this, "forIdVerifiedContacts");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ue().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ue().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ue().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ue, e, n);
  }
};
t(ue, "runtime", a), t(ue, "typeName", "ProfileShowcase"), t(ue, "fields", a.util.newFieldList(() => [
  { no: 1, name: "for_everyone", kind: "message", T: or },
  {
    no: 2,
    name: "for_contacts",
    kind: "message",
    T: At
  },
  {
    no: 3,
    name: "for_id_verified_contacts",
    kind: "message",
    T: At
  }
]));
let lr = ue;
const me = class me extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string community_id = 1;
     */
    t(this, "communityId", "");
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 2;
     */
    t(this, "showcaseVisibility", 0);
    /**
     * @generated from field: uint32 order = 3;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new me().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new me().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new me().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(me, e, n);
  }
};
t(me, "runtime", a), t(me, "typeName", "ProfileShowcaseCommunityPreference"), t(me, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  },
  {
    no: 3,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let cr = me;
const de = class de extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string address = 1;
     */
    t(this, "address", "");
    /**
     * @generated from field: string name = 2 [deprecated = true];
     * @deprecated
     */
    t(this, "name", "");
    /**
     * @generated from field: string color_id = 3 [deprecated = true];
     * @deprecated
     */
    t(this, "colorId", "");
    /**
     * @generated from field: string emoji = 4 [deprecated = true];
     * @deprecated
     */
    t(this, "emoji", "");
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 5;
     */
    t(this, "showcaseVisibility", 0);
    /**
     * @generated from field: uint32 order = 6;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new de().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new de().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new de().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(de, e, n);
  }
};
t(de, "runtime", a), t(de, "typeName", "ProfileShowcaseAccountPreference"), t(de, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "address",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "color_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "emoji",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  },
  {
    no: 6,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let ur = de;
const he = class he extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string contract_address = 1;
     */
    t(this, "contractAddress", "");
    /**
     * @generated from field: uint64 chain_id = 2;
     */
    t(this, "chainId", d.zero);
    /**
     * @generated from field: string token_id = 3;
     */
    t(this, "tokenId", "");
    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    t(this, "communityId", "");
    /**
     * @generated from field: string account_address = 5 [deprecated = true];
     * @deprecated
     */
    t(this, "accountAddress", "");
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 6;
     */
    t(this, "showcaseVisibility", 0);
    /**
     * @generated from field: uint32 order = 7;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new he().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new he().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new he().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(he, e, n);
  }
};
t(he, "runtime", a), t(he, "typeName", "ProfileShowcaseCollectiblePreference"), t(he, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "contract_address",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "chain_id",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 3,
    name: "token_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "community_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "account_address",
    kind: "scalar",
    T: 9
  },
  {
    no: 6,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  },
  {
    no: 7,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let mr = he;
const Ee = class Ee extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string symbol = 1;
     */
    t(this, "symbol", "");
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 2;
     */
    t(this, "showcaseVisibility", 0);
    /**
     * @generated from field: uint32 order = 3;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ee().fromBinary(
      e,
      n
    );
  }
  static fromJson(e, n) {
    return new Ee().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new Ee().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Ee, e, n);
  }
};
t(Ee, "runtime", a), t(Ee, "typeName", "ProfileShowcaseVerifiedTokenPreference"), t(Ee, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "symbol",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  },
  {
    no: 3,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let dr = Ee;
const Te = class Te extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string contract_address = 1;
     */
    t(this, "contractAddress", "");
    /**
     * @generated from field: uint64 chain_id = 2;
     */
    t(this, "chainId", d.zero);
    /**
     * @generated from field: string community_id = 3 [deprecated = true];
     * @deprecated
     */
    t(this, "communityId", "");
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 4;
     */
    t(this, "showcaseVisibility", 0);
    /**
     * @generated from field: uint32 order = 5;
     */
    t(this, "order", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Te().fromBinary(
      e,
      n
    );
  }
  static fromJson(e, n) {
    return new Te().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new Te().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Te, e, n);
  }
};
t(Te, "runtime", a), t(Te, "typeName", "ProfileShowcaseUnverifiedTokenPreference"), t(Te, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "contract_address",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "chain_id",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 3,
    name: "community_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  },
  {
    no: 5,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let hr = Te;
const fe = class fe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string url = 1;
     */
    t(this, "url", "");
    /**
     * @generated from field: string text = 2;
     */
    t(this, "text", "");
    /**
     * @generated from field: uint32 order = 3;
     */
    t(this, "order", 0);
    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 4;
     */
    t(this, "showcaseVisibility", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new fe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new fe().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new fe().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(fe, e, n);
  }
};
t(fe, "runtime", a), t(fe, "typeName", "ProfileShowcaseSocialLinkPreference"), t(fe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "text",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "order",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 4,
    name: "showcase_visibility",
    kind: "enum",
    T: a.getEnumType(bn)
  }
]));
let Er = fe;
const Se = class Se extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: repeated ProfileShowcaseCommunityPreference communities = 2;
     */
    t(this, "communities", []);
    /**
     * @generated from field: repeated ProfileShowcaseAccountPreference accounts = 3;
     */
    t(this, "accounts", []);
    /**
     * @generated from field: repeated ProfileShowcaseCollectiblePreference collectibles = 4;
     */
    t(this, "collectibles", []);
    /**
     * @generated from field: repeated ProfileShowcaseVerifiedTokenPreference verified_tokens = 5;
     */
    t(this, "verifiedTokens", []);
    /**
     * @generated from field: repeated ProfileShowcaseUnverifiedTokenPreference unverified_tokens = 6;
     */
    t(this, "unverifiedTokens", []);
    /**
     * @generated from field: repeated ProfileShowcaseSocialLinkPreference social_links = 7;
     */
    t(this, "socialLinks", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Se().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Se().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Se().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Se, e, n);
  }
};
t(Se, "runtime", a), t(Se, "typeName", "SyncProfileShowcasePreferences"), t(Se, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "communities",
    kind: "message",
    T: cr,
    repeated: !0
  },
  {
    no: 3,
    name: "accounts",
    kind: "message",
    T: ur,
    repeated: !0
  },
  {
    no: 4,
    name: "collectibles",
    kind: "message",
    T: mr,
    repeated: !0
  },
  {
    no: 5,
    name: "verified_tokens",
    kind: "message",
    T: dr,
    repeated: !0
  },
  {
    no: 6,
    name: "unverified_tokens",
    kind: "message",
    T: hr,
    repeated: !0
  },
  {
    no: 7,
    name: "social_links",
    kind: "message",
    T: Er,
    repeated: !0
  }
]));
let ga = Se;
const ye = class ye extends l {
  constructor(e) {
    super();
    /**
     * Lamport timestamp of the message
     *
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * ens_name is the valid ENS name associated with the chat key
     *
     * @generated from field: string ens_name = 2;
     */
    t(this, "ensName", "");
    /**
     * images is a string indexed mapping of images associated with an identity
     *
     * @generated from field: map<string, IdentityImage> images = 3;
     */
    t(this, "images", {});
    /**
     * display name is the user set identity
     *
     * @generated from field: string display_name = 4;
     */
    t(this, "displayName", "");
    /**
     * description is the user set description
     *
     * @generated from field: string description = 5;
     */
    t(this, "description", "");
    /**
     * @generated from field: string color = 6;
     */
    t(this, "color", "");
    /**
     * @generated from field: string emoji = 7;
     */
    t(this, "emoji", "");
    /**
     * @generated from field: repeated SocialLink social_links = 8;
     */
    t(this, "socialLinks", []);
    /**
     * first known message timestamp in seconds (valid only for community chats for now)
     * 0 - unknown
     * 1 - no messages
     *
     * @generated from field: uint32 first_message_timestamp = 9;
     */
    t(this, "firstMessageTimestamp", 0);
    /**
     * @generated from field: ProfileShowcase profile_showcase = 10;
     */
    t(this, "profileShowcase");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ye().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ye().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ye().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ye, e, n);
  }
};
t(ye, "runtime", a), t(ye, "typeName", "ChatIdentity"), t(ye, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "ens_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "images",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Tr }
  },
  {
    no: 4,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 6,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "emoji",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 8,
    name: "social_links",
    kind: "message",
    T: fr,
    repeated: !0
  },
  {
    no: 9,
    name: "first_message_timestamp",
    kind: "scalar",
    T: 13
  },
  { no: 10, name: "profile_showcase", kind: "message", T: lr }
]));
let at = ye;
const Ne = class Ne extends l {
  constructor(e) {
    super();
    /**
     * payload is a context based payload for the profile image data,
     * context is determined by the `source_type`
     *
     * @generated from field: bytes payload = 1;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * source_type signals the image payload source
     *
     * @generated from field: IdentityImage.SourceType source_type = 2;
     */
    t(this, "sourceType", 0);
    /**
     * image_format signals the image format and method of parsing the payload
     *
     * @generated from field: ImageFormat image_format = 3;
     */
    t(this, "imageFormat", jn.UNKNOWN_IMAGE_FORMAT);
    /**
     * encryption_keys is a list of encrypted keys that can be used to decrypted an encrypted payload
     *
     * @generated from field: repeated bytes encryption_keys = 4;
     */
    t(this, "encryptionKeys", []);
    /**
     * encrypted signals the encryption state of the payload, default is false.
     *
     * @generated from field: bool encrypted = 5;
     */
    t(this, "encrypted", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ne().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ne().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ne().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ne, e, n);
  }
};
t(Ne, "runtime", a), t(Ne, "typeName", "IdentityImage"), t(Ne, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "source_type",
    kind: "enum",
    T: a.getEnumType(Qr)
  },
  {
    no: 3,
    name: "image_format",
    kind: "enum",
    T: a.getEnumType(jn)
  },
  {
    no: 4,
    name: "encryption_keys",
    kind: "scalar",
    T: 12,
    repeated: !0
  },
  {
    no: 5,
    name: "encrypted",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]));
let Tr = Ne;
var Qr = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_SOURCE_TYPE = 0] = "UNKNOWN_SOURCE_TYPE", r[r.RAW_PAYLOAD = 1] = "RAW_PAYLOAD", r[r.ENS_AVATAR = 2] = "ENS_AVATAR", r))(Qr || {});
a.util.setEnumType(Qr, "IdentityImage.SourceType", [
  { no: 0, name: "UNKNOWN_SOURCE_TYPE" },
  { no: 1, name: "RAW_PAYLOAD" },
  { no: 2, name: "ENS_AVATAR" }
]);
const ge = class ge extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string text = 1;
     */
    t(this, "text", "");
    /**
     * @generated from field: string url = 2;
     */
    t(this, "url", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ge().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ge().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ge().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ge, e, n);
  }
};
t(ge, "runtime", a), t(ge, "typeName", "SocialLink"), t(ge, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "text",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let fr = ge;
const ke = class ke extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes community_id = 1;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: bytes member_id = 2;
     */
    t(this, "memberId", new Uint8Array(0));
    /**
     * @generated from field: string chat_id = 3;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: uint64 clock = 4;
     */
    t(this, "clock", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ke().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ke().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ke().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ke, e, n);
  }
};
t(ke, "runtime", a), t(ke, "typeName", "Grant"), t(ke, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "member_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let ka = ke;
const we = class we extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated CommunityMember.Roles roles = 1;
     */
    t(this, "roles", []);
    /**
     * @generated from field: repeated RevealedAccount revealed_accounts = 2 [deprecated = true];
     * @deprecated
     */
    t(this, "revealedAccounts", []);
    /**
     * @generated from field: uint64 last_update_clock = 3;
     */
    t(this, "lastUpdateClock", d.zero);
    /**
     * @generated from field: CommunityMember.ChannelRole channel_role = 4;
     */
    t(this, "channelRole", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new we().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new we().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new we().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(we, e, n);
  }
};
t(we, "runtime", a), t(we, "typeName", "CommunityMember"), t(we, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "roles",
    kind: "enum",
    T: a.getEnumType(jr),
    repeated: !0
  },
  {
    no: 2,
    name: "revealed_accounts",
    kind: "message",
    T: st,
    repeated: !0
  },
  {
    no: 3,
    name: "last_update_clock",
    kind: "scalar",
    T: 4
  },
  {
    no: 4,
    name: "channel_role",
    kind: "enum",
    T: a.getEnumType(Xr)
  }
]));
let Ct = we;
var jr = /* @__PURE__ */ ((r) => (r[r.ROLE_NONE = 0] = "ROLE_NONE", r[r.ROLE_OWNER = 1] = "ROLE_OWNER", r[r.ROLE_ADMIN = 4] = "ROLE_ADMIN", r[r.ROLE_TOKEN_MASTER = 5] = "ROLE_TOKEN_MASTER", r))(jr || {});
a.util.setEnumType(jr, "CommunityMember.Roles", [
  { no: 0, name: "ROLE_NONE" },
  { no: 1, name: "ROLE_OWNER" },
  { no: 4, name: "ROLE_ADMIN" },
  { no: 5, name: "ROLE_TOKEN_MASTER" }
]);
var Xr = /* @__PURE__ */ ((r) => (r[r.POSTER = 0] = "POSTER", r[r.VIEWER = 1] = "VIEWER", r))(Xr || {});
a.util.setEnumType(
  Xr,
  "CommunityMember.ChannelRole",
  [
    { no: 0, name: "CHANNEL_ROLE_POSTER" },
    { no: 1, name: "CHANNEL_ROLE_VIEWER" }
  ]
);
const Ie = class Ie extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: map<uint64, string> contract_addresses = 1;
     */
    t(this, "contractAddresses", {});
    /**
     * @generated from field: string description = 2;
     */
    t(this, "description", "");
    /**
     * @generated from field: string image = 3;
     */
    t(this, "image", "");
    /**
     * @generated from field: CommunityTokenType tokenType = 4;
     */
    t(this, "tokenType", Xn.UNKNOWN_TOKEN_TYPE);
    /**
     * @generated from field: string symbol = 5;
     */
    t(this, "symbol", "");
    /**
     * @generated from field: string name = 6;
     */
    t(this, "name", "");
    /**
     * @generated from field: uint32 decimals = 7;
     */
    t(this, "decimals", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ie().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ie().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ie().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ie, e, n);
  }
};
t(Ie, "runtime", a), t(Ie, "typeName", "CommunityTokenMetadata"), t(Ie, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "contract_addresses",
    kind: "map",
    K: 4,
    V: {
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  },
  {
    no: 2,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "image",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "tokenType",
    kind: "enum",
    T: a.getEnumType(Xn)
  },
  {
    no: 5,
    name: "symbol",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "decimals",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  }
]));
let Sr = Ie;
const Ae = class Ae extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bool ens_only = 1;
     */
    t(this, "ensOnly", !1);
    /**
     * https://gitlab.matrix.org/matrix-org/olm/blob/master/docs/megolm.md is a candidate for the algorithm to be used in case we want to have private communityal chats, lighter than pairwise encryption using the DR, less secure, but more efficient for large number of participants
     *
     * @generated from field: bool private = 2;
     */
    t(this, "private", !1);
    /**
     * @generated from field: CommunityPermissions.Access access = 3;
     */
    t(this, "access", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ae().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ae().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ae().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ae, e, n);
  }
};
t(Ae, "runtime", a), t(Ae, "typeName", "CommunityPermissions"), t(Ae, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "ens_only",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 2,
    name: "private",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 3,
    name: "access",
    kind: "enum",
    T: a.getEnumType(Zr)
  }
]));
let Ot = Ae;
var Zr = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_ACCESS = 0] = "UNKNOWN_ACCESS", r[r.AUTO_ACCEPT = 1] = "AUTO_ACCEPT", r[r.INVITATION_ONLY = 2] = "INVITATION_ONLY", r[r.MANUAL_ACCEPT = 3] = "MANUAL_ACCEPT", r))(Zr || {});
a.util.setEnumType(
  Zr,
  "CommunityPermissions.Access",
  [
    { no: 0, name: "UNKNOWN_ACCESS" },
    { no: 1, name: "AUTO_ACCEPT" },
    { no: 2, name: "INVITATION_ONLY" },
    { no: 3, name: "MANUAL_ACCEPT" }
  ]
);
const Ce = class Ce extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: map<uint64, string> contract_addresses = 1;
     */
    t(this, "contractAddresses", {});
    /**
     * @generated from field: CommunityTokenType type = 2;
     */
    t(this, "type", Xn.UNKNOWN_TOKEN_TYPE);
    /**
     * @generated from field: string symbol = 3;
     */
    t(this, "symbol", "");
    /**
     * @generated from field: string name = 4;
     */
    t(this, "name", "");
    /**
     * @generated from field: string amount = 5 [deprecated = true];
     * @deprecated
     */
    t(this, "amount", "");
    /**
     * @generated from field: repeated uint64 token_ids = 6;
     */
    t(this, "tokenIds", []);
    /**
     * @generated from field: string ens_pattern = 7;
     */
    t(this, "ensPattern", "");
    /**
     * @generated from field: uint64 decimals = 8;
     */
    t(this, "decimals", d.zero);
    /**
     * @generated from field: string amountInWei = 9;
     */
    t(this, "amountInWei", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ce().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ce().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ce().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ce, e, n);
  }
};
t(Ce, "runtime", a), t(Ce, "typeName", "TokenCriteria"), t(Ce, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "contract_addresses",
    kind: "map",
    K: 4,
    V: {
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  },
  {
    no: 2,
    name: "type",
    kind: "enum",
    T: a.getEnumType(Xn)
  },
  {
    no: 3,
    name: "symbol",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "amount",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "token_ids",
    kind: "scalar",
    T: 4,
    repeated: !0
  },
  {
    no: 7,
    name: "ens_pattern",
    kind: "scalar",
    T: 9
  },
  {
    no: 8,
    name: "decimals",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 9,
    name: "amountInWei",
    kind: "scalar",
    T: 9
  }
]));
let yr = Ce;
const Oe = class Oe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string id = 1;
     */
    t(this, "id", "");
    /**
     * @generated from field: CommunityTokenPermission.Type type = 2;
     */
    t(this, "type", 0);
    /**
     * @generated from field: repeated TokenCriteria token_criteria = 3;
     */
    t(this, "tokenCriteria", []);
    /**
     * @generated from field: repeated string chat_ids = 4;
     */
    t(this, "chatIds", []);
    /**
     * @generated from field: bool is_private = 5;
     */
    t(this, "isPrivate", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Oe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Oe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Oe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Oe, e, n);
  }
};
t(Oe, "runtime", a), t(Oe, "typeName", "CommunityTokenPermission"), t(Oe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "type",
    kind: "enum",
    T: a.getEnumType(Lt)
  },
  {
    no: 3,
    name: "token_criteria",
    kind: "message",
    T: yr,
    repeated: !0
  },
  {
    no: 4,
    name: "chat_ids",
    kind: "scalar",
    T: 9,
    repeated: !0
  },
  {
    no: 5,
    name: "is_private",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]));
let Nr = Oe;
var Lt = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_TOKEN_PERMISSION = 0] = "UNKNOWN_TOKEN_PERMISSION", r[r.BECOME_ADMIN = 1] = "BECOME_ADMIN", r[r.BECOME_MEMBER = 2] = "BECOME_MEMBER", r[r.CAN_VIEW_CHANNEL = 3] = "CAN_VIEW_CHANNEL", r[r.CAN_VIEW_AND_POST_CHANNEL = 4] = "CAN_VIEW_AND_POST_CHANNEL", r[r.BECOME_TOKEN_MASTER = 5] = "BECOME_TOKEN_MASTER", r[r.BECOME_TOKEN_OWNER = 6] = "BECOME_TOKEN_OWNER", r))(Lt || {});
a.util.setEnumType(
  Lt,
  "CommunityTokenPermission.Type",
  [
    { no: 0, name: "UNKNOWN_TOKEN_PERMISSION" },
    { no: 1, name: "BECOME_ADMIN" },
    { no: 2, name: "BECOME_MEMBER" },
    { no: 3, name: "CAN_VIEW_CHANNEL" },
    { no: 4, name: "CAN_VIEW_AND_POST_CHANNEL" },
    { no: 5, name: "BECOME_TOKEN_MASTER" },
    { no: 6, name: "BECOME_TOKEN_OWNER" }
  ]
);
const pe = class pe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: map<string, CommunityMember> members = 2;
     */
    t(this, "members", {});
    /**
     * @generated from field: CommunityPermissions permissions = 3;
     */
    t(this, "permissions");
    /**
     * @generated from field: ChatIdentity identity = 5;
     */
    t(this, "identity");
    /**
     * @generated from field: map<string, CommunityChat> chats = 6;
     */
    t(this, "chats", {});
    /**
     * @generated from field: repeated string ban_list = 7 [deprecated = true];
     * @deprecated
     */
    t(this, "banList", []);
    /**
     * @generated from field: map<string, CommunityCategory> categories = 8;
     */
    t(this, "categories", {});
    /**
     * @generated from field: uint64 archive_magnetlink_clock = 9;
     */
    t(this, "archiveMagnetlinkClock", d.zero);
    /**
     * @generated from field: CommunityAdminSettings admin_settings = 10;
     */
    t(this, "adminSettings");
    /**
     * @generated from field: string intro_message = 11;
     */
    t(this, "introMessage", "");
    /**
     * @generated from field: string outro_message = 12;
     */
    t(this, "outroMessage", "");
    /**
     * @generated from field: bool encrypted = 13 [deprecated = true];
     * @deprecated
     */
    t(this, "encrypted", !1);
    /**
     * @generated from field: repeated string tags = 14;
     */
    t(this, "tags", []);
    /**
     * @generated from field: map<string, CommunityTokenPermission> token_permissions = 15;
     */
    t(this, "tokenPermissions", {});
    /**
     * @generated from field: repeated CommunityTokenMetadata community_tokens_metadata = 16;
     */
    t(this, "communityTokensMetadata", []);
    /**
     * @generated from field: uint64 active_members_count = 17;
     */
    t(this, "activeMembersCount", d.zero);
    /**
     * @generated from field: string ID = 18;
     */
    t(this, "ID", "");
    /**
     * @generated from field: map<string, CommunityBanInfo> banned_members = 19;
     */
    t(this, "bannedMembers", {});
    /**
     * key is hash ratchet key_id + seq_no
     *
     * @generated from field: map<string, bytes> privateData = 100;
     */
    t(this, "privateData", {});
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new pe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new pe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new pe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(pe, e, n);
  }
};
t(pe, "runtime", a), t(pe, "typeName", "CommunityDescription"), t(pe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "members",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Ct }
  },
  { no: 3, name: "permissions", kind: "message", T: Ot },
  { no: 5, name: "identity", kind: "message", T: at },
  {
    no: 6,
    name: "chats",
    kind: "map",
    K: 9,
    V: { kind: "message", T: wr }
  },
  {
    no: 7,
    name: "ban_list",
    kind: "scalar",
    T: 9,
    repeated: !0
  },
  {
    no: 8,
    name: "categories",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Ir }
  },
  {
    no: 9,
    name: "archive_magnetlink_clock",
    kind: "scalar",
    T: 4
  },
  {
    no: 10,
    name: "admin_settings",
    kind: "message",
    T: kr
  },
  {
    no: 11,
    name: "intro_message",
    kind: "scalar",
    T: 9
  },
  {
    no: 12,
    name: "outro_message",
    kind: "scalar",
    T: 9
  },
  {
    no: 13,
    name: "encrypted",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 14,
    name: "tags",
    kind: "scalar",
    T: 9,
    repeated: !0
  },
  {
    no: 15,
    name: "token_permissions",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Nr }
  },
  {
    no: 16,
    name: "community_tokens_metadata",
    kind: "message",
    T: Sr,
    repeated: !0
  },
  {
    no: 17,
    name: "active_members_count",
    kind: "scalar",
    T: 4
  },
  {
    no: 18,
    name: "ID",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 19,
    name: "banned_members",
    kind: "map",
    K: 9,
    V: { kind: "message", T: gr }
  },
  {
    no: 100,
    name: "privateData",
    kind: "map",
    K: 9,
    V: {
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  }
]));
let it = pe;
const be = class be extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bool delete_all_messages = 1;
     */
    t(this, "deleteAllMessages", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new be().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new be().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new be().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(be, e, n);
  }
};
t(be, "runtime", a), t(be, "typeName", "CommunityBanInfo"), t(be, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "delete_all_messages",
    kind: "scalar",
    T: 8
  }
]));
let gr = be;
const Be = class Be extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bool pin_message_all_members_enabled = 1;
     */
    t(this, "pinMessageAllMembersEnabled", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Be().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Be().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Be().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Be, e, n);
  }
};
t(Be, "runtime", a), t(Be, "typeName", "CommunityAdminSettings"), t(Be, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "pin_message_all_members_enabled",
    kind: "scalar",
    T: 8
  }
]));
let kr = Be;
const Ue = class Ue extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: map<string, CommunityMember> members = 1;
     */
    t(this, "members", {});
    /**
     * @generated from field: CommunityPermissions permissions = 2;
     */
    t(this, "permissions");
    /**
     * @generated from field: ChatIdentity identity = 3;
     */
    t(this, "identity");
    /**
     * @generated from field: string category_id = 4;
     */
    t(this, "categoryId", "");
    /**
     * @generated from field: int32 position = 5;
     */
    t(this, "position", 0);
    /**
     * @generated from field: bool viewers_can_post_reactions = 6;
     */
    t(this, "viewersCanPostReactions", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ue().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ue().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ue().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ue, e, n);
  }
};
t(Ue, "runtime", a), t(Ue, "typeName", "CommunityChat"), t(Ue, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "members",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Ct }
  },
  { no: 2, name: "permissions", kind: "message", T: Ot },
  { no: 3, name: "identity", kind: "message", T: at },
  {
    no: 4,
    name: "category_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "position",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 6,
    name: "viewers_can_post_reactions",
    kind: "scalar",
    T: 8
  }
]));
let wr = Ue;
const Re = class Re extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string category_id = 1;
     */
    t(this, "categoryId", "");
    /**
     * @generated from field: string name = 2;
     */
    t(this, "name", "");
    /**
     * @generated from field: int32 position = 3;
     */
    t(this, "position", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Re().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Re().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Re().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Re, e, n);
  }
};
t(Re, "runtime", a), t(Re, "typeName", "CommunityCategory"), t(Re, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "category_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "position",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  }
]));
let Ir = Re;
const Je = class Je extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string address = 1;
     */
    t(this, "address", "");
    /**
     * @generated from field: bytes signature = 2;
     */
    t(this, "signature", new Uint8Array(0));
    /**
     * @generated from field: repeated uint64 chain_ids = 3;
     */
    t(this, "chainIds", []);
    /**
     * @generated from field: bool isAirdropAddress = 4;
     */
    t(this, "isAirdropAddress", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Je().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Je().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Je().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Je, e, n);
  }
};
t(Je, "runtime", a), t(Je, "typeName", "RevealedAccount"), t(Je, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "address",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 2,
    name: "signature",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "chain_ids",
    kind: "scalar",
    T: 4,
    repeated: !0
  },
  {
    no: 4,
    name: "isAirdropAddress",
    kind: "scalar",
    T: 8
  }
]));
let st = Je;
const Pe = class Pe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string ens_name = 2;
     */
    t(this, "ensName", "");
    /**
     * @generated from field: string chat_id = 3;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: bytes community_id = 4;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: string display_name = 5;
     */
    t(this, "displayName", "");
    /**
     * @generated from field: repeated RevealedAccount revealed_accounts = 6;
     */
    t(this, "revealedAccounts", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Pe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Pe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Pe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Pe, e, n);
  }
};
t(Pe, "runtime", a), t(Pe, "typeName", "CommunityRequestToJoin"), t(Pe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "ens_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 5,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 6,
    name: "revealed_accounts",
    kind: "message",
    T: st,
    repeated: !0
  }
]));
let Ar = Pe;
const Le = class Le extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: bytes community_id = 2;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: repeated RevealedAccount revealed_accounts = 3;
     */
    t(this, "revealedAccounts", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Le().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Le().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Le().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Le, e, n);
  }
};
t(Le, "runtime", a), t(Le, "typeName", "CommunityEditSharedAddresses"), t(Le, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 3,
    name: "revealed_accounts",
    kind: "message",
    T: st,
    repeated: !0
  }
]));
let wa = Le;
const De = class De extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string ens_name = 2;
     */
    t(this, "ensName", "");
    /**
     * @generated from field: string chat_id = 3;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: bytes community_id = 4;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: string display_name = 5;
     */
    t(this, "displayName", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new De().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new De().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new De().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(De, e, n);
  }
};
t(De, "runtime", a), t(De, "typeName", "CommunityCancelRequestToJoin"), t(De, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "ens_name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 5,
    name: "display_name",
    kind: "scalar",
    T: 9
  }
]));
let Ia = De;
const ve = class ve extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: bytes community_id = 2;
     */
    t(this, "communityId", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ve().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ve().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ve().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ve, e, n);
  }
};
t(ve, "runtime", a), t(ve, "typeName", "CommunityUserKicked"), t(ve, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "community_id",
    kind: "scalar",
    T: 12
  }
]));
let Aa = ve;
const Fe = class Fe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: CommunityDescription community = 2;
     */
    t(this, "community");
    /**
     * @generated from field: bool accepted = 3;
     */
    t(this, "accepted", !1);
    /**
     * @generated from field: bytes grant = 4;
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * @generated from field: bytes community_id = 5;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: string magnet_uri = 6;
     */
    t(this, "magnetUri", "");
    /**
     * @generated from field: bytes protected_topic_private_key = 7;
     */
    t(this, "protectedTopicPrivateKey", new Uint8Array(0));
    /**
     * @generated from field: Shard shard = 8;
     */
    t(this, "shard");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Fe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Fe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Fe().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Fe, e, n);
  }
};
t(Fe, "runtime", a), t(Fe, "typeName", "CommunityRequestToJoinResponse"), t(Fe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  { no: 2, name: "community", kind: "message", T: it },
  {
    no: 3,
    name: "accepted",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 4,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 5,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 6,
    name: "magnet_uri",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 7,
    name: "protected_topic_private_key",
    kind: "scalar",
    T: 12
  },
  { no: 8, name: "shard", kind: "message", T: nt }
]));
let Ca = Fe;
const Ge = class Ge extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: bytes community_id = 2;
     */
    t(this, "communityId", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ge().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ge().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ge().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ge, e, n);
  }
};
t(Ge, "runtime", a), t(Ge, "typeName", "CommunityRequestToLeave"), t(Ge, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "community_id",
    kind: "scalar",
    T: 12
  }
]));
let Oa = Ge;
const Ye = class Ye extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string magnet_uri = 2;
     */
    t(this, "magnetUri", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ye().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ye().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ye().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Ye, e, n);
  }
};
t(Ye, "runtime", a), t(Ye, "typeName", "CommunityMessageArchiveMagnetlink"), t(Ye, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "magnet_uri",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let pa = Ye;
const Ke = class Ke extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes sig = 1;
     */
    t(this, "sig", new Uint8Array(0));
    /**
     * @generated from field: uint64 timestamp = 2;
     */
    t(this, "timestamp", d.zero);
    /**
     * @generated from field: bytes topic = 3;
     */
    t(this, "topic", new Uint8Array(0));
    /**
     * @generated from field: bytes payload = 4;
     */
    t(this, "payload", new Uint8Array(0));
    /**
     * @generated from field: bytes padding = 5;
     */
    t(this, "padding", new Uint8Array(0));
    /**
     * @generated from field: bytes hash = 6;
     */
    t(this, "hash", new Uint8Array(0));
    /**
     * @generated from field: string thirdPartyId = 7;
     */
    t(this, "thirdPartyId", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ke().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ke().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ke().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ke, e, n);
  }
};
t(Ke, "runtime", a), t(Ke, "typeName", "WakuMessage"), t(Ke, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "sig",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "timestamp",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 3,
    name: "topic",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 5,
    name: "padding",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 6,
    name: "hash",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 7,
    name: "thirdPartyId",
    kind: "scalar",
    T: 9
  }
]));
let Cr = Ke;
const He = class He extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint32 version = 1;
     */
    t(this, "version", 0);
    /**
     * @generated from field: uint64 from = 2;
     */
    t(this, "from", d.zero);
    /**
     * @generated from field: uint64 to = 3;
     */
    t(this, "to", d.zero);
    /**
     * @generated from field: repeated bytes contentTopic = 4;
     */
    t(this, "contentTopic", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new He().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new He().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new He().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(He, e, n);
  }
};
t(He, "runtime", a), t(He, "typeName", "WakuMessageArchiveMetadata"), t(He, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "version",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 2,
    name: "from",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 3,
    name: "to",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 4,
    name: "contentTopic",
    kind: "scalar",
    T: 12,
    repeated: !0
  }
]));
let pt = He;
const xe = class xe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint32 version = 1;
     */
    t(this, "version", 0);
    /**
     * @generated from field: WakuMessageArchiveMetadata metadata = 2;
     */
    t(this, "metadata");
    /**
     * @generated from field: repeated WakuMessage messages = 3;
     */
    t(this, "messages", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new xe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new xe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new xe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(xe, e, n);
  }
};
t(xe, "runtime", a), t(xe, "typeName", "WakuMessageArchive"), t(xe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "version",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  { no: 2, name: "metadata", kind: "message", T: pt },
  {
    no: 3,
    name: "messages",
    kind: "message",
    T: Cr,
    repeated: !0
  }
]));
let ba = xe;
const Me = class Me extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint32 version = 1;
     */
    t(this, "version", 0);
    /**
     * @generated from field: WakuMessageArchiveMetadata metadata = 2;
     */
    t(this, "metadata");
    /**
     * @generated from field: uint64 offset = 3;
     */
    t(this, "offset", d.zero);
    /**
     * @generated from field: uint64 size = 4;
     */
    t(this, "size", d.zero);
    /**
     * @generated from field: uint64 padding = 5;
     */
    t(this, "padding", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Me().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Me().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Me().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(Me, e, n);
  }
};
t(Me, "runtime", a), t(Me, "typeName", "WakuMessageArchiveIndexMetadata"), t(Me, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "version",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  { no: 2, name: "metadata", kind: "message", T: pt },
  {
    no: 3,
    name: "offset",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 4,
    name: "size",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 5,
    name: "padding",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let Or = Me;
const We = class We extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: map<string, WakuMessageArchiveIndexMetadata> archives = 1;
     */
    t(this, "archives", {});
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new We().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new We().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new We().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(We, e, n);
  }
};
t(We, "runtime", a), t(We, "typeName", "WakuMessageArchiveIndex"), t(We, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "archives",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Or }
  }
]));
let Ba = We;
const qe = class qe extends l {
  constructor(e) {
    super();
    /**
     * Signature of the payload field
     *
     * @generated from field: bytes signature = 1;
     */
    t(this, "signature", new Uint8Array(0));
    /**
     * Marshaled CommunityStorenodes
     *
     * @generated from field: bytes payload = 2;
     */
    t(this, "payload", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new qe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new qe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new qe().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(qe, e, n);
  }
};
t(qe, "runtime", a), t(qe, "typeName", "CommunityPublicStorenodesInfo"), t(qe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "signature",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Ua = qe;
const _e = class _e extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: bytes community_id = 2;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: repeated Storenode storenodes = 3;
     */
    t(this, "storenodes", []);
    /**
     * @generated from field: uint64 chain_id = 4;
     */
    t(this, "chainId", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new _e().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new _e().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new _e().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(_e, e, n);
  }
};
t(_e, "runtime", a), t(_e, "typeName", "CommunityStorenodes"), t(_e, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 3,
    name: "storenodes",
    kind: "message",
    T: pr,
    repeated: !0
  },
  {
    no: 4,
    name: "chain_id",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let Ra = _e;
const Ve = class Ve extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes community_id = 1;
     */
    t(this, "communityId", new Uint8Array(0));
    /**
     * @generated from field: string storenode_id = 2;
     */
    t(this, "storenodeId", "");
    /**
     * @generated from field: string name = 3;
     */
    t(this, "name", "");
    /**
     * @generated from field: string address = 4;
     */
    t(this, "address", "");
    /**
     * @generated from field: string fleet = 5;
     */
    t(this, "fleet", "");
    /**
     * @generated from field: uint32 version = 6;
     */
    t(this, "version", 0);
    /**
     * @generated from field: bool removed = 7;
     */
    t(this, "removed", !1);
    /**
     * @generated from field: int64 deleted_at = 8;
     */
    t(this, "deletedAt", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ve().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ve().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ve().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ve, e, n);
  }
};
t(Ve, "runtime", a), t(Ve, "typeName", "Storenode"), t(Ve, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "storenode_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "address",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "fleet",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 6,
    name: "version",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 7,
    name: "removed",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 8,
    name: "deleted_at",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]));
let pr = Ve;
const ze = class ze extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes community_id = 1;
     */
    t(this, "communityId", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ze().fromBinary(
      e,
      n
    );
  }
  static fromJson(e, n) {
    return new ze().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new ze().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(ze, e, n);
  }
};
t(ze, "runtime", a), t(ze, "typeName", "CommunityReevaluatePermissionsRequest"), t(ze, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "community_id",
    kind: "scalar",
    T: 12
  }
]));
let Ja = ze;
function Dt(r) {
  try {
    const i = r.replace(/^0[xX]/, "");
    return za.Point.fromHex(i).toHex(!0);
  } catch {
    throw new Error("Invalid public key");
  }
}
const Ui = 32, Ri = 5;
function ri(r) {
  const e = Dt(r).slice(43, 63);
  return Ji(
    e,
    Ui,
    Ri
  );
}
function Ji(r, i, e) {
  const n = ai(
    BigInt(`0x${r}`),
    BigInt(i * e)
  );
  return Pi(n, i);
}
function ai(r, i) {
  const e = [];
  let n = r;
  if (n === 0n)
    return [0n];
  for (; n > 0n; ) {
    const s = za.utils.mod(n, i);
    n = n / i, e.push(s);
  }
  return e.reverse();
}
function Pi(r, i) {
  const e = [];
  let n;
  for (const s of r) {
    const c = Math.ceil((Number(s) + 1) / i), u = Number(s % BigInt(i));
    let m;
    u !== n ? m = u : m = Number((s + 1n) % BigInt(i)), n = m, e.push([c, m]);
  }
  return e;
}
class Li {
  constructor(i) {
    t(this, "publicKey");
    t(this, "chatKey");
    t(this, "username");
    t(this, "colorHash");
    this.publicKey = i, this.chatKey = Vr(this.publicKey), this.username = ei(i), this.colorHash = ri(i);
  }
  get link() {
    return ja(this.chatKey);
  }
}
var Pn, pn, Ln, qn;
class Di {
  constructor(i, e) {
    t(this, "client");
    T(this, Pn);
    /** Compressed. */
    t(this, "publicKey");
    t(this, "chatKey");
    t(this, "id");
    t(this, "contentTopic");
    t(this, "symmetricKey");
    t(this, "description");
    t(this, "chats");
    T(this, pn);
    T(this, Ln);
    T(this, qn);
    t(this, "fetch", async () => (await this.client.waku.store.queryWithOrderedCallback(
      [
        Hn(this.contentTopic, this.symmetricKey, {
          clusterId: 16,
          shard: 32
        })
      ],
      (i) => {
        if (this.client.handleWakuMessage(i), this.description)
          return !0;
      }
    ), this.description));
    t(this, "observe", async () => {
      await this.client.waku.filter.subscribe(
        [
          Hn(this.contentTopic, this.symmetricKey, {
            clusterId: 16,
            shard: 32
          })
        ],
        this.client.handleWakuMessage
      );
    });
    t(this, "observeChatMessages", async (i) => {
      const e = Object.entries(i).map(
        async ([n, s]) => {
          const c = await er.create(
            this,
            this.client,
            n,
            S.COMMUNITY_CHAT,
            s
          );
          this.chats.set(n, c);
          const u = await this.client.waku.filter.subscribe(
            [
              Hn(c.contentTopic, c.symmetricKey, {
                clusterId: 16,
                shard: 32
              })
            ],
            this.client.handleWakuMessage
          );
          o(this, qn).set(c.contentTopic, u);
        }
      );
      await Promise.all(e);
    });
    t(this, "unobserveChatMessages", (i) => {
      const e = [];
      for (const n of Object.keys(i)) {
        const s = this.chats.get(n);
        if (!s)
          continue;
        const c = s.contentTopic;
        this.chats.delete(n), e.push(c);
      }
      e.length && e.forEach(
        (n) => o(this, qn).get(n)?.()
      );
    });
    t(this, "addMembers", (i) => {
      for (const e of Object.keys(i)) {
        const n = new Li(e);
        o(this, pn).set(e, n);
      }
    });
    t(this, "removeMembers", (i) => {
      for (const e of i)
        o(this, pn).delete(e);
    });
    t(this, "handleDescription", (i) => {
      if (this.description) {
        if (this.description.clock >= i.clock)
          return;
        const e = Na(
          this.description.chats,
          i.chats
        );
        Object.keys(e).length && this.unobserveChatMessages(e);
        const n = Na(
          i.chats,
          this.description.chats
        );
        Object.keys(n).length && this.observeChatMessages(n);
        const s = Bi(
          this.description.members,
          i.members
        );
        this.addMembers(s.added), this.removeMembers(s.removed);
      }
      this.description = i, this.addMembers(this.description.members), o(this, Ln).forEach((e) => e({ ...this.description })), Object.entries(this.description.chats).forEach(
        ([e, n]) => this.chats.get(e)?.handleChange(n)
      );
    });
    t(this, "onChange", (i) => (o(this, Ln).add(i), () => {
      o(this, Ln).delete(i);
    }));
    t(this, "requestToJoin", async (i = "") => {
      const e = new Ar({
        clock: this.setClock(o(this, Pn)),
        chatId: i,
        communityId: Pt(this.id),
        ensName: ""
      }).toBinary();
      await this.client.sendWakuMessage(
        I.COMMUNITY_REQUEST_TO_JOIN,
        e,
        this.contentTopic,
        this.symmetricKey
      );
    });
    t(this, "isOwner", (i) => this.publicKey === `0x${Dt(i)}`);
    t(this, "isMember", (i) => this.getMember(i) !== void 0);
    t(this, "setClock", (i) => (E(this, Pn, Za(i)), o(this, Pn)));
    this.client = i, this.publicKey = e, this.chatKey = Vr(this.publicKey), this.id = e.replace(/^0[xX]/, ""), E(this, Pn, BigInt(Date.now())), this.chats = /* @__PURE__ */ new Map(), E(this, pn, /* @__PURE__ */ new Map()), E(this, Ln, /* @__PURE__ */ new Set()), E(this, qn, /* @__PURE__ */ new Map());
  }
  async start() {
    if (this.contentTopic = It(this.publicKey), this.symmetricKey = await wt(this.publicKey), !await this.fetch())
      throw new Error("Failed to intiliaze Community");
    await this.observe(), await this.observeChatMessages(this.description.chats);
  }
  // todo: rename this to chats when changing references in ui
  get _chats() {
    return [...this.chats.values()];
  }
  getChat(i) {
    return this.chats.get(i);
  }
  get members() {
    return [...o(this, pn).values()];
  }
  getMember(i) {
    return o(this, pn).get(i);
  }
  get link() {
    return Si(this.chatKey);
  }
}
Pn = new WeakMap(), pn = new WeakMap(), Ln = new WeakMap(), qn = new WeakMap();
const Qe = class Qe extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 clock = 1;
     */
    t(this, "clock", d.zero);
    /**
     * @generated from field: string message_id = 2;
     */
    t(this, "messageId", "");
    /**
     * @generated from field: string chat_id = 3;
     */
    t(this, "chatId", "");
    /**
     * @generated from field: bool pinned = 4;
     */
    t(this, "pinned", !1);
    /**
     * The type of message (public/one-to-one/private-group-chat)
     *
     * @generated from field: MessageType message_type = 5;
     */
    t(this, "messageType", S.UNKNOWN_MESSAGE_TYPE);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Qe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Qe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Qe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Qe, e, n);
  }
};
t(Qe, "runtime", a), t(Qe, "typeName", "PinMessage"), t(Qe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "clock",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 2,
    name: "message_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "chat_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "pinned",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 5,
    name: "message_type",
    kind: "enum",
    T: a.getEnumType(S)
  }
]));
let br = Qe;
const je = class je extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes signed_pre_key = 1;
     */
    t(this, "signedPreKey", new Uint8Array(0));
    /**
     * @generated from field: uint32 version = 2;
     */
    t(this, "version", 0);
    /**
     * @generated from field: uint32 protocol_version = 3;
     */
    t(this, "protocolVersion", 0);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new je().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new je().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new je().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(je, e, n);
  }
};
t(je, "runtime", a), t(je, "typeName", "SignedPreKey"), t(je, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "signed_pre_key",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "version",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "protocol_version",
    kind: "scalar",
    T: 13
  }
]));
let Br = je;
const Xe = class Xe extends l {
  constructor(e) {
    super();
    /**
     * Identity key
     *
     * @generated from field: bytes identity = 1;
     */
    t(this, "identity", new Uint8Array(0));
    /**
     * Installation id
     *
     * @generated from field: map<string, SignedPreKey> signed_pre_keys = 2;
     */
    t(this, "signedPreKeys", {});
    /**
     * Prekey signature
     *
     * @generated from field: bytes signature = 4;
     */
    t(this, "signature", new Uint8Array(0));
    /**
     * When the bundle was created locally
     *
     * @generated from field: int64 timestamp = 5;
     */
    t(this, "timestamp", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Xe().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Xe().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Xe().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Xe, e, n);
  }
};
t(Xe, "runtime", a), t(Xe, "typeName", "Bundle"), t(Xe, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "identity",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "signed_pre_keys",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Br }
  },
  {
    no: 4,
    name: "signature",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 5,
    name: "timestamp",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]));
let bt = Xe;
const Ze = class Ze extends l {
  constructor(e) {
    super();
    /**
     * X3DH prekey bundle
     *
     * @generated from field: Bundle bundle = 1;
     */
    t(this, "bundle");
    /**
     * Private signed prekey
     *
     * @generated from field: bytes private_signed_pre_key = 2;
     */
    t(this, "privateSignedPreKey", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Ze().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Ze().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Ze().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Ze, e, n);
  }
};
t(Ze, "runtime", a), t(Ze, "typeName", "BundleContainer"), t(Ze, "fields", a.util.newFieldList(() => [
  { no: 1, name: "bundle", kind: "message", T: bt },
  {
    no: 2,
    name: "private_signed_pre_key",
    kind: "scalar",
    T: 12
  }
]));
let Pa = Ze;
const $e = class $e extends l {
  constructor(e) {
    super();
    /**
     * Current ratchet public key
     *
     * @generated from field: bytes key = 1;
     */
    t(this, "key", new Uint8Array(0));
    /**
     * Number of the message in the sending chain
     *
     * @generated from field: uint32 n = 2;
     */
    t(this, "n", 0);
    /**
     * Length of the previous sending chain
     *
     * @generated from field: uint32 pn = 3;
     */
    t(this, "pn", 0);
    /**
     * Bundle ID
     *
     * @generated from field: bytes id = 4;
     */
    t(this, "id", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new $e().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new $e().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new $e().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals($e, e, n);
  }
};
t($e, "runtime", a), t($e, "typeName", "DRHeader"), t($e, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "n",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "pn",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 4,
    name: "id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Ur = $e;
const en = class en extends l {
  constructor(e) {
    super();
    /**
     * Compressed ephemeral public key
     *
     * @generated from field: bytes key = 1;
     */
    t(this, "key", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new en().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new en().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new en().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(en, e, n);
  }
};
t(en, "runtime", a), t(en, "typeName", "DHHeader"), t(en, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Rr = en;
const nn = class nn extends l {
  constructor(e) {
    super();
    /**
     * Ephemeral key used
     *
     * @generated from field: bytes key = 1;
     */
    t(this, "key", new Uint8Array(0));
    /**
     * Used bundle's signed prekey
     *
     * @generated from field: bytes id = 4;
     */
    t(this, "id", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new nn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new nn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new nn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(nn, e, n);
  }
};
t(nn, "runtime", a), t(nn, "typeName", "X3DHHeader"), t(nn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Jr = nn;
const tn = class tn extends l {
  constructor(e) {
    super();
    /**
     * deprecated group key ID
     *
     * @generated from field: uint32 deprecated_key_id = 1;
     */
    t(this, "deprecatedKeyId", 0);
    /**
     * group message number for this key_id
     *
     * @generated from field: uint32 seq_no = 2;
     */
    t(this, "seqNo", 0);
    /**
     * group ID
     *
     * @generated from field: bytes group_id = 3;
     */
    t(this, "groupId", new Uint8Array(0));
    /**
     * group key ID
     *
     * @generated from field: bytes key_id = 4;
     */
    t(this, "keyId", new Uint8Array(0));
    /**
     * @generated from field: HRKeys keys = 5;
     */
    t(this, "keys");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new tn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new tn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new tn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(tn, e, n);
  }
};
t(tn, "runtime", a), t(tn, "typeName", "HRHeader"), t(tn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "deprecated_key_id",
    kind: "scalar",
    T: 13
  },
  {
    no: 2,
    name: "seq_no",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "group_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "key_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  { no: 5, name: "keys", kind: "message", T: Dr }
]));
let Pr = tn;
const rn = class rn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint64 timestamp = 2;
     */
    t(this, "timestamp", d.zero);
    /**
     * @generated from field: map<uint32, bytes> keys = 4;
     */
    t(this, "keys", {});
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new rn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new rn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new rn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(rn, e, n);
  }
};
t(rn, "runtime", a), t(rn, "typeName", "RekeyGroup"), t(rn, "fields", a.util.newFieldList(() => [
  {
    no: 2,
    name: "timestamp",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 4,
    name: "keys",
    kind: "map",
    K: 13,
    V: {
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  }
]));
let Lr = rn;
const an = class an extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated HRKey keys = 1;
     */
    t(this, "keys", []);
    /**
     * @generated from field: RekeyGroup rekey_group = 2;
     */
    t(this, "rekeyGroup");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new an().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new an().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new an().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(an, e, n);
  }
};
t(an, "runtime", a), t(an, "typeName", "HRKeys"), t(an, "fields", a.util.newFieldList(() => [
  { no: 1, name: "keys", kind: "message", T: vr, repeated: !0 },
  { no: 2, name: "rekey_group", kind: "message", T: Lr }
]));
let Dr = an;
const sn = class sn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: uint32 deprecated_key_id = 1;
     */
    t(this, "deprecatedKeyId", 0);
    /**
     * @generated from field: bytes key = 2;
     */
    t(this, "key", new Uint8Array(0));
    /**
     * @generated from field: uint64 timestamp = 3;
     */
    t(this, "timestamp", d.zero);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new sn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new sn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new sn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(sn, e, n);
  }
};
t(sn, "runtime", a), t(sn, "typeName", "HRKey"), t(sn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "deprecated_key_id",
    kind: "scalar",
    T: 13
  },
  {
    no: 2,
    name: "key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "timestamp",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  }
]));
let vr = sn;
const on = class on extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: X3DHHeader X3DH_header = 1;
     */
    t(this, "X3DHHeader");
    /**
     * @generated from field: DRHeader DR_header = 2;
     */
    t(this, "DRHeader");
    /**
     * @generated from field: DHHeader DH_header = 101;
     */
    t(this, "DHHeader");
    /**
     * @generated from field: HRHeader HR_header = 102;
     */
    t(this, "HRHeader");
    /**
     * Encrypted payload
     *
     * @generated from field: bytes payload = 3;
     */
    t(this, "payload", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new on().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new on().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new on().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(on, e, n);
  }
};
t(on, "runtime", a), t(on, "typeName", "EncryptedMessageProtocol"), t(on, "fields", a.util.newFieldList(() => [
  { no: 1, name: "X3DH_header", kind: "message", T: Jr },
  { no: 2, name: "DR_header", kind: "message", T: Ur },
  { no: 101, name: "DH_header", kind: "message", T: Rr },
  { no: 102, name: "HR_header", kind: "message", T: Pr },
  {
    no: 3,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Fr = on;
const ln = class ln extends l {
  constructor(e) {
    super();
    /**
     * The device id of the sender
     *
     * @generated from field: string installation_id = 2;
     */
    t(this, "installationId", "");
    /**
     * List of bundles
     *
     * @generated from field: repeated Bundle bundles = 3;
     */
    t(this, "bundles", []);
    /**
     * One to one message, encrypted, indexed by installation_id
     * TODO map here is redundant in case of community messages
     *
     * @generated from field: map<string, EncryptedMessageProtocol> encrypted_message = 101;
     */
    t(this, "encryptedMessage", {});
    /**
     * Public chats, not encrypted
     *
     * @generated from field: bytes public_message = 102;
     */
    t(this, "publicMessage", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new ln().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new ln().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new ln().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(ln, e, n);
  }
};
t(ln, "runtime", a), t(ln, "typeName", "ProtocolMessage"), t(ln, "fields", a.util.newFieldList(() => [
  {
    no: 2,
    name: "installation_id",
    kind: "scalar",
    T: 9
  },
  { no: 3, name: "bundles", kind: "message", T: bt, repeated: !0 },
  {
    no: 101,
    name: "encrypted_message",
    kind: "map",
    K: 9,
    V: { kind: "message", T: Fr }
  },
  {
    no: 102,
    name: "public_message",
    kind: "scalar",
    T: 12
  }
]));
let Bt = ln;
const vi = BigInt(120 * 1e3);
function In(r, i) {
  return !(r <= 0 || r > BigInt(i.getTime()) + vi);
}
function ii(r, i) {
  const e = ut(Wr(i, r));
  return `0x${Yn(e)}`;
}
function $n(r) {
  return r.slice(68);
}
function Fi(r, i) {
  const { messageId: e, chatUuid: n, signerPublicKey: s, community: c, chat: u } = i;
  return {
    ...r,
    messageId: e,
    chatUuid: n,
    pinned: !1,
    signer: s,
    reactions: {
      THUMBS_UP: /* @__PURE__ */ new Set(),
      THUMBS_DOWN: /* @__PURE__ */ new Set(),
      LOVE: /* @__PURE__ */ new Set(),
      LAUGH: /* @__PURE__ */ new Set(),
      SAD: /* @__PURE__ */ new Set(),
      ANGRY: /* @__PURE__ */ new Set()
    },
    member: c.getMember(s),
    // todo?: asign as .community, .community.description, .communityDescription, or .community.displayName
    communityDisplayName: c.description.identity.displayName,
    chatDisplayName: u.description.identity.displayName
  };
}
function Gi(r, i, e, n) {
  if (!r.payload || !r.signaturePublicKey || !r.timestamp)
    return;
  let s = r.payload, c;
  try {
    c = Bt.fromBinary(s), c && (s = c.publicMessage);
  } catch {
  }
  const u = et.fromBinary(s);
  if (!u.payload)
    return;
  s = u.payload;
  const m = zr(
    u.signature,
    u.payload
  ), f = ii(
    c?.publicMessage ?? r.payload,
    m
  ), g = r.timestamp, k = `0x${Yn(m)}`;
  if (!i.wakuMessages.has(f)) {
    i.wakuMessages.add(f);
    try {
      switch (u.type) {
        case I.COMMUNITY_DESCRIPTION: {
          const h = it.fromBinary(s);
          if (!In(BigInt(h.clock), g) || !e.isOwner(k))
            return;
          e.handleDescription(h), e.setClock(BigInt(h.clock)), n?.updateMembership(e);
          break;
        }
        case I.CHAT_MESSAGE: {
          const h = rt.fromBinary(s);
          if (!In(BigInt(h.clock), g))
            return;
          switch (h.messageType) {
            case S.COMMUNITY_CHAT: {
              if (!e.isMember(k))
                return;
              const y = $n(h.chatId), A = e.chats.get(y);
              if (!A)
                return;
              const N = Fi(h, {
                messageId: f,
                chatUuid: y,
                signerPublicKey: k,
                community: e,
                chat: A
              });
              A.handleNewMessage(N, g), A.setClock(h.clock);
              break;
            }
            default:
              break;
          }
          break;
        }
        case I.EDIT_MESSAGE: {
          const h = ft.fromBinary(s);
          if (!In(BigInt(h.clock), g))
            return;
          switch (h.messageType) {
            case S.COMMUNITY_CHAT: {
              if (!e.isMember(k))
                return;
              const y = h.messageId, A = $n(h.chatId), N = e.chats.get(A);
              if (!N)
                return;
              N.handleEditedMessage(
                y,
                h.text,
                h.clock,
                k
              ), N.setClock(h.clock);
              break;
            }
            default:
              break;
          }
          break;
        }
        case I.DELETE_MESSAGE: {
          const h = St.fromBinary(s);
          if (!In(BigInt(h.clock), g))
            return;
          switch (h.messageType) {
            case S.COMMUNITY_CHAT: {
              if (!e.isMember(k))
                return;
              const y = h.messageId, A = $n(h.chatId), N = e.chats.get(A);
              if (!N)
                return;
              N.handleDeletedMessage(
                y,
                h.clock,
                k
              ), N.setClock(h.clock);
              break;
            }
            default:
              break;
          }
          break;
        }
        case I.PIN_MESSAGE: {
          const h = br.fromBinary(s);
          if (!In(BigInt(h.clock), g))
            return;
          switch (h.messageType) {
            case S.COMMUNITY_CHAT: {
              if (!e.isMember(k))
                return;
              const y = h.messageId, A = $n(h.chatId), N = e.chats.get(A);
              if (!N)
                return;
              N.handlePinnedMessage(
                y,
                h.clock,
                h.pinned
              ), N.setClock(h.clock);
              break;
            }
            default:
              break;
          }
          break;
        }
        case I.EMOJI_REACTION: {
          const h = kt.fromBinary(s);
          if (!In(BigInt(h.clock), g))
            return;
          switch (h.messageType) {
            case S.COMMUNITY_CHAT: {
              if (!e.isMember(k))
                return;
              const y = h.messageId, A = $n(h.chatId), N = e.chats.get(A);
              if (!N)
                return;
              N.handleEmojiReaction(
                y,
                h,
                h.clock,
                k
              ), N.setClock(h.clock);
              break;
            }
            default:
              break;
          }
          break;
        }
        default:
          break;
      }
    } catch {
    }
  }
}
var Jt, _n, ht;
class Yi {
  constructor() {
    T(this, _n);
    T(this, Jt, "status-im:");
  }
  getItem(i) {
    const e = window.localStorage.getItem(mt(this, _n, ht).call(this, i));
    if (!e)
      return null;
    try {
      return JSON.parse(e);
    } catch {
      return null;
    }
  }
  setItem(i, e) {
    try {
      return window.localStorage.setItem(
        mt(this, _n, ht).call(this, i),
        JSON.stringify(e)
      ), !0;
    } catch {
      return !1;
    }
  }
  removeItem(i) {
    return window.localStorage.removeItem(mt(this, _n, ht).call(this, i));
  }
  subscribe(i, e) {
    const n = (s) => {
      s.key === i && s.newValue && e(JSON.parse(s.newValue));
    };
    return window.addEventListener("storage", n), () => {
      window.removeEventListener("storage", n);
    };
  }
}
Jt = new WeakMap(), _n = new WeakSet(), ht = function(i) {
  return `${o(this, Jt)}${i}`;
};
const La = "throwaway_account";
var ot, Dn, O, Vn;
const aa = class aa {
  constructor(i, e) {
    t(this, "waku");
    t(this, "wakuMessages");
    /**
     * Tracks open connections which had their streams silently destroyed
     * and closes them so new connections can be automatically created
     * by libp2p's dial mechanism.
     *
     * For example, in case of a websocket in browser which did not
     * have its close event emitted.
     *
     * Note: Detection of the stream removal depends pinging the peer.
     *
     * Note: This is only a workaround (@see https://github.com/libp2p/js-libp2p/issues/939).
     */
    T(this, ot);
    t(this, "connected");
    T(this, Dn);
    t(this, "activityCenter");
    t(this, "community");
    T(this, O);
    T(this, Vn, /* @__PURE__ */ new Set());
    t(this, "storage");
    t(this, "onConnection", (i) => (o(this, Dn).add(i), () => {
      o(this, Dn).delete(i);
    }));
    t(this, "emitConnection", (i) => {
      o(this, Dn).forEach((e) => e(i));
    });
    t(this, "sendWakuMessage", async (i, e, n, s) => {
      if (!this.waku)
        throw new Error("Waku not started");
      if (!o(this, O))
        throw new Error("Account not created");
      const c = await o(this, O).sign(e), u = new et({
        type: i,
        signature: c,
        payload: e
      }).toBinary();
      await this.waku.lightPush.send(
        ui({
          contentTopic: n,
          symKey: s,
          sigPrivKey: Pt(o(this, O).privateKey),
          pubsubTopicShardInfo: {
            clusterId: 16,
            shard: 32
          }
        }),
        { payload: u }
      );
    });
    t(this, "handleWakuMessage", (i) => {
      Gi(i, this, this.community, o(this, O));
    });
    this.connected = !0, E(this, Dn, /* @__PURE__ */ new Set()), this.waku = i, this.wakuMessages = /* @__PURE__ */ new Set(), E(this, ot, setInterval(async () => {
      const s = [];
      for (const c of this.waku.libp2p.getConnections())
        try {
          await this.waku.libp2p.services.ping.ping(c.remoteAddr), this.connected || (this.connected = !0, this.emitConnection(this.connected));
        } catch {
          s.push(c.close());
        }
      await Promise.allSettled(s);
    }, 10 * 1e3)), this.waku.libp2p.addEventListener("peer:connect", () => {
      this.connected = !0, this.emitConnection(this.connected);
    }), i.libp2p.addEventListener("peer:disconnect", () => {
      this.connected = !1, this.emitConnection(this.connected);
    }), window.addEventListener("offline", () => {
      this.connected = !1, this.emitConnection(this.connected);
    }), this.storage = e.storage ?? new Yi(), this.activityCenter = new bi(this), this.community = new Di(this, e.publicKey);
    const n = this.storage.getItem(La);
    n && E(this, O, new ya(this, n));
  }
  static async start(i) {
    const { environment: e = "development" } = i;
    let n, s;
    try {
      n = await _a({
        defaultBootstrap: !1,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        emitSelf: !0,
        /**
         * Note: Delegated to `wakuDisconnectionTimer`.
         */
        pingKeepAlive: 0,
        /**
         * Note: Not supported in light mode.
         */
        relayKeepAlive: 0,
        libp2p: {
          peerDiscovery: [
            /**
             * >only connects to 1 remote node because of the limited number of nodes
             * >run by Status and the limited number of connections provided by these nodes
             * >
             * >@see https://forum.vac.dev/t/waku-v2-scalability-studies/142/2
             */
            qa({
              list: $a[e],
              timeout: 0
              // note: Infinity prevents connection
              // tagTTL: Infinity,
            })
          ]
        },
        shardInfo: {
          clusterId: 16,
          shards: [32]
        }
      }), await n.start(), await Va(
        n,
        [xn.Store, xn.Filter, xn.LightPush],
        10 * 1e3
      ), s = new aa(n, i), await s.community.start();
    } catch (c) {
      throw s ? await s.stop() : n && await n.stop(), c;
    }
    return s;
  }
  async stop() {
    clearInterval(o(this, ot)), await this.waku.stop();
  }
  get account() {
    return o(this, O);
  }
  set account(i) {
    E(this, O, i), this.storage.setItem(La, o(this, O));
    for (const e of o(this, Vn))
      e(o(this, O));
  }
  createAccount() {
    return this.account = new ya(this), this.account.updateMembership(this.community), this.account;
  }
  deleteAccount() {
    this.account = void 0;
  }
  onAccountChange(i) {
    return o(this, Vn).add(i), () => {
      o(this, Vn).delete(i);
    };
  }
};
ot = new WeakMap(), Dn = new WeakMap(), O = new WeakMap(), Vn = new WeakMap();
let Gr = aa;
async function ls(r) {
  return await Gr.start(r);
}
function Ki(r) {
  const i = ni(r, {
    compress: !1
  });
  return Kn.computeAddress(i);
}
var wn;
class Hi {
  constructor(i) {
    T(this, wn);
    E(this, wn, new Kn.JsonRpcProvider(i));
  }
  stop() {
    o(this, wn).destroy();
  }
  async resolvePublicKey(i, e) {
    try {
      const n = await o(this, wn).getResolver(i);
      if (!n)
        return;
      const s = n.address, c = [
        "function pubkey(bytes32 node) view returns (bytes32 x, bytes32 y)"
      ], u = new Kn.Contract(s, c, o(this, wn)), m = Kn.namehash(i), [f, g] = await u.pubkey(m), k = BigInt(f), h = BigInt(g), y = new Qa(k, h);
      return y.assertValidity(), `0x${y.toHex(e.compress)}`;
    } catch {
      return;
    }
  }
  async resolveOwner(i, e) {
    try {
      const s = await new Kn.Contract(
        i,
        ["function getEntry(address _communityAddress) view returns (address)"],
        o(this, wn)
      ).getEntry(
        Ki(e)
      );
      return await new Kn.Contract(
        s,
        ["function signerPublicKey() view returns (bytes)"],
        o(this, wn)
      ).signerPublicKey();
    } catch {
      return;
    }
  }
}
wn = new WeakMap();
const $r = {
  Activism: "✊",
  Art: "🎨",
  Blockchain: "🔗",
  "Books & blogs": "📚",
  Career: "💼",
  Collaboration: "🤝",
  Commerce: "🛒",
  Culture: "🎎",
  DAO: "🚀",
  DeFi: "📈",
  Design: "🧩",
  DIY: "🔨",
  Environment: "🌿",
  Education: "🎒",
  Entertainment: "🍿",
  Ethereum: "Ξ",
  Event: "🗓",
  Fantasy: "🧙‍♂️",
  Fashion: "🧦",
  Food: "🌶",
  Gaming: "🎮",
  Global: "🌍",
  Health: "🧠",
  Hobby: "📐",
  Innovation: "🧪",
  Language: "📜",
  Lifestyle: "✨",
  Local: "📍",
  Love: "❤️",
  Markets: "💎",
  "Movies & TV": "🎞",
  Music: "🎶",
  News: "🗞",
  NFT: "🖼",
  "Non-profit": "🙏",
  NSFW: "🍆",
  Org: "🏢",
  Pets: "🐶",
  Play: "🎲",
  Podcast: "🎙️",
  Politics: "🗳️",
  Product: "🍱",
  Psyche: "🍁",
  Privacy: "👻",
  Security: "🔒",
  Social: "☕",
  "Software dev": "👩‍💻",
  Sports: "⚽️",
  Tech: "📱",
  Travel: "🗺",
  Vehicles: "🚕",
  Web3: "🌐"
}, cs = (r) => {
  const i = Object.entries($r);
  return r.reduce((e, n) => {
    const s = i[n];
    return s && e.push({ text: s[0], emoji: s[1] }), e;
  }, []);
}, Kt = {
  1: {
    CommunityOwnerTokenRegistry: "0x898331B756EE1f29302DeF227a4471e960c50612"
  },
  10: {
    CommunityOwnerTokenRegistry: "0x0AF2c7d60E89a941D586216059814D1Cb4Bd4CAb"
  },
  42161: {
    CommunityOwnerTokenRegistry: "0x76352764590378011CAE677b50110Ae02eDE2b62"
  }
}, Da = {
  development: Kt,
  preview: Kt,
  production: Kt
}, Ht = {
  infura: {
    1: "https://mainnet.infura.io/v3/",
    10: "https://optimism-mainnet.infura.io/v3/",
    42161: "https://arbitrum-mainnet.infura.io/v3/"
  }
}, va = {
  development: Ht,
  preview: Ht,
  production: Ht
}, cn = class cn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: PushNotificationRegistration.TokenType token_type = 1;
     */
    t(this, "tokenType", 0);
    /**
     * @generated from field: string device_token = 2;
     */
    t(this, "deviceToken", "");
    /**
     * @generated from field: string installation_id = 3;
     */
    t(this, "installationId", "");
    /**
     * @generated from field: string access_token = 4;
     */
    t(this, "accessToken", "");
    /**
     * @generated from field: bool enabled = 5;
     */
    t(this, "enabled", !1);
    /**
     * @generated from field: uint64 version = 6;
     */
    t(this, "version", d.zero);
    /**
     * @generated from field: repeated bytes allowed_key_list = 7;
     */
    t(this, "allowedKeyList", []);
    /**
     * @generated from field: repeated bytes blocked_chat_list = 8;
     */
    t(this, "blockedChatList", []);
    /**
     * @generated from field: bool unregister = 9;
     */
    t(this, "unregister", !1);
    /**
     * @generated from field: bytes grant = 10;
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * @generated from field: bool allow_from_contacts_only = 11;
     */
    t(this, "allowFromContactsOnly", !1);
    /**
     * @generated from field: string apn_topic = 12;
     */
    t(this, "apnTopic", "");
    /**
     * @generated from field: bool block_mentions = 13;
     */
    t(this, "blockMentions", !1);
    /**
     * @generated from field: repeated bytes allowed_mentions_chat_list = 14;
     */
    t(this, "allowedMentionsChatList", []);
    /**
     * @generated from field: repeated bytes muted_chat_list = 15;
     */
    t(this, "mutedChatList", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new cn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new cn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new cn().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(cn, e, n);
  }
};
t(cn, "runtime", a), t(cn, "typeName", "PushNotificationRegistration"), t(cn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "token_type",
    kind: "enum",
    T: a.getEnumType(ea)
  },
  {
    no: 2,
    name: "device_token",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "installation_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 4,
    name: "access_token",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "enabled",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 6,
    name: "version",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 7,
    name: "allowed_key_list",
    kind: "scalar",
    T: 12,
    repeated: !0
  },
  {
    no: 8,
    name: "blocked_chat_list",
    kind: "scalar",
    T: 12,
    repeated: !0
  },
  {
    no: 9,
    name: "unregister",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 10,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 11,
    name: "allow_from_contacts_only",
    kind: "scalar",
    T: 8
  },
  {
    no: 12,
    name: "apn_topic",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 13,
    name: "block_mentions",
    kind: "scalar",
    T: 8
  },
  {
    no: 14,
    name: "allowed_mentions_chat_list",
    kind: "scalar",
    T: 12,
    repeated: !0
  },
  {
    no: 15,
    name: "muted_chat_list",
    kind: "scalar",
    T: 12,
    repeated: !0
  }
]));
let Fa = cn;
var ea = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_TOKEN_TYPE = 0] = "UNKNOWN_TOKEN_TYPE", r[r.APN_TOKEN = 1] = "APN_TOKEN", r[r.FIREBASE_TOKEN = 2] = "FIREBASE_TOKEN", r))(ea || {});
a.util.setEnumType(
  ea,
  "PushNotificationRegistration.TokenType",
  [
    { no: 0, name: "UNKNOWN_TOKEN_TYPE" },
    { no: 1, name: "APN_TOKEN" },
    { no: 2, name: "FIREBASE_TOKEN" }
  ]
);
const un = class un extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bool success = 1;
     */
    t(this, "success", !1);
    /**
     * @generated from field: PushNotificationRegistrationResponse.ErrorType error = 2;
     */
    t(this, "error", 0);
    /**
     * @generated from field: bytes request_id = 3;
     */
    t(this, "requestId", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new un().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new un().fromJson(
      e,
      n
    );
  }
  static fromJsonString(e, n) {
    return new un().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(un, e, n);
  }
};
t(un, "runtime", a), t(un, "typeName", "PushNotificationRegistrationResponse"), t(un, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "success",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 2,
    name: "error",
    kind: "enum",
    T: a.getEnumType(na)
  },
  {
    no: 3,
    name: "request_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Ga = un;
var na = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_ERROR_TYPE = 0] = "UNKNOWN_ERROR_TYPE", r[r.MALFORMED_MESSAGE = 1] = "MALFORMED_MESSAGE", r[r.VERSION_MISMATCH = 2] = "VERSION_MISMATCH", r[r.UNSUPPORTED_TOKEN_TYPE = 3] = "UNSUPPORTED_TOKEN_TYPE", r[r.INTERNAL_ERROR = 4] = "INTERNAL_ERROR", r))(na || {});
a.util.setEnumType(
  na,
  "PushNotificationRegistrationResponse.ErrorType",
  [
    { no: 0, name: "UNKNOWN_ERROR_TYPE" },
    { no: 1, name: "MALFORMED_MESSAGE" },
    { no: 2, name: "VERSION_MISMATCH" },
    { no: 3, name: "UNSUPPORTED_TOKEN_TYPE" },
    { no: 4, name: "INTERNAL_ERROR" }
  ]
);
const mn = class mn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated PushNotificationQueryInfo push_notification_info = 1;
     */
    t(this, "pushNotificationInfo", []);
    /**
     * @generated from field: ChatIdentity chat_identity = 2;
     */
    t(this, "chatIdentity");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new mn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new mn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new mn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(mn, e, n);
  }
};
t(mn, "runtime", a), t(mn, "typeName", "ContactCodeAdvertisement"), t(mn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "push_notification_info",
    kind: "message",
    T: Ut,
    repeated: !0
  },
  { no: 2, name: "chat_identity", kind: "message", T: at }
]));
let Yr = mn;
const dn = class dn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated bytes public_keys = 1;
     */
    t(this, "publicKeys", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new dn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new dn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new dn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(dn, e, n);
  }
};
t(dn, "runtime", a), t(dn, "typeName", "PushNotificationQuery"), t(dn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "public_keys",
    kind: "scalar",
    T: 12,
    repeated: !0
  }
]));
let Ya = dn;
const hn = class hn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string access_token = 1;
     */
    t(this, "accessToken", "");
    /**
     * @generated from field: string installation_id = 2;
     */
    t(this, "installationId", "");
    /**
     * @generated from field: bytes public_key = 3;
     */
    t(this, "publicKey", new Uint8Array(0));
    /**
     * @generated from field: repeated bytes allowed_key_list = 4;
     */
    t(this, "allowedKeyList", []);
    /**
     * @generated from field: bytes grant = 5;
     */
    t(this, "grant", new Uint8Array(0));
    /**
     * @generated from field: uint64 version = 6;
     */
    t(this, "version", d.zero);
    /**
     * @generated from field: bytes server_public_key = 7;
     */
    t(this, "serverPublicKey", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new hn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new hn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new hn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(hn, e, n);
  }
};
t(hn, "runtime", a), t(hn, "typeName", "PushNotificationQueryInfo"), t(hn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "access_token",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "installation_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "public_key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "allowed_key_list",
    kind: "scalar",
    T: 12,
    repeated: !0
  },
  {
    no: 5,
    name: "grant",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 6,
    name: "version",
    kind: "scalar",
    T: 4
    /* ScalarType.UINT64 */
  },
  {
    no: 7,
    name: "server_public_key",
    kind: "scalar",
    T: 12
  }
]));
let Ut = hn;
const En = class En extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated PushNotificationQueryInfo info = 1;
     */
    t(this, "info", []);
    /**
     * @generated from field: bytes message_id = 2;
     */
    t(this, "messageId", new Uint8Array(0));
    /**
     * @generated from field: bool success = 3;
     */
    t(this, "success", !1);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new En().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new En().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new En().fromJsonString(
      e,
      n
    );
  }
  static equals(e, n) {
    return a.util.equals(En, e, n);
  }
};
t(En, "runtime", a), t(En, "typeName", "PushNotificationQueryResponse"), t(En, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "info",
    kind: "message",
    T: Ut,
    repeated: !0
  },
  {
    no: 2,
    name: "message_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "success",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]));
let Ka = En;
const Tn = class Tn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: string access_token = 1;
     */
    t(this, "accessToken", "");
    /**
     * @generated from field: bytes chat_id = 2;
     */
    t(this, "chatId", new Uint8Array(0));
    /**
     * @generated from field: bytes public_key = 3;
     */
    t(this, "publicKey", new Uint8Array(0));
    /**
     * @generated from field: string installation_id = 4;
     */
    t(this, "installationId", "");
    /**
     * @generated from field: bytes message = 5;
     */
    t(this, "message", new Uint8Array(0));
    /**
     * @generated from field: PushNotification.PushNotificationType type = 6;
     */
    t(this, "type", 0);
    /**
     * @generated from field: bytes author = 7;
     */
    t(this, "author", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Tn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Tn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Tn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Tn, e, n);
  }
};
t(Tn, "runtime", a), t(Tn, "typeName", "PushNotification"), t(Tn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "access_token",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "chat_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 3,
    name: "public_key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "installation_id",
    kind: "scalar",
    T: 9
  },
  {
    no: 5,
    name: "message",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 6,
    name: "type",
    kind: "enum",
    T: a.getEnumType(ta)
  },
  {
    no: 7,
    name: "author",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Kr = Tn;
var ta = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_PUSH_NOTIFICATION_TYPE = 0] = "UNKNOWN_PUSH_NOTIFICATION_TYPE", r[r.MESSAGE = 1] = "MESSAGE", r[r.MENTION = 2] = "MENTION", r[r.REQUEST_TO_JOIN_COMMUNITY = 3] = "REQUEST_TO_JOIN_COMMUNITY", r))(ta || {});
a.util.setEnumType(
  ta,
  "PushNotification.PushNotificationType",
  [
    { no: 0, name: "UNKNOWN_PUSH_NOTIFICATION_TYPE" },
    { no: 1, name: "MESSAGE" },
    { no: 2, name: "MENTION" },
    { no: 3, name: "REQUEST_TO_JOIN_COMMUNITY" }
  ]
);
const fn = class fn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: repeated PushNotification requests = 1;
     */
    t(this, "requests", []);
    /**
     * @generated from field: bytes message_id = 2;
     */
    t(this, "messageId", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new fn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new fn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new fn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(fn, e, n);
  }
};
t(fn, "runtime", a), t(fn, "typeName", "PushNotificationRequest"), t(fn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "requests",
    kind: "message",
    T: Kr,
    repeated: !0
  },
  {
    no: 2,
    name: "message_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let Ha = fn;
const Sn = class Sn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bool success = 1;
     */
    t(this, "success", !1);
    /**
     * @generated from field: PushNotificationReport.ErrorType error = 2;
     */
    t(this, "error", 0);
    /**
     * @generated from field: bytes public_key = 3;
     */
    t(this, "publicKey", new Uint8Array(0));
    /**
     * @generated from field: string installation_id = 4;
     */
    t(this, "installationId", "");
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Sn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Sn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Sn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Sn, e, n);
  }
};
t(Sn, "runtime", a), t(Sn, "typeName", "PushNotificationReport"), t(Sn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "success",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  {
    no: 2,
    name: "error",
    kind: "enum",
    T: a.getEnumType(ra)
  },
  {
    no: 3,
    name: "public_key",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 4,
    name: "installation_id",
    kind: "scalar",
    T: 9
  }
]));
let Hr = Sn;
var ra = /* @__PURE__ */ ((r) => (r[r.UNKNOWN_ERROR_TYPE = 0] = "UNKNOWN_ERROR_TYPE", r[r.WRONG_TOKEN = 1] = "WRONG_TOKEN", r[r.INTERNAL_ERROR = 2] = "INTERNAL_ERROR", r[r.NOT_REGISTERED = 3] = "NOT_REGISTERED", r))(ra || {});
a.util.setEnumType(
  ra,
  "PushNotificationReport.ErrorType",
  [
    { no: 0, name: "UNKNOWN_ERROR_TYPE" },
    { no: 1, name: "WRONG_TOKEN" },
    { no: 2, name: "INTERNAL_ERROR" },
    { no: 3, name: "NOT_REGISTERED" }
  ]
);
const yn = class yn extends l {
  constructor(e) {
    super();
    /**
     * @generated from field: bytes message_id = 1;
     */
    t(this, "messageId", new Uint8Array(0));
    /**
     * @generated from field: repeated PushNotificationReport reports = 2;
     */
    t(this, "reports", []);
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new yn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new yn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new yn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(yn, e, n);
  }
};
t(yn, "runtime", a), t(yn, "typeName", "PushNotificationResponse"), t(yn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "message_id",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  },
  {
    no: 2,
    name: "reports",
    kind: "message",
    T: Hr,
    repeated: !0
  }
]));
let xa = yn;
const Nn = class Nn extends l {
  constructor(e) {
    super();
    /**
     * hash of the entire original message
     *
     * @generated from field: bytes entire_message_hash = 1;
     */
    t(this, "entireMessageHash", new Uint8Array(0));
    /**
     * Index of this segment within the entire original message
     *
     * @generated from field: uint32 index = 2;
     */
    t(this, "index", 0);
    /**
     * Total number of segments the entire original message is divided into
     *
     * @generated from field: uint32 segments_count = 3;
     */
    t(this, "segmentsCount", 0);
    /**
     * The payload data for this particular segment
     *
     * @generated from field: bytes payload = 4;
     */
    t(this, "payload", new Uint8Array(0));
    a.util.initPartial(e, this);
  }
  static fromBinary(e, n) {
    return new Nn().fromBinary(e, n);
  }
  static fromJson(e, n) {
    return new Nn().fromJson(e, n);
  }
  static fromJsonString(e, n) {
    return new Nn().fromJsonString(e, n);
  }
  static equals(e, n) {
    return a.util.equals(Nn, e, n);
  }
};
t(Nn, "runtime", a), t(Nn, "typeName", "SegmentMessage"), t(Nn, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "entire_message_hash",
    kind: "scalar",
    T: 12
  },
  {
    no: 2,
    name: "index",
    kind: "scalar",
    T: 13
    /* ScalarType.UINT32 */
  },
  {
    no: 3,
    name: "segments_count",
    kind: "scalar",
    T: 13
  },
  {
    no: 4,
    name: "payload",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let xr = Nn;
function si(r) {
  const { identity: i, tags: e, members: n } = r;
  return i ? {
    banner: i.images.banner?.payload,
    photo: i.images.thumbnail?.payload,
    displayName: i.displayName,
    description: i.description,
    membersCount: Object.keys(n).length,
    tags: e.reduce((c, u) => {
      const m = $r[u];
      return m && c.push({
        text: u,
        emoji: m
      }), c;
    }, []),
    color: i.color
  } : void 0;
}
function xi(r, i) {
  const e = si(i);
  if (!e)
    return;
  const { identity: n } = r;
  return n ? {
    emoji: n.emoji,
    displayName: n.displayName,
    description: n.description,
    color: n.color,
    community: e
  } : void 0;
}
const oi = [
  "😀",
  "😃",
  "😄",
  "😁",
  "😆",
  "😅",
  "🤣",
  "😂",
  "🙂",
  "🙃",
  "😉",
  "😊",
  "😇",
  "🥰",
  "😍",
  "🤩",
  "😘",
  "😗",
  "☺️",
  "😚",
  "😙",
  "🥲",
  "😋",
  "😛",
  "😜",
  "🤪",
  "😝",
  "🤑",
  "🤗",
  "🤭",
  "🤫",
  "🤔",
  "🤐",
  "🤨",
  "😐",
  "😑",
  "😶",
  "😏",
  "😒",
  "🙄",
  "😬",
  "🤥",
  "😌",
  "😔",
  "😪",
  "🤤",
  "😴",
  "😷",
  "🤒",
  "🤕",
  "🤢",
  "🤮",
  "🤧",
  "🥵",
  "🥶",
  "🥴",
  "😵",
  "🤯",
  "🤠",
  "🥳",
  "🥸",
  "😎",
  "🤓",
  "🧐",
  "😕",
  "😟",
  "🙁",
  "☹️",
  "😮",
  "😯",
  "😲",
  "😳",
  "🥺",
  "😦",
  "😧",
  "😨",
  "😰",
  "😥",
  "😢",
  "😭",
  "😱",
  "😖",
  "😣",
  "😞",
  "😓",
  "😩",
  "😫",
  "🥱",
  "😤",
  "😡",
  "😠",
  "🤬",
  "😈",
  "👿",
  "💀",
  "☠️",
  "💩",
  "🤡",
  "👹",
  "👺",
  "👻",
  "👽",
  "👾",
  "🤖",
  "😺",
  "😸",
  "😹",
  "😻",
  "😼",
  "😽",
  "🙀",
  "😿",
  "😾",
  "🙈",
  "🙉",
  "🙊",
  "💋",
  "💌",
  "💘",
  "💝",
  "💖",
  "💗",
  "💓",
  "💞",
  "💕",
  "💟",
  "❣️",
  "💔",
  "❤️",
  "🧡",
  "💛",
  "💚",
  "💙",
  "💜",
  "🤎",
  "🖤",
  "🤍",
  "💯",
  "💢",
  "💥",
  "💫",
  "💦",
  "💨",
  "🕳️",
  "💣",
  "💬",
  "👁️‍🗨️",
  "🗨️",
  "🗯️",
  "💭",
  "💤",
  "👋",
  "👋🏻",
  "👋🏼",
  "👋🏽",
  "👋🏾",
  "👋🏿",
  "🤚",
  "🤚🏻",
  "🤚🏼",
  "🤚🏽",
  "🤚🏾",
  "🤚🏿",
  "🖐️",
  "🖐🏻",
  "🖐🏼",
  "🖐🏽",
  "🖐🏾",
  "🖐🏿",
  "✋",
  "✋🏻",
  "✋🏼",
  "✋🏽",
  "✋🏾",
  "✋🏿",
  "🖖",
  "🖖🏻",
  "🖖🏼",
  "🖖🏽",
  "🖖🏾",
  "🖖🏿",
  "👌",
  "👌🏻",
  "👌🏼",
  "👌🏽",
  "👌🏾",
  "👌🏿",
  "🤌",
  "🤌🏻",
  "🤌🏼",
  "🤌🏽",
  "🤌🏾",
  "🤌🏿",
  "🤏",
  "🤏🏻",
  "🤏🏼",
  "🤏🏽",
  "🤏🏾",
  "🤏🏿",
  "✌️",
  "✌🏻",
  "✌🏼",
  "✌🏽",
  "✌🏾",
  "✌🏿",
  "🤞",
  "🤞🏻",
  "🤞🏼",
  "🤞🏽",
  "🤞🏾",
  "🤞🏿",
  "🤟",
  "🤟🏻",
  "🤟🏼",
  "🤟🏽",
  "🤟🏾",
  "🤟🏿",
  "🤘",
  "🤘🏻",
  "🤘🏼",
  "🤘🏽",
  "🤘🏾",
  "🤘🏿",
  "🤙",
  "🤙🏻",
  "🤙🏼",
  "🤙🏽",
  "🤙🏾",
  "🤙🏿",
  "👈",
  "👈🏻",
  "👈🏼",
  "👈🏽",
  "👈🏾",
  "👈🏿",
  "👉",
  "👉🏻",
  "👉🏼",
  "👉🏽",
  "👉🏾",
  "👉🏿",
  "👆",
  "👆🏻",
  "👆🏼",
  "👆🏽",
  "👆🏾",
  "👆🏿",
  "👇",
  "👇🏻",
  "👇🏼",
  "👇🏽",
  "👇🏾",
  "👇🏿",
  "☝️",
  "☝🏻",
  "☝🏼",
  "☝🏽",
  "☝🏾",
  "☝🏿",
  "👍",
  "👍🏻",
  "👍🏼",
  "👍🏽",
  "👍🏾",
  "👍🏿",
  "👎",
  "👎🏻",
  "👎🏼",
  "👎🏽",
  "👎🏾",
  "👎🏿",
  "✊",
  "✊🏻",
  "✊🏼",
  "✊🏽",
  "✊🏾",
  "✊🏿",
  "👊",
  "👊🏻",
  "👊🏼",
  "👊🏽",
  "👊🏾",
  "👊🏿",
  "🤛",
  "🤛🏻",
  "🤛🏼",
  "🤛🏽",
  "🤛🏾",
  "🤛🏿",
  "🤜",
  "🤜🏻",
  "🤜🏼",
  "🤜🏽",
  "🤜🏾",
  "🤜🏿",
  "👏",
  "👏🏻",
  "👏🏼",
  "👏🏽",
  "👏🏾",
  "👏🏿",
  "🙌",
  "🙌🏻",
  "🙌🏼",
  "🙌🏽",
  "🙌🏾",
  "🙌🏿",
  "👐",
  "👐🏻",
  "👐🏼",
  "👐🏽",
  "👐🏾",
  "👐🏿",
  "🤲",
  "🤲🏻",
  "🤲🏼",
  "🤲🏽",
  "🤲🏾",
  "🤲🏿",
  "🤝",
  "🙏",
  "🙏🏻",
  "🙏🏼",
  "🙏🏽",
  "🙏🏾",
  "🙏🏿",
  "✍️",
  "✍🏻",
  "✍🏼",
  "✍🏽",
  "✍🏾",
  "✍🏿",
  "💅",
  "💅🏻",
  "💅🏼",
  "💅🏽",
  "💅🏾",
  "💅🏿",
  "🤳",
  "🤳🏻",
  "🤳🏼",
  "🤳🏽",
  "🤳🏾",
  "🤳🏿",
  "💪",
  "💪🏻",
  "💪🏼",
  "💪🏽",
  "💪🏾",
  "💪🏿",
  "🦾",
  "🦿",
  "🦵",
  "🦵🏻",
  "🦵🏼",
  "🦵🏽",
  "🦵🏾",
  "🦵🏿",
  "🦶",
  "🦶🏻",
  "🦶🏼",
  "🦶🏽",
  "🦶🏾",
  "🦶🏿",
  "👂",
  "👂🏻",
  "👂🏼",
  "👂🏽",
  "👂🏾",
  "👂🏿",
  "🦻",
  "🦻🏻",
  "🦻🏼",
  "🦻🏽",
  "🦻🏾",
  "🦻🏿",
  "👃",
  "👃🏻",
  "👃🏼",
  "👃🏽",
  "👃🏾",
  "👃🏿",
  "🧠",
  "🫀",
  "🫁",
  "🦷",
  "🦴",
  "👀",
  "👁️",
  "👅",
  "👄",
  "👶",
  "👶🏻",
  "👶🏼",
  "👶🏽",
  "👶🏾",
  "👶🏿",
  "🧒",
  "🧒🏻",
  "🧒🏼",
  "🧒🏽",
  "🧒🏾",
  "🧒🏿",
  "👦",
  "👦🏻",
  "👦🏼",
  "👦🏽",
  "👦🏾",
  "👦🏿",
  "👧",
  "👧🏻",
  "👧🏼",
  "👧🏽",
  "👧🏾",
  "👧🏿",
  "🧑",
  "🧑🏻",
  "🧑🏼",
  "🧑🏽",
  "🧑🏾",
  "🧑🏿",
  "👱",
  "👱🏻",
  "👱🏼",
  "👱🏽",
  "👱🏾",
  "👱🏿",
  "👨",
  "👨🏻",
  "👨🏼",
  "👨🏽",
  "👨🏾",
  "👨🏿",
  "🧔",
  "🧔🏻",
  "🧔🏼",
  "🧔🏽",
  "🧔🏾",
  "🧔🏿",
  "👨‍🦰",
  "👨🏻‍🦰",
  "👨🏼‍🦰",
  "👨🏽‍🦰",
  "👨🏾‍🦰",
  "👨🏿‍🦰",
  "👨‍🦱",
  "👨🏻‍🦱",
  "👨🏼‍🦱",
  "👨🏽‍🦱",
  "👨🏾‍🦱",
  "👨🏿‍🦱",
  "👨‍🦳",
  "👨🏻‍🦳",
  "👨🏼‍🦳",
  "👨🏽‍🦳",
  "👨🏾‍🦳",
  "👨🏿‍🦳",
  "👨‍🦲",
  "👨🏻‍🦲",
  "👨🏼‍🦲",
  "👨🏽‍🦲",
  "👨🏾‍🦲",
  "👨🏿‍🦲",
  "👩",
  "👩🏻",
  "👩🏼",
  "👩🏽",
  "👩🏾",
  "👩🏿",
  "👩‍🦰",
  "👩🏻‍🦰",
  "👩🏼‍🦰",
  "👩🏽‍🦰",
  "👩🏾‍🦰",
  "👩🏿‍🦰",
  "🧑‍🦰",
  "🧑🏻‍🦰",
  "🧑🏽‍🦰",
  "🧑🏾‍🦰",
  "🧑🏿‍🦰",
  "👩‍🦱",
  "👩🏻‍🦱",
  "👩🏼‍🦱",
  "👩🏽‍🦱",
  "👩🏾‍🦱",
  "👩🏿‍🦱",
  "🧑‍🦱",
  "🧑🏻‍🦱",
  "🧑🏼‍🦱",
  "🧑🏽‍🦱",
  "🧑🏾‍🦱",
  "🧑🏿‍🦱",
  "👩‍🦳",
  "👩🏻‍🦳",
  "👩🏽‍🦳",
  "👩🏾‍🦳",
  "👩🏿‍🦳",
  "🧑‍🦳",
  "🧑🏻‍🦳",
  "🧑🏽‍🦳",
  "🧑🏾‍🦳",
  "🧑🏿‍🦳",
  "👩‍🦲",
  "👩🏻‍🦲",
  "👩🏽‍🦲",
  "👩🏾‍🦲",
  "👩🏿‍🦲",
  "🧑‍🦲",
  "🧑🏻‍🦲",
  "🧑🏼‍🦲",
  "🧑🏽‍🦲",
  "🧑🏾‍🦲",
  "🧑🏿‍🦲",
  "👱‍♀️",
  "👱🏻‍♀️",
  "👱🏽‍♀️",
  "👱🏾‍♀️",
  "👱🏿‍♀️",
  "👱‍♂️",
  "👱🏻‍♂️",
  "👱🏼‍♂️",
  "👱🏽‍♂️",
  "👱🏾‍♂️",
  "👱🏿‍♂️",
  "🧓",
  "🧓🏻",
  "🧓🏽",
  "🧓🏾",
  "🧓🏿",
  "👴",
  "👴🏻",
  "👴🏼",
  "👴🏽",
  "👴🏾",
  "👴🏿",
  "👵",
  "👵🏻",
  "👵🏽",
  "👵🏾",
  "👵🏿",
  "🙍",
  "🙍🏻",
  "🙍🏼",
  "🙍🏽",
  "🙍🏾",
  "🙍🏿",
  "🙍‍♂️",
  "🙍🏻‍♂️",
  "🙍🏼‍♂️",
  "🙍🏽‍♂️",
  "🙍🏾‍♂️",
  "🙍🏿‍♂️",
  "🙍‍♀️",
  "🙍🏻‍♀️",
  "🙍🏼‍♀️",
  "🙍🏽‍♀️",
  "🙍🏾‍♀️",
  "🙍🏿‍♀️",
  "🙎",
  "🙎🏻",
  "🙎🏼",
  "🙎🏽",
  "🙎🏾",
  "🙎🏿",
  "🙎‍♂️",
  "🙎🏻‍♂️",
  "🙎🏼‍♂️",
  "🙎🏽‍♂️",
  "🙎🏾‍♂️",
  "🙎🏿‍♂️",
  "🙎‍♀️",
  "🙎🏻‍♀️",
  "🙎🏼‍♀️",
  "🙎🏽‍♀️",
  "🙎🏾‍♀️",
  "🙎🏿‍♀️",
  "🙅",
  "🙅🏻",
  "🙅🏼",
  "🙅🏽",
  "🙅🏾",
  "🙅🏿",
  "🙅‍♂️",
  "🙅🏻‍♂️",
  "🙅🏼‍♂️",
  "🙅🏽‍♂️",
  "🙅🏾‍♂️",
  "🙅🏿‍♂️",
  "🙅‍♀️",
  "🙅🏻‍♀️",
  "🙅🏼‍♀️",
  "🙅🏽‍♀️",
  "🙅🏾‍♀️",
  "🙅🏿‍♀️",
  "🙆",
  "🙆🏻",
  "🙆🏼",
  "🙆🏽",
  "🙆🏾",
  "🙆🏿",
  "🙆‍♂️",
  "🙆🏻‍♂️",
  "🙆🏼‍♂️",
  "🙆🏽‍♂️",
  "🙆🏾‍♂️",
  "🙆🏿‍♂️",
  "🙆‍♀️",
  "🙆🏻‍♀️",
  "🙆🏼‍♀️",
  "🙆🏽‍♀️",
  "🙆🏾‍♀️",
  "🙆🏿‍♀️",
  "💁",
  "💁🏻",
  "💁🏼",
  "💁🏽",
  "💁🏾",
  "💁🏿",
  "💁‍♂️",
  "💁🏻‍♂️",
  "💁🏼‍♂️",
  "💁🏽‍♂️",
  "💁🏾‍♂️",
  "💁🏿‍♂️",
  "💁‍♀️",
  "💁🏻‍♀️",
  "💁🏼‍♀️",
  "💁🏽‍♀️",
  "💁🏾‍♀️",
  "💁🏿‍♀️",
  "🙋",
  "🙋🏻",
  "🙋🏼",
  "🙋🏽",
  "🙋🏾",
  "🙋🏿",
  "🙋‍♂️",
  "🙋🏻‍♂️",
  "🙋🏼‍♂️",
  "🙋🏽‍♂️",
  "🙋🏾‍♂️",
  "🙋🏿‍♂️",
  "🙋‍♀️",
  "🙋🏻‍♀️",
  "🙋🏼‍♀️",
  "🙋🏽‍♀️",
  "🙋🏾‍♀️",
  "🙋🏿‍♀️",
  "🧏",
  "🧏🏻",
  "🧏🏽",
  "🧏🏾",
  "🧏🏿",
  "🧏‍♂️",
  "🧏🏻‍♂️",
  "🧏🏽‍♂️",
  "🧏🏾‍♂️",
  "🧏🏿‍♂️",
  "🧏‍♀️",
  "🧏🏻‍♀️",
  "🧏🏼‍♀️",
  "🧏🏽‍♀️",
  "🧏🏾‍♀️",
  "🧏🏿‍♀️",
  "🙇",
  "🙇🏻",
  "🙇🏼",
  "🙇🏽",
  "🙇🏾",
  "🙇🏿",
  "🙇‍♂️",
  "🙇🏻‍♂️",
  "🙇🏼‍♂️",
  "🙇🏽‍♂️",
  "🙇🏾‍♂️",
  "🙇🏿‍♂️",
  "🙇‍♀️",
  "🙇🏻‍♀️",
  "🙇🏼‍♀️",
  "🙇🏽‍♀️",
  "🙇🏾‍♀️",
  "🙇🏿‍♀️",
  "🤦",
  "🤦🏻",
  "🤦🏼",
  "🤦🏽",
  "🤦🏾",
  "🤦🏿",
  "🤦‍♂️",
  "🤦🏻‍♂️",
  "🤦🏼‍♂️",
  "🤦🏽‍♂️",
  "🤦🏾‍♂️",
  "🤦🏿‍♂️",
  "🤦‍♀️",
  "🤦🏻‍♀️",
  "🤦🏼‍♀️",
  "🤦🏽‍♀️",
  "🤦🏾‍♀️",
  "🤦🏿‍♀️",
  "🤷",
  "🤷🏻",
  "🤷🏼",
  "🤷🏽",
  "🤷🏾",
  "🤷🏿",
  "🤷‍♂️",
  "🤷🏻‍♂️",
  "🤷🏼‍♂️",
  "🤷🏽‍♂️",
  "🤷🏾‍♂️",
  "🤷🏿‍♂️",
  "🤷‍♀️",
  "🤷🏻‍♀️",
  "🤷🏼‍♀️",
  "🤷🏽‍♀️",
  "🤷🏾‍♀️",
  "🤷🏿‍♀️",
  "🧑‍⚕️",
  "🧑🏻‍⚕️",
  "🧑🏼‍⚕️",
  "🧑🏽‍⚕️",
  "🧑🏾‍⚕️",
  "🧑🏿‍⚕️",
  "👨‍⚕️",
  "👨🏻‍⚕️",
  "👨🏼‍⚕️",
  "👨🏽‍⚕️",
  "👨🏾‍⚕️",
  "👨🏿‍⚕️",
  "👩‍⚕️",
  "👩🏻‍⚕️",
  "👩🏼‍⚕️",
  "👩🏽‍⚕️",
  "👩🏾‍⚕️",
  "👩🏿‍⚕️",
  "🧑‍🎓",
  "🧑🏻‍🎓",
  "🧑🏽‍🎓",
  "🧑🏿‍🎓",
  "👨‍🎓",
  "👨🏻‍🎓",
  "👨🏼‍🎓",
  "👨🏽‍🎓",
  "👨🏿‍🎓",
  "👩‍🎓",
  "👩🏻‍🎓",
  "👩🏼‍🎓",
  "👩🏽‍🎓",
  "👩🏿‍🎓",
  "🧑‍🏫",
  "🧑🏻‍🏫",
  "🧑🏼‍🏫",
  "🧑🏽‍🏫",
  "🧑🏾‍🏫",
  "🧑🏿‍🏫",
  "👨‍🏫",
  "👨🏻‍🏫",
  "👨🏼‍🏫",
  "👨🏽‍🏫",
  "👨🏾‍🏫",
  "👨🏿‍🏫",
  "👩‍🏫",
  "👩🏻‍🏫",
  "👩🏼‍🏫",
  "👩🏽‍🏫",
  "👩🏾‍🏫",
  "👩🏿‍🏫",
  "🧑‍⚖️",
  "🧑🏻‍⚖️",
  "🧑🏼‍⚖️",
  "🧑🏽‍⚖️",
  "🧑🏿‍⚖️",
  "👨‍⚖️",
  "👨🏻‍⚖️",
  "👨🏼‍⚖️",
  "👨🏽‍⚖️",
  "👨🏿‍⚖️",
  "👩‍⚖️",
  "👩🏻‍⚖️",
  "👩🏼‍⚖️",
  "👩🏽‍⚖️",
  "👩🏾‍⚖️",
  "👩🏿‍⚖️",
  "🧑‍🌾",
  "🧑🏻‍🌾",
  "🧑🏽‍🌾",
  "🧑🏿‍🌾",
  "👨‍🌾",
  "👨🏻‍🌾",
  "👨🏽‍🌾",
  "👨🏿‍🌾",
  "👩‍🌾",
  "👩🏻‍🌾",
  "👩🏼‍🌾",
  "👩🏽‍🌾",
  "👩🏿‍🌾",
  "🧑‍🍳",
  "🧑🏻‍🍳",
  "🧑🏽‍🍳",
  "🧑🏾‍🍳",
  "🧑🏿‍🍳",
  "👨‍🍳",
  "👨🏻‍🍳",
  "👨🏽‍🍳",
  "👨🏾‍🍳",
  "👨🏿‍🍳",
  "👩‍🍳",
  "👩🏻‍🍳",
  "👩🏼‍🍳",
  "👩🏽‍🍳",
  "👩🏾‍🍳",
  "👩🏿‍🍳",
  "🧑‍🔧",
  "🧑🏻‍🔧",
  "🧑🏽‍🔧",
  "🧑🏾‍🔧",
  "🧑🏿‍🔧",
  "👨‍🔧",
  "👨🏻‍🔧",
  "👨🏽‍🔧",
  "👨🏾‍🔧",
  "👨🏿‍🔧",
  "👩‍🔧",
  "👩🏻‍🔧",
  "👩🏼‍🔧",
  "👩🏽‍🔧",
  "👩🏾‍🔧",
  "👩🏿‍🔧",
  "🧑‍🏭",
  "🧑🏻‍🏭",
  "🧑🏽‍🏭",
  "🧑🏾‍🏭",
  "🧑🏿‍🏭",
  "👨‍🏭",
  "👨🏻‍🏭",
  "👨🏽‍🏭",
  "👨🏾‍🏭",
  "👨🏿‍🏭",
  "👩‍🏭",
  "👩🏻‍🏭",
  "👩🏼‍🏭",
  "👩🏽‍🏭",
  "👩🏾‍🏭",
  "👩🏿‍🏭",
  "🧑‍💼",
  "🧑🏻‍💼",
  "🧑🏼‍💼",
  "🧑🏽‍💼",
  "🧑🏾‍💼",
  "🧑🏿‍💼",
  "👨‍💼",
  "👨🏻‍💼",
  "👨🏼‍💼",
  "👨🏽‍💼",
  "👨🏾‍💼",
  "👨🏿‍💼",
  "👩‍💼",
  "👩🏻‍💼",
  "👩🏼‍💼",
  "👩🏽‍💼",
  "👩🏾‍💼",
  "👩🏿‍💼",
  "🧑‍🔬",
  "🧑🏻‍🔬",
  "🧑🏼‍🔬",
  "🧑🏽‍🔬",
  "🧑🏾‍🔬",
  "🧑🏿‍🔬",
  "👨‍🔬",
  "👨🏻‍🔬",
  "👨🏼‍🔬",
  "👨🏽‍🔬",
  "👨🏾‍🔬",
  "👨🏿‍🔬",
  "👩‍🔬",
  "👩🏻‍🔬",
  "👩🏼‍🔬",
  "👩🏽‍🔬",
  "👩🏾‍🔬",
  "👩🏿‍🔬",
  "🧑‍💻",
  "🧑🏻‍💻",
  "🧑🏼‍💻",
  "🧑🏾‍💻",
  "🧑🏿‍💻",
  "👨‍💻",
  "👨🏻‍💻",
  "👨🏼‍💻",
  "👨🏽‍💻",
  "👨🏾‍💻",
  "👨🏿‍💻",
  "👩‍💻",
  "👩🏻‍💻",
  "👩🏼‍💻",
  "👩🏽‍💻",
  "👩🏾‍💻",
  "👩🏿‍💻",
  "🧑‍🎤",
  "🧑🏻‍🎤",
  "🧑🏼‍🎤",
  "🧑🏽‍🎤",
  "🧑🏾‍🎤",
  "🧑🏿‍🎤",
  "👨‍🎤",
  "👨🏻‍🎤",
  "👨🏼‍🎤",
  "👨🏽‍🎤",
  "👨🏾‍🎤",
  "👨🏿‍🎤",
  "👩‍🎤",
  "👩🏻‍🎤",
  "👩🏼‍🎤",
  "👩🏽‍🎤",
  "👩🏾‍🎤",
  "👩🏿‍🎤",
  "🧑‍🎨",
  "🧑🏻‍🎨",
  "🧑🏽‍🎨",
  "🧑🏾‍🎨",
  "🧑🏿‍🎨",
  "👨‍🎨",
  "👨🏻‍🎨",
  "👨🏼‍🎨",
  "👨🏽‍🎨",
  "👨🏾‍🎨",
  "👨🏿‍🎨",
  "👩‍🎨",
  "👩🏻‍🎨",
  "👩🏼‍🎨",
  "👩🏽‍🎨",
  "👩🏾‍🎨",
  "👩🏿‍🎨",
  "🧑‍✈️",
  "🧑🏻‍✈️",
  "🧑🏽‍✈️",
  "🧑🏾‍✈️",
  "🧑🏿‍✈️",
  "👨‍✈️",
  "👨🏻‍✈️",
  "👨🏽‍✈️",
  "👨🏾‍✈️",
  "👨🏿‍✈️",
  "👩‍✈️",
  "👩🏻‍✈️",
  "👩🏼‍✈️",
  "👩🏽‍✈️",
  "👩🏾‍✈️",
  "👩🏿‍✈️",
  "🧑‍🚀",
  "🧑🏻‍🚀",
  "🧑🏽‍🚀",
  "🧑🏾‍🚀",
  "🧑🏿‍🚀",
  "👨‍🚀",
  "👨🏻‍🚀",
  "👨🏽‍🚀",
  "👨🏾‍🚀",
  "👨🏿‍🚀",
  "👩‍🚀",
  "👩🏻‍🚀",
  "👩🏽‍🚀",
  "👩🏾‍🚀",
  "👩🏿‍🚀",
  "🧑‍🚒",
  "🧑🏻‍🚒",
  "🧑🏽‍🚒",
  "🧑🏾‍🚒",
  "🧑🏿‍🚒",
  "👨‍🚒",
  "👨🏻‍🚒",
  "👨🏽‍🚒",
  "👨🏾‍🚒",
  "👨🏿‍🚒",
  "👩‍🚒",
  "👩🏻‍🚒",
  "👩🏼‍🚒",
  "👩🏽‍🚒",
  "👩🏾‍🚒",
  "👩🏿‍🚒",
  "👮",
  "👮🏻",
  "👮🏽",
  "👮🏾",
  "👮🏿",
  "👮‍♂️",
  "👮🏻‍♂️",
  "👮🏽‍♂️",
  "👮🏾‍♂️",
  "👮🏿‍♂️",
  "👮‍♀️",
  "👮🏻‍♀️",
  "👮🏼‍♀️",
  "👮🏽‍♀️",
  "👮🏾‍♀️",
  "👮🏿‍♀️",
  "🕵️",
  "🕵🏻",
  "🕵🏽",
  "🕵🏾",
  "🕵🏿",
  "🕵️‍♂️",
  "🕵🏻‍♂️",
  "🕵🏽‍♂️",
  "🕵🏾‍♂️",
  "🕵🏿‍♂️",
  "🕵️‍♀️",
  "🕵🏻‍♀️",
  "🕵🏼‍♀️",
  "🕵🏽‍♀️",
  "🕵🏾‍♀️",
  "🕵🏿‍♀️",
  "💂",
  "💂🏻",
  "💂🏽",
  "💂🏿",
  "💂‍♂️",
  "💂🏻‍♂️",
  "💂🏾‍♂️",
  "💂🏿‍♂️",
  "💂‍♀️",
  "💂🏻‍♀️",
  "💂🏼‍♀️",
  "💂🏽‍♀️",
  "💂🏿‍♀️",
  "🥷",
  "🥷🏻",
  "🥷🏽",
  "🥷🏿",
  "👷",
  "👷🏻",
  "👷🏽",
  "👷🏾",
  "👷🏿",
  "👷‍♂️",
  "👷🏼‍♂️",
  "👷🏽‍♂️",
  "👷🏾‍♂️",
  "👷🏿‍♂️",
  "👷‍♀️",
  "👷🏻‍♀️",
  "👷🏽‍♀️",
  "👷🏾‍♀️",
  "👷🏿‍♀️",
  "🤴",
  "🤴🏻",
  "🤴🏽",
  "🤴🏾",
  "🤴🏿",
  "👸",
  "👸🏻",
  "👸🏼",
  "👸🏽",
  "👸🏾",
  "👸🏿",
  "👳",
  "👳🏻",
  "👳🏽",
  "👳🏾",
  "👳🏿",
  "👳‍♂️",
  "👳🏻‍♂️",
  "👳🏼‍♂️",
  "👳🏽‍♂️",
  "👳🏾‍♂️",
  "👳🏿‍♂️",
  "👳‍♀️",
  "👳🏻‍♀️",
  "👳🏽‍♀️",
  "👳🏾‍♀️",
  "👳🏿‍♀️",
  "👲",
  "👲🏻",
  "👲🏽",
  "👲🏾",
  "👲🏿",
  "🧕",
  "🧕🏻",
  "🧕🏽",
  "🧕🏾",
  "🧕🏿",
  "🤵",
  "🤵🏻",
  "🤵🏼",
  "🤵🏽",
  "🤵🏾",
  "🤵🏿",
  "🤵‍♂️",
  "🤵🏻‍♂️",
  "🤵🏼‍♂️",
  "🤵🏽‍♂️",
  "🤵🏾‍♂️",
  "🤵🏿‍♂️",
  "🤵‍♀️",
  "🤵🏻‍♀️",
  "🤵🏼‍♀️",
  "🤵🏽‍♀️",
  "🤵🏾‍♀️",
  "🤵🏿‍♀️",
  "👰",
  "👰🏻",
  "👰🏼",
  "👰🏽",
  "👰🏾",
  "👰🏿",
  "👰‍♂️",
  "👰🏻‍♂️",
  "👰🏼‍♂️",
  "👰🏽‍♂️",
  "👰🏾‍♂️",
  "👰🏿‍♂️",
  "👰‍♀️",
  "👰🏻‍♀️",
  "👰🏼‍♀️",
  "👰🏽‍♀️",
  "👰🏾‍♀️",
  "👰🏿‍♀️",
  "🤰",
  "🤰🏻",
  "🤰🏼",
  "🤰🏽",
  "🤰🏾",
  "🤰🏿",
  "🤱",
  "🤱🏻",
  "🤱🏼",
  "🤱🏽",
  "🤱🏾",
  "🤱🏿",
  "👩‍🍼",
  "👩🏻‍🍼",
  "👩🏼‍🍼",
  "👩🏽‍🍼",
  "👩🏾‍🍼",
  "👩🏿‍🍼",
  "👨‍🍼",
  "👨🏻‍🍼",
  "👨🏼‍🍼",
  "👨🏾‍🍼",
  "👨🏿‍🍼",
  "🧑‍🍼",
  "🧑🏻‍🍼",
  "🧑🏼‍🍼",
  "🧑🏽‍🍼",
  "🧑🏾‍🍼",
  "🧑🏿‍🍼",
  "👼",
  "👼🏻",
  "👼🏼",
  "👼🏽",
  "👼🏾",
  "👼🏿",
  "🎅",
  "🎅🏻",
  "🎅🏽",
  "🎅🏾",
  "🎅🏿",
  "🤶",
  "🤶🏻",
  "🤶🏽",
  "🤶🏾",
  "🤶🏿",
  "🧑‍🎄",
  "🧑🏻‍🎄",
  "🧑🏽‍🎄",
  "🧑🏾‍🎄",
  "🧑🏿‍🎄",
  "🦸",
  "🦸🏻",
  "🦸🏼",
  "🦸🏽",
  "🦸🏾",
  "🦸🏿",
  "🦸‍♀️",
  "🦸🏻‍♀️",
  "🦸🏼‍♀️",
  "🦸🏽‍♀️",
  "🦸🏾‍♀️",
  "🦸🏿‍♀️",
  "🦹",
  "🦹🏻",
  "🦹🏼",
  "🦹🏽",
  "🦹🏾",
  "🦹🏿",
  "🦹‍♀️",
  "🦹🏼‍♀️",
  "🦹🏽‍♀️",
  "🦹🏾‍♀️",
  "🦹🏿‍♀️",
  "🧙",
  "🧙🏻",
  "🧙🏽",
  "🧙🏾",
  "🧙🏿",
  "🧙‍♂️",
  "🧙🏻‍♂️",
  "🧙🏾‍♂️",
  "🧙🏿‍♂️",
  "🧙‍♀️",
  "🧙🏻‍♀️",
  "🧙🏽‍♀️",
  "🧙🏾‍♀️",
  "🧙🏿‍♀️",
  "🧚",
  "🧚🏻",
  "🧚🏾",
  "🧚🏿",
  "🧚‍♂️",
  "🧚🏽‍♂️",
  "🧚🏾‍♂️",
  "🧚🏿‍♂️",
  "🧚‍♀️",
  "🧚🏻‍♀️",
  "🧚🏼‍♀️",
  "🧚🏾‍♀️",
  "🧚🏿‍♀️",
  "🧛",
  "🧛🏻",
  "🧛🏽",
  "🧛🏾",
  "🧛🏿",
  "🧛‍♂️",
  "🧛🏻‍♂️",
  "🧛🏽‍♂️",
  "🧛🏾‍♂️",
  "🧛🏿‍♂️",
  "🧛‍♀️",
  "🧛🏻‍♀️",
  "🧛🏽‍♀️",
  "🧛🏾‍♀️",
  "🧛🏿‍♀️",
  "🧜",
  "🧜🏻",
  "🧜🏽",
  "🧜🏾",
  "🧜🏿",
  "🧜‍♂️",
  "🧜🏼‍♂️",
  "🧜🏽‍♂️",
  "🧜🏾‍♂️",
  "🧜🏿‍♂️",
  "🧜‍♀️",
  "🧜🏻‍♀️",
  "🧜🏼‍♀️",
  "🧜🏽‍♀️",
  "🧜🏾‍♀️",
  "🧜🏿‍♀️",
  "🧝",
  "🧝🏻",
  "🧝🏼",
  "🧝🏽",
  "🧝🏾",
  "🧝🏿",
  "🧝‍♂️",
  "🧝🏻‍♂️",
  "🧝🏼‍♂️",
  "🧝🏽‍♂️",
  "🧝🏾‍♂️",
  "🧝🏿‍♂️",
  "🧝‍♀️",
  "🧝🏻‍♀️",
  "🧝🏼‍♀️",
  "🧝🏾‍♀️",
  "🧝🏿‍♀️",
  "🧞",
  "🧞‍♂️",
  "🧞‍♀️",
  "🧟",
  "🧟‍♂️",
  "🧟‍♀️",
  "💆",
  "💆🏻",
  "💆🏼",
  "💆🏽",
  "💆🏾",
  "💆🏿",
  "💆‍♂️",
  "💆🏻‍♂️",
  "💆🏼‍♂️",
  "💆🏽‍♂️",
  "💆🏾‍♂️",
  "💆🏿‍♂️",
  "💆‍♀️",
  "💆🏻‍♀️",
  "💆🏼‍♀️",
  "💆🏽‍♀️",
  "💆🏾‍♀️",
  "💆🏿‍♀️",
  "💇",
  "💇🏻",
  "💇🏼",
  "💇🏽",
  "💇🏾",
  "💇🏿",
  "💇‍♂️",
  "💇🏻‍♂️",
  "💇🏼‍♂️",
  "💇🏽‍♂️",
  "💇🏾‍♂️",
  "💇🏿‍♂️",
  "💇‍♀️",
  "💇🏻‍♀️",
  "💇🏼‍♀️",
  "💇🏽‍♀️",
  "💇🏾‍♀️",
  "💇🏿‍♀️",
  "🚶",
  "🚶🏼",
  "🚶🏽",
  "🚶🏿",
  "🚶‍♂️",
  "🚶🏼‍♂️",
  "🚶🏽‍♂️",
  "🚶🏿‍♂️",
  "🚶‍♀️",
  "🚶🏻‍♀️",
  "🚶🏼‍♀️",
  "🚶🏽‍♀️",
  "🚶🏾‍♀️",
  "🚶🏿‍♀️",
  "🧍",
  "🧍🏻",
  "🧍🏼",
  "🧍🏾",
  "🧍🏿",
  "🧍‍♂️",
  "🧍🏼‍♂️",
  "🧍🏽‍♂️",
  "🧍🏿‍♂️",
  "🧍‍♀️",
  "🧍🏻‍♀️",
  "🧍🏼‍♀️",
  "🧍🏾‍♀️",
  "🧍🏿‍♀️",
  "🧎",
  "🧎🏼",
  "🧎🏽",
  "🧎🏾",
  "🧎🏿",
  "🧎‍♂️",
  "🧎🏻‍♂️",
  "🧎🏼‍♂️",
  "🧎🏽‍♂️",
  "🧎🏿‍♂️",
  "🧎‍♀️",
  "🧎🏻‍♀️",
  "🧎🏼‍♀️",
  "🧎🏽‍♀️",
  "🧎🏾‍♀️",
  "🧎🏿‍♀️",
  "🧑‍🦯",
  "🧑🏻‍🦯",
  "🧑🏼‍🦯",
  "🧑🏽‍🦯",
  "🧑🏿‍🦯",
  "👨‍🦯",
  "👨🏻‍🦯",
  "👨🏼‍🦯",
  "👨🏽‍🦯",
  "👨🏿‍🦯",
  "👩‍🦯",
  "👩🏻‍🦯",
  "👩🏼‍🦯",
  "👩🏽‍🦯",
  "👩🏿‍🦯",
  "🧑‍🦼",
  "🧑🏼‍🦼",
  "🧑🏽‍🦼",
  "🧑🏾‍🦼",
  "🧑🏿‍🦼",
  "👨‍🦼",
  "👨🏼‍🦼",
  "👨🏽‍🦼",
  "👨🏾‍🦼",
  "👨🏿‍🦼",
  "👩‍🦼",
  "👩🏼‍🦼",
  "👩🏽‍🦼",
  "👩🏿‍🦼",
  "🧑‍🦽",
  "🧑🏻‍🦽",
  "🧑🏼‍🦽",
  "🧑🏾‍🦽",
  "🧑🏿‍🦽",
  "👨‍🦽",
  "👨🏻‍🦽",
  "👨🏼‍🦽",
  "👨🏽‍🦽",
  "👨🏿‍🦽",
  "👩‍🦽",
  "👩🏼‍🦽",
  "👩🏽‍🦽",
  "👩🏾‍🦽",
  "👩🏿‍🦽",
  "🏃",
  "🏃🏻",
  "🏃🏼",
  "🏃🏾",
  "🏃🏿",
  "🏃‍♂️",
  "🏃🏼‍♂️",
  "🏃🏽‍♂️",
  "🏃🏾‍♂️",
  "🏃🏿‍♂️",
  "🏃‍♀️",
  "🏃🏻‍♀️",
  "🏃🏼‍♀️",
  "🏃🏽‍♀️",
  "🏃🏿‍♀️",
  "💃",
  "💃🏼",
  "💃🏽",
  "💃🏿",
  "🕺",
  "🕺🏼",
  "🕺🏾",
  "🕺🏿",
  "🕴️",
  "🕴🏻",
  "🕴🏾",
  "🕴🏿",
  "👯",
  "👯‍♂️",
  "👯‍♀️",
  "🧖",
  "🧖🏼",
  "🧖🏽",
  "🧖🏾",
  "🧖🏿",
  "🧖‍♂️",
  "🧖🏻‍♂️",
  "🧖🏼‍♂️",
  "🧖🏽‍♂️",
  "🧖🏾‍♂️",
  "🧖🏿‍♂️",
  "🧖‍♀️",
  "🧖🏻‍♀️",
  "🧖🏼‍♀️",
  "🧖🏽‍♀️",
  "🧖🏾‍♀️",
  "🧖🏿‍♀️",
  "🧗",
  "🧗🏻",
  "🧗🏽",
  "🧗🏿",
  "🧗‍♂️",
  "🧗🏻‍♂️",
  "🧗🏽‍♂️",
  "🧗🏿‍♂️",
  "🧗‍♀️",
  "🧗🏻‍♀️",
  "🧗🏽‍♀️",
  "🧗🏿‍♀️",
  "🤺",
  "🏇",
  "🏇🏻",
  "🏇🏽",
  "🏇🏿",
  "⛷️",
  "🏂",
  "🏌️",
  "🏌🏻",
  "🏌🏽",
  "🏌🏿",
  "🏌️‍♂️",
  "🏌🏼‍♂️",
  "🏌🏾‍♂️",
  "🏌🏿‍♂️",
  "🏌️‍♀️",
  "🏌🏼‍♀️",
  "🏌🏽‍♀️",
  "🏌🏿‍♀️",
  "🏄",
  "🏄🏻",
  "🏄🏼",
  "🏄🏾",
  "🏄🏿",
  "🏄‍♂️",
  "🏄🏼‍♂️",
  "🏄🏾‍♂️",
  "🏄🏿‍♂️",
  "🏄‍♀️",
  "🏄🏼‍♀️",
  "🏄🏽‍♀️",
  "🏄🏿‍♀️",
  "🚣",
  "🚣🏼",
  "🚣🏽",
  "🚣🏾",
  "🚣🏿",
  "🚣‍♂️",
  "🚣🏼‍♂️",
  "🚣🏽‍♂️",
  "🚣🏾‍♂️",
  "🚣🏿‍♂️",
  "🚣‍♀️",
  "🚣🏻‍♀️",
  "🚣🏼‍♀️",
  "🚣🏽‍♀️",
  "🚣🏾‍♀️",
  "🚣🏿‍♀️",
  "🏊",
  "🏊🏻",
  "🏊🏽",
  "🏊🏾",
  "🏊🏿",
  "🏊‍♂️",
  "🏊🏻‍♂️",
  "🏊🏽‍♂️",
  "🏊🏾‍♂️",
  "🏊🏿‍♂️",
  "🏊‍♀️",
  "🏊🏻‍♀️",
  "🏊🏽‍♀️",
  "🏊🏾‍♀️",
  "🏊🏿‍♀️",
  "⛹️",
  "⛹🏼",
  "⛹🏾",
  "⛹🏿",
  "⛹️‍♂️",
  "⛹🏼‍♂️",
  "⛹🏽‍♂️",
  "⛹🏿‍♂️",
  "⛹️‍♀️",
  "⛹🏻‍♀️",
  "⛹🏼‍♀️",
  "⛹🏽‍♀️",
  "⛹🏾‍♀️",
  "⛹🏿‍♀️",
  "🏋️",
  "🏋🏼",
  "🏋🏽",
  "🏋🏾",
  "🏋🏿",
  "🏋️‍♂️",
  "🏋🏼‍♂️",
  "🏋🏽‍♂️",
  "🏋🏿‍♂️",
  "🏋️‍♀️",
  "🏋🏼‍♀️",
  "🏋🏽‍♀️",
  "🏋🏿‍♀️",
  "🚴",
  "🚴🏼",
  "🚴🏽",
  "🚴🏿",
  "🚴‍♂️",
  "🚴🏻‍♂️",
  "🚴🏽‍♂️",
  "🚴🏾‍♂️",
  "🚴🏿‍♂️",
  "🚴‍♀️",
  "🚴🏻‍♀️",
  "🚴🏽‍♀️",
  "🚴🏾‍♀️",
  "🚴🏿‍♀️",
  "🚵",
  "🚵🏻",
  "🚵🏽",
  "🚵🏿",
  "🚵‍♂️",
  "🚵🏻‍♂️",
  "🚵🏽‍♂️",
  "🚵🏿‍♂️",
  "🚵‍♀️",
  "🚵🏼‍♀️",
  "🚵🏾‍♀️",
  "🚵🏿‍♀️",
  "🤸",
  "🤸🏻",
  "🤸🏽",
  "🤸🏿",
  "🤸‍♂️",
  "🤸🏻‍♂️",
  "🤸🏽‍♂️",
  "🤸🏿‍♂️",
  "🤸‍♀️",
  "🤸🏻‍♀️",
  "🤸🏽‍♀️",
  "🤸🏾‍♀️",
  "🤸🏿‍♀️",
  "🤼",
  "🤼‍♂️",
  "🤼‍♀️",
  "🤽",
  "🤽🏼",
  "🤽🏽",
  "🤽🏾",
  "🤽🏿",
  "🤽‍♂️",
  "🤽🏻‍♂️",
  "🤽🏽‍♂️",
  "🤽🏾‍♂️",
  "🤽🏿‍♂️",
  "🤽‍♀️",
  "🤽🏻‍♀️",
  "🤽🏽‍♀️",
  "🤽🏾‍♀️",
  "🤽🏿‍♀️",
  "🤾",
  "🤾🏼",
  "🤾🏽",
  "🤾🏾",
  "🤾🏿",
  "🤾‍♂️",
  "🤾🏻‍♂️",
  "🤾🏼‍♂️",
  "🤾🏽‍♂️",
  "🤾🏾‍♂️",
  "🤾🏿‍♂️",
  "🤾‍♀️",
  "🤾🏻‍♀️",
  "🤾🏼‍♀️",
  "🤾🏽‍♀️",
  "🤾🏾‍♀️",
  "🤾🏿‍♀️",
  "🤹",
  "🤹🏼",
  "🤹🏽",
  "🤹🏾",
  "🤹🏿",
  "🤹🏻‍♂️",
  "🤹‍♀️",
  "🤹🏻‍♀️",
  "🤹🏼‍♀️",
  "🤹🏽‍♀️",
  "🤹🏾‍♀️",
  "🤹🏿‍♀️",
  "🧘",
  "🧘🏻",
  "🧘🏼",
  "🧘🏽",
  "🧘🏾",
  "🧘🏿",
  "🧘‍♂️",
  "🧘🏻‍♂️",
  "🧘🏼‍♂️",
  "🧘🏽‍♂️",
  "🧘🏾‍♂️",
  "🧘🏿‍♂️",
  "🧘‍♀️",
  "🧘🏻‍♀️",
  "🧘🏼‍♀️",
  "🧘🏽‍♀️",
  "🧘🏾‍♀️",
  "🧘🏿‍♀️",
  "🛀",
  "🛀🏼",
  "🛀🏾",
  "🛀🏿",
  "🛌",
  "🛌🏻",
  "🛌🏼",
  "🛌🏽",
  "🛌🏿",
  "🧑‍🤝‍🧑",
  "🧑🏻‍🤝‍🧑🏻",
  "🧑🏻‍🤝‍🧑🏽",
  "🧑🏻‍🤝‍🧑🏾",
  "🧑🏻‍🤝‍🧑🏿",
  "🧑🏼‍🤝‍🧑🏻",
  "🧑🏼‍🤝‍🧑🏼",
  "🧑🏼‍🤝‍🧑🏾",
  "🧑🏼‍🤝‍🧑🏿",
  "🧑🏽‍🤝‍🧑🏻",
  "🧑🏽‍🤝‍🧑🏾",
  "🧑🏽‍🤝‍🧑🏿",
  "🧑🏾‍🤝‍🧑🏼",
  "🧑🏾‍🤝‍🧑🏿",
  "🧑🏿‍🤝‍🧑🏼",
  "🧑🏿‍🤝‍🧑🏾",
  "🧑🏿‍🤝‍🧑🏿",
  "👭",
  "👭🏻",
  "👩🏻‍🤝‍👩🏼",
  "👩🏻‍🤝‍👩🏽",
  "👩🏼‍🤝‍👩🏻",
  "👭🏼",
  "👩🏼‍🤝‍👩🏿",
  "👩🏽‍🤝‍👩🏻",
  "👩🏽‍🤝‍👩🏼",
  "👭🏽",
  "👩🏽‍🤝‍👩🏾",
  "👩🏽‍🤝‍👩🏿",
  "👩🏾‍🤝‍👩🏼",
  "👩🏿‍🤝‍👩🏼",
  "👩🏿‍🤝‍👩🏽",
  "👩🏿‍🤝‍👩🏾",
  "👭🏿",
  "👫",
  "👫🏻",
  "👩🏻‍🤝‍👨🏼",
  "👩🏻‍🤝‍👨🏿",
  "👩🏼‍🤝‍👨🏻",
  "👩🏼‍🤝‍👨🏿",
  "👩🏽‍🤝‍👨🏼",
  "👫🏽",
  "👩🏽‍🤝‍👨🏿",
  "👩🏾‍🤝‍👨🏼",
  "👩🏾‍🤝‍👨🏿",
  "👩🏿‍🤝‍👨🏼",
  "👩🏿‍🤝‍👨🏾",
  "👫🏿",
  "👬",
  "👨🏻‍🤝‍👨🏽",
  "👨🏻‍🤝‍👨🏿",
  "👨🏼‍🤝‍👨🏻",
  "👬🏼",
  "👨🏼‍🤝‍👨🏾",
  "👨🏼‍🤝‍👨🏿",
  "👨🏽‍🤝‍👨🏻",
  "👨🏽‍🤝‍👨🏼",
  "👬🏽",
  "👨🏽‍🤝‍👨🏿",
  "👨🏾‍🤝‍👨🏼",
  "👨🏿‍🤝‍👨🏼",
  "👨🏿‍🤝‍👨🏾",
  "👬🏿",
  "💏",
  "👩‍❤️‍💋‍👨",
  "👩‍❤️‍💋‍👩",
  "👪",
  "👨‍👩‍👦",
  "👨‍👩‍👧",
  "👨‍👩‍👧‍👦",
  "👨‍👩‍👦‍👦",
  "👨‍👩‍👧‍👧",
  "👨‍👨‍👦",
  "👨‍👨‍👧",
  "👨‍👨‍👧‍👦",
  "👨‍👨‍👦‍👦",
  "👨‍👨‍👧‍👧",
  "👩‍👩‍👦",
  "👩‍👩‍👧",
  "👩‍👩‍👧‍👦",
  "👩‍👩‍👦‍👦",
  "👩‍👩‍👧‍👧",
  "👨‍👦",
  "👨‍👦‍👦",
  "👨‍👧",
  "👨‍👧‍👦",
  "👨‍👧‍👧",
  "👩‍👦",
  "👩‍👦‍👦",
  "👩‍👧",
  "👩‍👧‍👦",
  "👩‍👧‍👧",
  "🗣️",
  "👤",
  "👥",
  "🫂",
  "👣",
  "🐵",
  "🐒",
  "🦍",
  "🦧",
  "🐶",
  "🐕",
  "🦮",
  "🐕‍🦺",
  "🐩",
  "🐺",
  "🦊",
  "🦝",
  "🐱",
  "🐈",
  "🐈‍⬛",
  "🦁",
  "🐯",
  "🐅",
  "🐆",
  "🐴",
  "🐎",
  "🦄",
  "🦓",
  "🦌",
  "🦬",
  "🐮",
  "🐂",
  "🐃",
  "🐄",
  "🐷",
  "🐖",
  "🐗",
  "🐽",
  "🐏",
  "🐑",
  "🐐",
  "🐪",
  "🐫",
  "🦙",
  "🦒",
  "🐘",
  "🦣",
  "🦏",
  "🦛",
  "🐭",
  "🐁",
  "🐀",
  "🐹",
  "🐰",
  "🐇",
  "🐿️",
  "🦫",
  "🦔",
  "🦇",
  "🐻",
  "🐻‍❄️",
  "🐨",
  "🐼",
  "🦥",
  "🦦",
  "🦨",
  "🦘",
  "🦡",
  "🐾",
  "🦃",
  "🐔",
  "🐓",
  "🐣",
  "🐤",
  "🐥",
  "🐦",
  "🐧",
  "🕊️",
  "🦅",
  "🦆",
  "🦢",
  "🦉",
  "🦤",
  "🪶",
  "🦩",
  "🦚",
  "🦜",
  "🐸",
  "🐊",
  "🐢",
  "🦎",
  "🐍",
  "🐲",
  "🐉",
  "🦕",
  "🦖",
  "🐳",
  "🐋",
  "🐬",
  "🦭",
  "🐟",
  "🐠",
  "🐡",
  "🦈",
  "🐙",
  "🐚",
  "🐌",
  "🦋",
  "🐛",
  "🐜",
  "🐝",
  "🪲",
  "🐞",
  "🦗",
  "🪳",
  "🕷️",
  "🕸️",
  "🦂",
  "🦟",
  "🪰",
  "🪱",
  "🦠",
  "💐",
  "🌸",
  "💮",
  "🏵️",
  "🌹",
  "🥀",
  "🌺",
  "🌻",
  "🌼",
  "🌷",
  "🌱",
  "🪴",
  "🌲",
  "🌳",
  "🌴",
  "🌵",
  "🌾",
  "🌿",
  "☘️",
  "🍀",
  "🍁",
  "🍂",
  "🍃",
  "🍇",
  "🍈",
  "🍉",
  "🍊",
  "🍋",
  "🍌",
  "🍍",
  "🥭",
  "🍎",
  "🍏",
  "🍐",
  "🍑",
  "🍒",
  "🍓",
  "🫐",
  "🥝",
  "🍅",
  "🫒",
  "🥥",
  "🥑",
  "🍆",
  "🥔",
  "🥕",
  "🌽",
  "🌶️",
  "🫑",
  "🥒",
  "🥬",
  "🥦",
  "🧄",
  "🧅",
  "🍄",
  "🥜",
  "🌰",
  "🍞",
  "🥐",
  "🥖",
  "🫓",
  "🥨",
  "🥯",
  "🥞",
  "🧇",
  "🧀",
  "🍖",
  "🍗",
  "🥩",
  "🥓",
  "🍔",
  "🍟",
  "🍕",
  "🌭",
  "🥪",
  "🌮",
  "🌯",
  "🫔",
  "🥙",
  "🧆",
  "🥚",
  "🍳",
  "🥘",
  "🍲",
  "🫕",
  "🥣",
  "🥗",
  "🍿",
  "🧈",
  "🧂",
  "🥫",
  "🍱",
  "🍘",
  "🍙",
  "🍚",
  "🍛",
  "🍜",
  "🍝",
  "🍠",
  "🍢",
  "🍣",
  "🍤",
  "🍥",
  "🥮",
  "🍡",
  "🥟",
  "🥠",
  "🥡",
  "🦀",
  "🦞",
  "🦐",
  "🦑",
  "🦪",
  "🍦",
  "🍧",
  "🍨",
  "🍩",
  "🍪",
  "🎂",
  "🍰",
  "🧁",
  "🥧",
  "🍫",
  "🍬",
  "🍭",
  "🍮",
  "🍯",
  "🍼",
  "🥛",
  "☕",
  "🫖",
  "🍵",
  "🍶",
  "🍾",
  "🍷",
  "🍸",
  "🍹",
  "🍺",
  "🍻",
  "🥂",
  "🥃",
  "🥤",
  "🧋",
  "🧃",
  "🧉",
  "🧊",
  "🥢",
  "🍽️",
  "🍴",
  "🥄",
  "🔪",
  "🏺",
  "🌍",
  "🌎",
  "🌏",
  "🌐",
  "🗺️",
  "🗾",
  "🧭",
  "🏔️",
  "⛰️",
  "🌋",
  "🗻",
  "🏕️",
  "🏖️",
  "🏜️",
  "🏝️",
  "🏞️",
  "🏟️",
  "🏛️",
  "🏗️",
  "🧱",
  "🪨",
  "🪵",
  "🛖",
  "🏘️",
  "🏚️",
  "🏠",
  "🏡",
  "🏢",
  "🏣",
  "🏤",
  "🏥",
  "🏦",
  "🏨",
  "🏩",
  "🏪",
  "🏫",
  "🏬",
  "🏭",
  "🏯",
  "🏰",
  "💒",
  "🗼",
  "🗽",
  "⛪",
  "🕌",
  "🛕",
  "🕍",
  "⛩️",
  "🕋",
  "⛲",
  "⛺",
  "🌁",
  "🌃",
  "🏙️",
  "🌄",
  "🌅",
  "🌆",
  "🌇",
  "🌉",
  "♨️",
  "🎠",
  "🎡",
  "🎢",
  "💈",
  "🎪",
  "🚂",
  "🚃",
  "🚄",
  "🚅",
  "🚆",
  "🚇",
  "🚈",
  "🚉",
  "🚊",
  "🚝",
  "🚞",
  "🚋",
  "🚌",
  "🚍",
  "🚎",
  "🚐",
  "🚑",
  "🚒",
  "🚓",
  "🚔",
  "🚕",
  "🚖",
  "🚗",
  "🚘",
  "🚙",
  "🛻",
  "🚚",
  "🚛",
  "🚜",
  "🏎️",
  "🏍️",
  "🛵",
  "🦽",
  "🦼",
  "🛺",
  "🚲",
  "🛴",
  "🛹",
  "🛼",
  "🚏",
  "🛣️",
  "🛤️",
  "🛢️",
  "⛽",
  "🚨",
  "🚥",
  "🚦",
  "🛑",
  "🚧",
  "⚓",
  "⛵",
  "🛶",
  "🚤",
  "🛳️",
  "⛴️",
  "🛥️",
  "🚢",
  "✈️",
  "🛩️",
  "🛫",
  "🛬",
  "🪂",
  "💺",
  "🚁",
  "🚟",
  "🚠",
  "🚡",
  "🛰️",
  "🚀",
  "🛸",
  "🛎️",
  "🧳",
  "⌛",
  "⏳",
  "⌚",
  "⏰",
  "⏱️",
  "⏲️",
  "🕰️",
  "🕛",
  "🕧",
  "🕐",
  "🕜",
  "🕑",
  "🕝",
  "🕒",
  "🕞",
  "🕓",
  "🕟",
  "🕔",
  "🕠",
  "🕕",
  "🕡",
  "🕖",
  "🕢",
  "🕗",
  "🕣",
  "🕘",
  "🕤",
  "🕙",
  "🕥",
  "🕚",
  "🕦",
  "🌑",
  "🌒",
  "🌓",
  "🌔",
  "🌕",
  "🌖",
  "🌗",
  "🌘",
  "🌙",
  "🌚",
  "🌛",
  "🌜",
  "🌡️",
  "☀️",
  "🌝",
  "🌞",
  "🪐",
  "⭐",
  "🌟",
  "🌠",
  "🌌",
  "☁️",
  "⛅",
  "⛈️",
  "🌤️",
  "🌥️",
  "🌦️",
  "🌧️",
  "🌨️",
  "🌩️",
  "🌪️",
  "🌫️",
  "🌬️",
  "🌀",
  "🌈",
  "🌂",
  "☂️",
  "☔",
  "⛱️",
  "⚡",
  "❄️",
  "☃️",
  "⛄",
  "☄️",
  "🔥",
  "💧",
  "🌊",
  "🎃",
  "🎄",
  "🎆",
  "🎇",
  "🧨",
  "✨",
  "🎈",
  "🎉",
  "🎊",
  "🎋",
  "🎍",
  "🎎",
  "🎏",
  "🎐",
  "🎑",
  "🧧",
  "🎀",
  "🎁",
  "🎗️",
  "🎟️",
  "🎫",
  "🎖️",
  "🏆",
  "🏅",
  "🥇",
  "🥈",
  "🥉",
  "⚽",
  "⚾",
  "🥎",
  "🏀",
  "🏐",
  "🏈",
  "🏉",
  "🎾",
  "🥏",
  "🎳",
  "🏏",
  "🏑",
  "🏒",
  "🥍",
  "🏓",
  "🏸",
  "🥊",
  "🥋",
  "🥅",
  "⛳",
  "⛸️",
  "🎣",
  "🤿",
  "🎽",
  "🎿",
  "🛷",
  "🥌",
  "🎯",
  "🪀",
  "🪁",
  "🎱",
  "🔮",
  "🪄",
  "🧿",
  "🎮",
  "🕹️",
  "🎰",
  "🎲",
  "🧩",
  "🧸",
  "🪅",
  "🪆",
  "♠️",
  "♥️",
  "♦️",
  "♣️",
  "♟️",
  "🃏",
  "🀄",
  "🎴",
  "🎭",
  "🖼️",
  "🎨",
  "🧵",
  "🪡",
  "🧶",
  "🪢",
  "👓",
  "🕶️",
  "🥽",
  "🥼",
  "🦺",
  "👔",
  "👕",
  "👖",
  "🧣",
  "🧤",
  "🧥",
  "🧦",
  "👗",
  "👘",
  "🥻",
  "🩱",
  "🩲",
  "🩳",
  "👙",
  "👚",
  "👛",
  "👜",
  "👝",
  "🛍️",
  "🎒",
  "🩴",
  "👞",
  "👟",
  "🥾",
  "🥿",
  "👠",
  "👡",
  "🩰",
  "👢",
  "👑",
  "👒",
  "🎩",
  "🎓",
  "🧢",
  "🪖",
  "⛑️",
  "📿",
  "💄",
  "💍",
  "💎",
  "🔇",
  "🔈",
  "🔉",
  "🔊",
  "📢",
  "📣",
  "📯",
  "🔔",
  "🔕",
  "🎼",
  "🎵",
  "🎶",
  "🎙️",
  "🎚️",
  "🎛️",
  "🎤",
  "🎧",
  "📻",
  "🎷",
  "🪗",
  "🎸",
  "🎹",
  "🎺",
  "🎻",
  "🪕",
  "🥁",
  "🪘",
  "📱",
  "📲",
  "☎️",
  "📞",
  "📟",
  "📠",
  "🔋",
  "🔌",
  "💻",
  "🖥️",
  "🖨️",
  "⌨️",
  "🖱️",
  "🖲️",
  "💽",
  "💾",
  "💿",
  "📀",
  "🧮",
  "🎥",
  "🎞️",
  "📽️",
  "🎬",
  "📺",
  "📷",
  "📸",
  "📹",
  "📼",
  "🔍",
  "🔎",
  "🕯️",
  "💡",
  "🔦",
  "🏮",
  "🪔",
  "📔",
  "📕",
  "📖",
  "📗",
  "📘",
  "📙",
  "📚",
  "📓",
  "📒",
  "📃",
  "📜",
  "📄",
  "📰",
  "🗞️",
  "📑",
  "🔖",
  "🏷️",
  "💰",
  "🪙",
  "💴",
  "💵",
  "💶",
  "💷",
  "💸",
  "💳",
  "🧾",
  "💹",
  "✉️",
  "📧",
  "📨",
  "📩",
  "📤",
  "📥",
  "📦",
  "📫",
  "📪",
  "📬",
  "📭",
  "📮",
  "🗳️",
  "✏️",
  "✒️",
  "🖋️",
  "🖊️",
  "🖌️",
  "🖍️",
  "📝",
  "💼",
  "📁",
  "📂",
  "🗂️",
  "📅",
  "📆",
  "🗒️",
  "🗓️",
  "📇",
  "📈",
  "📉",
  "📊",
  "📋",
  "📌",
  "📍",
  "📎",
  "🖇️",
  "📏",
  "📐",
  "✂️",
  "🗃️",
  "🗄️",
  "🗑️",
  "🔒",
  "🔓",
  "🔏",
  "🔐",
  "🔑",
  "🗝️",
  "🔨",
  "🪓",
  "⛏️",
  "⚒️",
  "🛠️",
  "🗡️",
  "⚔️",
  "🔫",
  "🪃",
  "🏹",
  "🛡️",
  "🪚",
  "🔧",
  "🪛",
  "🔩",
  "⚙️",
  "🗜️",
  "⚖️",
  "🦯",
  "🔗",
  "⛓️",
  "🪝",
  "🧰",
  "🧲",
  "🪜",
  "⚗️",
  "🧪",
  "🧫",
  "🧬",
  "🔬",
  "🔭",
  "📡",
  "💉",
  "🩸",
  "💊",
  "🩹",
  "🩺",
  "🚪",
  "🛗",
  "🪞",
  "🪟",
  "🛏️",
  "🛋️",
  "🪑",
  "🚽",
  "🪠",
  "🚿",
  "🛁",
  "🪤",
  "🪒",
  "🧴",
  "🧷",
  "🧹",
  "🧺",
  "🧻",
  "🪣",
  "🧼",
  "🪥",
  "🧽",
  "🧯",
  "🛒",
  "🚬",
  "⚰️",
  "🪦",
  "⚱️",
  "🗿",
  "🪧",
  "🏧",
  "🚮",
  "🚰",
  "♿",
  "🚹",
  "🚺",
  "🚻",
  "🚼",
  "🚾",
  "🛂",
  "🛃",
  "🛄",
  "🛅",
  "⚠️",
  "🚸",
  "⛔",
  "🚫",
  "🚳",
  "🚭",
  "🚯",
  "🚱",
  "🚷",
  "📵",
  "🔞",
  "☢️",
  "☣️",
  "⬆️",
  "↗️",
  "➡️",
  "↘️",
  "⬇️",
  "↙️",
  "⬅️",
  "↖️",
  "↕️",
  "↔️",
  "↩️",
  "↪️",
  "⤴️",
  "⤵️",
  "🔃",
  "🔄",
  "🔙",
  "🔚",
  "🔛",
  "🔜",
  "🔝",
  "🛐",
  "⚛️",
  "🕉️",
  "✡️",
  "☸️",
  "☯️",
  "✝️",
  "☦️",
  "☪️",
  "☮️",
  "🕎",
  "🔯",
  "♈",
  "♉",
  "♊",
  "♋",
  "♌",
  "♍",
  "♎",
  "♏",
  "♐",
  "♑",
  "♒",
  "♓",
  "⛎",
  "🔀",
  "🔁",
  "🔂",
  "▶️",
  "⏩",
  "⏭️",
  "⏯️",
  "◀️",
  "⏪",
  "⏮️",
  "🔼",
  "⏫",
  "🔽",
  "⏬",
  "⏸️",
  "⏹️",
  "⏺️",
  "⏏️",
  "🎦",
  "🔅",
  "🔆",
  "📶",
  "📳",
  "📴",
  "♀️",
  "♂️",
  "⚧️",
  "✖️",
  "➕",
  "➖",
  "➗",
  "♾️",
  "‼️",
  "⁉️",
  "❓",
  "❔",
  "❕",
  "❗",
  "〰️",
  "💱",
  "💲",
  "⚕️",
  "♻️",
  "⚜️",
  "🔱",
  "📛",
  "🔰",
  "⭕",
  "✅",
  "☑️",
  "✔️",
  "❌",
  "❎",
  "➰",
  "➿",
  "〽️",
  "✳️",
  "✴️",
  "❇️",
  "©️",
  "®️",
  "™️",
  "#️⃣",
  "*️⃣",
  "0️⃣",
  "1️⃣",
  "2️⃣",
  "3️⃣",
  "4️⃣",
  "5️⃣",
  "6️⃣",
  "7️⃣",
  "8️⃣",
  "9️⃣",
  "🔟",
  "🔠",
  "🔡",
  "🔢",
  "🔣",
  "🔤",
  "🅰️",
  "🆎",
  "🅱️",
  "🆑",
  "🆒",
  "🆓",
  "ℹ️",
  "🆔",
  "Ⓜ️",
  "🆕",
  "🆖",
  "🅾️",
  "🆗",
  "🅿️",
  "🆘",
  "🆙",
  "🆚",
  "🈁",
  "🈂️",
  "🈷️",
  "🈶",
  "🈯",
  "🉐",
  "🈹",
  "🈚",
  "🈲",
  "🉑",
  "🈸",
  "🈴",
  "🈳",
  "㊗️",
  "㊙️",
  "🈺",
  "🈵",
  "🔴",
  "🟠",
  "🟡",
  "🟢",
  "🔵",
  "🟣",
  "🟤",
  "⚫",
  "⚪",
  "🟥",
  "🟧",
  "🟨",
  "🟩",
  "🟦",
  "🟪",
  "🟫",
  "⬛",
  "⬜",
  "◼️",
  "◻️",
  "◾",
  "◽",
  "▪️",
  "▫️",
  "🔶",
  "🔷",
  "🔸",
  "🔹",
  "🔺",
  "🔻",
  "💠",
  "🔘",
  "🔳",
  "🔲",
  "🏁",
  "🚩",
  "🎌",
  "🏴",
  "🏳️",
  "🏳️‍🌈",
  "🏳️‍⚧️",
  "🏴‍☠️"
], Ma = 2757, Mi = 14;
function Wi(r) {
  if (oi.length < Ma)
    throw new Error("Not enough emojis");
  const e = Dt(r).slice(3, 43);
  return qi(
    e,
    Ma,
    Mi
  );
}
function qi(r, i, e) {
  const n = ai(BigInt(`0x${r}`), BigInt(i));
  return _i(n, e);
}
function _i(r, i) {
  let e = "";
  if (r.length < i) {
    let n = i - r.length;
    for (; n--; )
      r.unshift(BigInt(0));
  }
  for (const n of r)
    e += oi[Number(n)];
  return e;
}
function Vi(r, i) {
  const { chatIdentity: e } = r;
  return e ? {
    photo: e.images.thumbnail?.payload,
    displayName: e.displayName,
    description: e.description,
    colorHash: ri(i),
    emojiHash: Wi(i)
  } : void 0;
}
var vn, zn, Qn, lt, Fn, ct;
const ia = class ia {
  constructor(i, e) {
    t(this, "waku");
    /** Cache. */
    t(this, "wakuMessages");
    T(this, vn);
    T(this, zn);
    T(this, Qn);
    T(this, lt);
    T(this, Fn);
    T(this, ct);
    t(this, "getEthereumClient", (i) => {
      const e = o(this, Fn).get(i);
      if (!e) {
        const n = o(this, Qn)[i];
        if (!n)
          return;
        const s = new Hi(n + o(this, lt));
        return o(this, Fn).set(i, s).get(i);
      }
      return e;
    });
    t(this, "fetchCommunity", async (i) => {
      const e = await this.fetchCommunityDescription(i);
      if (e)
        return si(e);
    });
    t(this, "fetchChannel", async (i, e) => {
      const n = await this.fetchCommunityDescription(i);
      if (!n)
        return;
      const s = n.chats[e];
      return xi(s, n);
    });
    t(this, "fetchUser", async (i) => {
      const e = await this.fetchContactCodeAdvertisement(i);
      if (e)
        return Vi(e, i);
    });
    t(this, "fetchCommunityDescription", async (i) => {
      const e = It(i), n = await wt(i), s = this.waku.store.queryGenerator([
        Hn(e, n, {
          clusterId: 16,
          shard: 32
        })
      ]);
      for await (const c of s)
        for await (const u of c) {
          if (!u)
            continue;
          const m = this.handleWakuMessage(u);
          if (!m || m.type !== I.COMMUNITY_DESCRIPTION)
            continue;
          const f = it.fromBinary(
            m.payload
          );
          if (!In(
            BigInt(f.clock),
            m.timestamp
          ))
            continue;
          const g = Object.values(
            f.tokenPermissions
          ).find(
            (k) => k.type === Lt.BECOME_TOKEN_OWNER
          );
          if (g) {
            const h = g.tokenCriteria[0]?.contractAddresses, y = Object.keys(h)[0];
            if (!y || !o(this, Qn)[Number(y)])
              continue;
            const N = this.getEthereumClient(Number(y));
            if (!N || await N.resolveOwner(
              o(this, ct)[Number(y)].CommunityOwnerTokenRegistry,
              i
            ) !== m.signerPublicKey)
              continue;
          } else if (i !== `0x${Dt(m.signerPublicKey)}`)
            continue;
          return f;
        }
    });
    t(this, "fetchContactCodeAdvertisement", async (i) => {
      const e = It(`${i}-contact-code`), n = await wt(
        `${i}-contact-code`
      ), s = this.waku.store.queryGenerator([
        Hn(e, n, {
          clusterId: 16,
          shard: 32
        })
      ]);
      for await (const c of s)
        for await (const u of c) {
          if (!u)
            continue;
          const m = this.handleWakuMessage(u);
          if (!m || m.type !== I.CONTACT_CODE_ADVERTISEMENT)
            continue;
          const f = Yr.fromBinary(
            m.payload
          );
          if (f.chatIdentity && In(
            BigInt(f.chatIdentity.clock),
            m.timestamp
          ) && i === m.signerPublicKey)
            return f;
        }
    });
    t(this, "handleWakuMessage", (i) => {
      if (!i.payload || !i.signaturePublicKey || !i.timestamp)
        return;
      let e = i.payload;
      try {
        const m = xr.fromBinary(e);
        if (m) {
          const f = Yn(
            m.entireMessageHash
          ), g = o(this, vn).get(
            f
          );
          if (!g) {
            o(this, vn).set(
              f,
              /* @__PURE__ */ new Map([[m.index, m]])
            );
            return;
          }
          if (g.has(m.index) || (g.set(m.index, m), g.size !== m.segmentsCount))
            return;
          try {
            const k = [];
            g.forEach((y) => {
              k[y.index] = y.payload;
            }), e = Wr(...k), o(this, vn).delete(f);
          } catch {
            return;
          }
        }
      } catch {
      }
      let n;
      try {
        n = Bt.fromBinary(e), n.encryptedMessage.none ? e = n.encryptedMessage.none.payload : n && (e = n.publicMessage);
      } catch {
      }
      let s;
      try {
        s = et.fromBinary(e);
      } catch {
        return;
      }
      if (!s || !s.payload || !s.signature.length)
        return;
      const c = zr(
        s.signature,
        s.payload
      ), u = ii(
        n?.publicMessage ?? i.payload,
        c
      );
      if (!this.wakuMessages.has(u))
        return this.wakuMessages.add(u), {
          timestamp: i.timestamp,
          signerPublicKey: `0x${Yn(c)}`,
          type: s.type,
          payload: s.payload
        };
    });
    const { environment: n = "development" } = e;
    this.waku = i, this.wakuMessages = /* @__PURE__ */ new Set(), E(this, vn, /* @__PURE__ */ new Map()), E(this, zn, e.started ?? !1), E(this, Qn, e.ethProviderURLs ?? va[n].infura), E(this, lt, e.ethProviderApiKey), E(this, Fn, /* @__PURE__ */ new Map()), E(this, ct, e.contractAddresses ?? Da[n]);
  }
  static async start(i) {
    const { environment: e = "development" } = i;
    let n, s;
    try {
      n = await _a({
        defaultBootstrap: !1,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        emitSelf: !0,
        // pingKeepAlive: 0,
        // relayKeepAlive: 0,
        libp2p: {
          peerDiscovery: [
            qa({
              list: $a[e],
              timeout: 0
              // note: Infinity prevents connection
              // tagTTL: Infinity,
            })
          ]
        },
        shardInfo: {
          clusterId: 16,
          shards: [32]
        }
      }), await n.start(), await Va(n, [xn.Store], 10 * 1e3), s = new ia(n, {
        started: !0,
        ethProviderURLs: va[e].infura,
        ethProviderApiKey: i.ethProviderApiKey,
        contractAddresses: Da[e]
      });
    } catch (c) {
      throw n && await n.stop(), c;
    }
    return s;
  }
  async stop() {
    if (!o(this, zn))
      throw new Error("Waku instance not created by class initialization");
    await Promise.all([
      async () => this.waku.stop(),
      [...o(this, Fn).values()].map(
        async (i) => i.stop()
      )
    ]), E(this, zn, !1);
  }
};
vn = new WeakMap(), zn = new WeakMap(), Qn = new WeakMap(), lt = new WeakMap(), Fn = new WeakMap(), ct = new WeakMap();
let Mr = ia;
async function us(r) {
  return await Mr.start(r);
}
const ms = (r) => {
  const i = Object.entries($r);
  return r.reduce((e, n) => {
    const s = i.findIndex(([c]) => c === n);
    return s !== -1 && e.push(s), e;
  }, []);
};
export {
  Hi as EthereumClient,
  Gn as MessageContentType,
  Mr as RequestClient,
  ls as createClient,
  us as createRequestClient,
  ni as deserializePublicKey,
  cs as indicesToTags,
  $a as peers,
  ri as publicKeyToColorHash,
  Wi as publicKeyToEmojiHash,
  Vr as serializePublicKey,
  ms as tagsToIndices
};
//# sourceMappingURL=index.js.map
